export const translations = {
  de: {
    // Navigation
    nav: {
      home: "Home",
      about: "Über uns", 
      triax: "TRIAX®",
      services: "Services",
      signature: "Signature",
      sos: "SOS",
      insights: "Insights",
      contact: "Kontakt"
    },
    navDropdown: {
  services: {
    change: {
      title: "Change ohne Schablone",
      description: "Individuelles, systemisches Change Management jenseits von Standard-Blueprints."
    },
    bridges: {
      title: "Business zwischen Welten",
      description: "Interkulturelle Intelligenz für greifbare Zusammenarbeit über Kulturgrenzen hinweg."
    },
    scrum4sales: {
      title: "Scrum4Sales",
      description: "Agiler Vertrieb neu gedacht Sprints, Fokus, klare Abschlüsse."
    },
    leadership: {
      title: "Leadership Resonanz Atelier",
      description: "Coaching & Sparring für Führungskräfte und Expats in komplexen Systemen."
    }
  },
  signature: {
    foundation: {
      title: "Resonance Foundation",
      description: "Essentials für nachhaltiges Change Management."
    },
    accelerator: {
      title: "Resonance Accelerator",
      description: "Verbindung von Change und Leadership-Entwicklung."
    },
    transformation: {
      title: "Resonance Transformation",
      description: "Full RFF – Begleitung der gesamten Transformationsreise."
    },
    sos: {
      title: "Resonance SOS",
      description: "Schnelle, präzise Intervention in akuten Krisenmomenten."
    }
  },
  insights: {
    successStories: {
      title: "Erfolgsgeschichten",
      description: "Case Studies mit Zahlen, Wirkung und echten Learnings."
    },
    caseStudies: {
      title: "Case Studies",
      description: "Detaillierte Einblicke in Transformationsprojekte und Architektur."
    },
    blog: {
      title: "Blog",
      description: "Strategische Denkanstöße & Executive Reflections (geplant)."
    }
  }
},
    // Hero Slider - Revolutionary Content
    hero: {
      slide1: {
        headline: "Transformation    ist kein Projekt. Es ist eine Sprache.",
        subheadline: "Wir sprechen sie fließend, zwischen System &Mensch, Zwischen Strategie & Wirkung, Zwischen DACH & MENA Regionen.",
        claim: "Wo Strategie auf Menschlichkeit trifft und Projekte auf nachhaltige Wirkung.",
        cta: "Kostensloses Gespräch vereinbaren"
      },
      slide2: {
        headline: "Interkulturelle Intelligenz Wir bauen Brücken, wo andere an Grenzen stoßen .",
        subheadline: "Der stille Wettbewerbsvorteil.", 
        cta: "Mehr erfahren"
      },
      slide3: {
        headline: "TRIAX®     Unser exklusives System für ganzheitliche Transformation.",
        subheadline: "Ein wissenschaftlich fundierter Ansatz, der Struktur, Kultur und Mensch systematisch vereint – für Veränderungen, die funktionieren.",
        cta: "TRIAX® entdecken"
      },
      slide4: {
        headline: "Scrum4Sales     Vertrieb neu gedacht: kooperativ, adaptiv, erfolgreich .",
        subheadline: "Agilität, die verkauft.",
        cta: "Kostensloses Gespräch vereinbaren"
      }
    },
    // Welcome Section
    welcome: {
      title: "Willkommen bei GLOBRIDGE",
      subtitle: "Ihr Partner für systemische Transformation und interkulturelle Intelligenz. Wir verbinden Welten – kulturell, technologisch, menschlich.",
      card1: {
        title: "TRIAX® Modell",
        description: "Das Modell für interkulturelle Transformation in Europa: Zwischen System & Mensch, zwischen Strategie & Wirkung"
      },
      card2: {
        title: "Business zwischen Welten",
        description: "Erfolgreiche Zusammenarbeit über Kulturgrenzen hinweg. Interkulturelle Brücken zwischen DACH und MENA-Regionen"
      },
      card3: {
        title: "Premium Services & SOS Support",
        description: "Maßgeschneiderte Lösungen und sofortige Hilfe für nachhaltige Change-Prozesse und akute Transformationskrisen"
      },
      cta: "Executive Dialog beginnen"
    },
    // Silent Epidemic New Section
    silentEpidemicNew: {
      title: "Die stille Epidemie in deutschen Unternehmen",
      subtitle: "Während alle über Digitalisierung sprechen, versagen 70% aller Transformationsprojekte. Warum? Weil der Mensch vergessen wird.",
      stat1: "aller Change-Projekte scheitern, weil kulturelle und menschliche Faktoren ignoriert werden.",
      stat2: "werden jährlich in Deutschland durch gescheiterte Transformationen verschwendet.",
      stat3: "der Führungskräfte fühlen sich unvorbereitet auf internationale Geschäfte.",
      billion: "Mrd.",
      bottomTitle: "Das Problem liegt nicht in der Technik. Es liegt in der Umsetzung.",
      bottomDescription: "Zwischen Vision und Realität, zwischen Führung und Team, zwischen Kulturen und Märkten. Wir sind die Dolmetscher für diese unsichtbaren Sprachen."
    },
    // Silent Epidemic Section (Old - kept for compatibility)
    silentEpidemic: {
      badge: "Die stille Epidemie",
      title: "Wir leben in einem Moment, der alles beschleunigt und gleichzeitig lähmt.",
      description1: "Digitalisierung, künstliche Intelligenz, soziale Medien und globale Spannungen verändern nicht nur Märkte.",
      description1Highlight: "Sie verändern Menschen.",
      description2: "Teams brechen auseinander, Führung wird zum Kraftakt, Kulturen prallen aufeinander und hinter jedem Prozess steht ein Mensch, der entscheiden, führen, funktionieren soll.",
      description3: "Und doch spüren viele: Es braucht etwas das man nicht messen kann. Tieferes. Wahreres. Irgendetwas fehlt.",
      description4: "Kein Plan, Tool oder noch eine Strategie. Sondern das, was dazwischen liegt.",
      description5: "Zwischen dem, was möglich wäre – und dem, was Realität bleibt.",
      quote: "Das ist die Paradoxie des modernen Business: Je lauter die Technik wird, desto leiser die menschliche Genialität.",
      imageQuote: "GLOBRIDGE entfaltet Transformation wie ein exquisites Parfüm:",
      imageQuoteHighlight: "tief, präzise, langanhaltend.",
      imageSignature: "Resonanz ist unser Signature-Duft.",
      bottomTitle1: "Wir bauen keine Strategien.",
      bottomTitle2: "Wir bauen Resonanz.",
      bottomDescription: "Ein unsichtbares Dreiklangsystem aus Kultur, Mensch und Struktur – fein abgestimmt, mutig komponiert, spürbar in jeder Bewegung.",
      cta1: "Gespräch vereinbaren",
      cta2: "TRIAX entdecken"
    },
    
    // Expertise Section
    expertise: {
      title: "Wirkung in",
      titleHighlight: "Bewegung bringen",
      description: "Vier kraftvolle Säulen, die Transformation nicht nur versprechen – sondern messbar liefern. Systemisch gedacht, kulturell intelligent, menschlich wirksam.",
      subDescription: "Das ist nicht Standard-Consulting. Das ist Wirkung in ihrer intelligentesten Form.",
      services: [
        {
          id: 'change',
          iconName: 'Zap',
          title: 'Systemisches Change Management',
          subtitle: 'Transformation mit Tiefe',
          intro: 'Transformation ist mehr als Prozessoptimierung. Wir adressieren das gesamte System – Kultur, Struktur und Mensch als lebendigen Organismus.',
          description: 'Wandel, der nicht nur oberflächlich wirkt, sondern systemisch verankert wird.',
          whatWeDo: [
            'Kulturanalyse und Change-Readiness Assessment',
            'Entwicklung maßgeschneiderter Transformationsstrategien',
            'Stakeholder-Alignment und Widerstandsmanagement',
            'Implementierung nachhaltiger Veränderungsprozesse'
          ],
          features: [
            'Kultureller Wandel mit 40% höherer Akzeptanz',
            'Strukturelle Integration in bestehende Systeme',
            '85% Reduzierung von Change-Widerständen',
            'Nachhaltige Verankerung über 24+ Monate'
          ],
          whyImportant: 'Ohne systemische Verankerung scheitern 70% aller Change-Projekte innerhalb der ersten 6 Monate. Wir sorgen dafür, dass Transformation nicht nur startet, sondern dauerhaft wirkt.',
          background: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
          cta: 'Change Management entdecken',
          href: '/services#service-0',
          gradient: 'from-purple-600 to-blue-600'
        },
        {
          id: 'coaching',
          iconName: 'Users',
          title: 'Business Coaching',
          subtitle: 'Leadership Excellence',
          intro: 'Führung bedeutet heute mehr als Entscheidungskraft. Es geht um Resonanzfähigkeit, kulturelle Intelligenz und die Kunst, Menschen durch Komplexität zu navigieren.',
          description: 'Führungskräfte-Entwicklung auf höchstem Niveau für nachhaltige Ergebnisse.',
          whatWeDo: [
            '1:1 Executive Coaching für C-Level Führungskräfte',
            'Team-Coaching für High-Performance Teams',
            'Interkulturelle Führungskompetenz-Entwicklung',
            'Strategisches Leadership in Transformationsphasen'
          ],
          features: [
            'Executive Coaching mit 360° Feedback',
            'Team Development & Konfliktlösung',
            'Leadership Resonanz für authentische Führung',
            '35% Performance Boost in 6 Monaten'
          ],
          whyImportant: '85% der Führungskräfte fühlen sich auf globale und kulturelle Herausforderungen unvorbereitet. Wir schließen diese kritische Lücke durch praxisnahe, messbare Leadership-Entwicklung.',
          background: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
          cta: 'Coaching Program entdecken',
          href: '/services#service-1',
          gradient: 'from-emerald-500 to-teal-600'
        },
        {
          id: 'sales',
          iconName: 'Target',
          title: 'SCRUM for Sales',
          subtitle: 'Agile Vertriebsrevolution',
          intro: 'Vertrieb ist kein linearer Prozess mehr. Mit SCRUM for Sales bringen wir agile Prinzipien in den Vertrieb und machen Ihr Team schneller, adaptiver und erfolgreicher.',
          description: 'Vertriebsteams agil transformieren für messbar höhere Abschlussraten.',
          whatWeDo: [
            'Implementierung agiler Vertriebsprozesse (Sprints, Standups)',
            'Sales Performance Tracking mit KPI-Dashboards',
            'Team-Synchronisation und Kollaborationstools',
            'Adaptive Strategieanpassung basierend auf Marktfeedback'
          ],
          features: [
            'Agile Sales Methodik mit Sprint-Planning',
            'Team Synchronisation in Echtzeit',
            'Performance Tracking & Data-Driven Decisions',
            '25% Conversion Boost in 3 Monaten'
          ],
          whyImportant: 'Traditionelle Vertriebsmodelle sind zu starr für moderne Märkte. Agile Vertriebsteams reagieren 3x schneller auf Kundenbedürfnisse und erzielen nachweislich höhere Abschlussraten.',
          background: 'https://images.unsplash.com/photo-1629471361722-e1306b0c0e42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw1fHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85',
          cta: 'Scrum4Sales erleben',
          href: '/services#service-2',
          gradient: 'from-orange-500 to-red-500'
        },
        {
          id: 'intercultural',
          iconName: 'Star',
          title: 'Interkulturelle Business Intelligenz',
          subtitle: 'Global Expansion Excellence',
          intro: 'Globales Business scheitert selten an Strategien, sondern an kulturellen Missverständnissen. Wir übersetzen nicht nur Sprachen, sondern Geschäftskulturen.',
          description: 'Kulturelle Brücken bauen für erfolgreiches globales Business.',
          whatWeDo: [
            'Kulturelle Due Diligence für DACH-MENA Expansion',
            'Interkulturelle Kommunikationstrainings',
            'Market Entry Strategies mit lokalem Insider-Wissen',
            'Aufbau und Führung multikultureller Teams'
          ],
          features: [
            'MENA Expertise (Arabisch, Französisch, Deutsch)',
            'Cultural Intelligence Training für Führungskräfte',
            'Market Entry Strategy mit 90% Erfolgsquote',
            'Cross-Cultural Teams mit 60% höherer Performance'
          ],
          whyImportant: 'Kulturelle Missverständnisse kosten deutsche Unternehmen jährlich €2.3 Mrd. Wir vermeiden diese Verluste durch tiefes kulturelles Verständnis und praktische Übersetzungsarbeit.',
          background: 'https://images.unsplash.com/photo-1672664003230-106aa4f534c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85',
          cta: 'Global Intelligence entdecken',
          href: '/services#service-3',
          gradient: 'from-violet-500 to-purple-600'
        }
      ]
    },
    markets: {
      title: "Märkte &",
      description: "DACH · Mittlerer Osten · Nordafrika – wo kulturelle Kompetenz entscheidet."
    },
    // Triax Section
    triaxSection: {
      title: "Was und warum TRIAX®?",
      classical: "Klassische Beratung trennt Silos",
      classicalDesc: "Prozess ↔ Kultur ↔ Mensch getrennt.",
      triax: "TRIAX® integriert ganzheitlich", 
      triaxDesc: "Verhalten, Prozesse, Performance als ein System.",
      highlights: [
        "KPI-Steigerung durch Systemharmonisierung",
        "Frühwarnsystem für Widerstände",
        "Transparenz über Interdependenzen"
      ],
      cta: "Wir verkaufen keine Services. Wir liefern Transformationen."
    },
    // For Whom Section
    forWhom: {
      title: "Für führende und ambitionierte Unternehmen",
      subtitle: "Das ist keine gewöhnliche Website. Das ist ein strategisches Assessment Ihrer Bereitschaft.",
      intro: "Wenn 3+ der folgenden Punkte zutreffen, ist Ihr Unternehmen reif für eine Partnerschaft mit uns:",
      points: [
        "Sie implementieren modernste KI-Technologien, aber Ihre Meetings sind so leblos und unproduktiv wie nie zuvor.",
        "Expansion-Projekte liefern exzellente Finanzergebnisse, fühlen sich aber eher wie Übernahmen als wie Partnerschaften an.",
        "Sie sind zertifiziert in Agile-Methodologien – aber Ihre Organisationsstruktur funktioniert immer noch wie in den 80ern.",
        "Ihr Team spricht sechs verschiedene Sprachen – außer der des gegenseitigen Verständnisses.",
        "Sie lesen diesen Text mit erhöhtem Puls und wachsender Erkenntnis über Ihr Unternehmen."
      ],
      notFor: "Unternehmen, die wir nicht bedienen:",
      notForDesc: "Oberflächliche Quick-Fixes · Projekte nur für den Schein · Task-orientiertes statt Journey-orientiertes Denken · Mangel an Mut für unangenehme Wahrheiten.",
      whyDifferent: "Was uns anders macht:",
      whyDifferentDesc: "Deutsche Präzision × authentische östliche Weisheit · Tiefe × Pragmatismus · Die richtigen Fragen stellen statt Lösungen verkaufen · Trainer/strategischer Partner/kultureller Übersetzer."
    },
    journeyTimeline: {
  milestones: [
    {
      year: 'Ursprung',
      title: 'Zwischen Welten aufgewachsen',
      description:
        'Geboren zwischen Kulturen, aufgewachsen zwischen Kontinenten. DACH, MENA, Europa – nicht als Tourist, sondern als Teil mehrerer Welten.'
    },
    {
      year: 'Akademie',
      title: 'International Business & Interkulturelle Studien',
      description:
        'Akademischer Background in International Business, Interkulturellen Studien und systemischem Change Management. Theorie als Fundament, nicht als Dogma.'
    },
    {
      year: 'Zertifizierung',
      title: 'ISO-EN-17024 Change Management Consultant',
      description:
        'Internationale Zertifizierung als Change Management Consultant. Nicht weil wir Zertifikate sammeln, sondern weil Exzellenz Standards braucht.'
    },
    {
      year: 'Praxis',
      title: 'Project Delivery & Transformations-Begleitung',
      description:
        'Jahre in der Praxis: Project Delivery, Change-Projekte, internationale Teams. Vom Mittelstand bis zum Konzern. Von München bis Marokko.'
    },
    {
      year: 'Innovation',
      title: 'TRIAX® & Resonance Flow Framework',
      description:
        'Die Synthese: TRIAX® als systemisches Modell (Kultur–Mensch–Struktur) und das Resonance Flow Framework als skalierbare Methodik.'
    },
    {
      year: 'Heute',
      title: 'GLOBRIDGE – Boutique Consulting',
      description:
        'Kein Großkonzern, keine Massenware. Eine Boutique für Unternehmen, die tiefgreifende Transformation suchen – mit Resonanz, nicht nur mit Tools.'
    }
  ]
},
about: {
  hero: {
    badge: "Identität & Ursprung",
    titleLine1: "Zwischen Welten geboren.",
    titleHighlight: "Für Welten gebaut.",
    subtitle:
      "GLOBRIDGE wurde nicht gegründet, um klassische Beratung zu verkaufen. Sondern um eine Leerstelle zu füllen, die andere nicht einmal sehen.",
    quoteLine1: "Zwischen System & Mensch. Zwischen Strategie & Wirkung.",
    quoteLine2: "Zwischen Kulturen & Märkten.",
    imageAlt: "Professioneller Business-Kontext im internationalen Umfeld"
  },
  story: {
    titleBeforeHighlight: "Wer",
    titleHighlight: "wir sind",
    p1:
      "GLOBRIDGE ist keine Firma im klassischen Sinne. Es ist die Synthese einer persönlichen Reise – zwischen Kulturen aufgewachsen, akademisch geschult, praktisch bewährt.",
    p2:
      "Als Change Management Consultant mit ISO-EN-17024-Zertifizierung, akademischem Background in International Business und Interkulturellen Studien sowie praktischer Expertise als Project Delivery Manager habe ich eines früh gelernt:",
    quote:
      "Transformation scheitert nicht an Tools. Sie scheitert daran, dass der Mensch vergessen wird.",
    p3:
      "Zu oft habe ich gesehen, wie brillante Strategien an kultureller Ignoranz, innerem Widerstand oder fehlendem Zuhören zerbrachen. Also entstand GLOBRIDGE als Boutique für systemische Transformation mit Tiefgang – nicht mit Massenware.",
    closing:
      "Nicht, um Beratung neu zu erfinden. Sondern um den Raum zwischen System und Seele, zwischen Struktur und Menschlichkeit zu füllen.",
    floatingQuote:
      "Wirkung entsteht nicht durch Methoden. Sondern durch Resonanz."
  },
  credentials: {
    title: "Fundament &",
    highlight: "Credentials",
    subtitle:
      "Nicht weil wir Zertifikate sammeln, sondern weil Exzellenz Standards braucht",
    items: [
      {
        id: "iso",
        title: "ISO-EN-17024",
        subtitle: "Change Management Consultant",
        description:
          "Internationale Zertifizierung als Change Management Consultant."
      },
      {
        id: "academic",
        title: "Akademischer Background",
        subtitle: "International Business & Interkulturelle Studien",
        description:
          "Master-Level in International Business und interkultureller Kommunikation."
      },
      {
        id: "delivery",
        title: "Project Delivery Manager",
        subtitle: "Praktische Expertise",
        description:
          "Jahre in der Praxis: Change-Projekte vom Mittelstand bis zum Konzern."
      },
      {
        id: "dach-mena",
        title: "DACH-MENA Expertise",
        subtitle: "Arabisch · Französisch · Deutsch",
        description:
          "Trilinguale Kompetenz für grenzüberschreitende Transformation."
      }
    ]
  },
  journey: {
    title: "Die",
    highlight: "Reise",
    subtitle: "Von interkulturellen Wurzeln zur systemischen Transformation"
  },
  values: {
    title: "Unsere",
    highlight: "Philosophie",
    subtitle:
      "Werte, die uns leiten – nicht als Slogan, sondern als gelebte Praxis",
    items: [
      {
        id: "resonance",
        title: "Resonanz vor Perfektion",
        description:
          "Wir glauben nicht an perfekte Strategien. Wir glauben an menschliche Verbindung, die echten Wandel möglich macht."
      },
      {
        id: "systemic",
        title: "Systemisch & systemkritisch",
        description:
          "Wir denken in Systemen (TRIAX®), aber hinterfragen Dogmen. Methodik mit Demut und klarem Blick auf die Realität."
      },
      {
        id: "cultural",
        title: "Kulturelle Intelligenz",
        description:
          "Transformation scheitert selten an Tools, sondern an kulturellen Blindstellen. Wir übersetzen zwischen Welten."
      },
      {
        id: "boutique",
        title: "Boutique, kein Konzern",
        description:
          "Keine Massenware, keine Junior-Consultants. Persönliche Begleitung auf höchstem Niveau – fokussiert und selektiv."
      }
    ]
  },
  difference: {
    title: "Was uns",
    highlight: "anders macht",
    subtitle: "Ehrlichkeit statt Marketing-Speak",
    blocks: [
      {
        id: "not",
        title: "Wir sind keine klassische Beratung",
        points: [
          "Keine 200-seitigen PowerPoint-Decks, die niemand liest.",
          "Keine Junior-Consultants, die aus Lehrbüchern rezitieren.",
          "Keine One-Size-Fits-All Frameworks.",
          "Keine leeren Versprechungen."
        ]
      },
      {
        id: "offer",
        title: "Stattdessen bieten wir",
        points: [
          "Persönliche Sparring-Partner auf Augenhöhe.",
          "Systemisches Denken mit konsequenter Umsetzung.",
          "Kulturelle Intelligenz, nicht nur „Sensibilisierungstrainings“.",
          "Ehrlichkeit: Wir beraten und begleiten – Sie entscheiden."
        ]
      }
    ],
    promiseLead: "Das GLOBRIDGE-Versprechen:",
    promiseText:
      "Wir beraten und begleiten mit Tiefgang, Expertise und kultureller Intelligenz. Die Entscheidung liegt immer bei Ihnen. Keine leeren Versprechungen, nur ehrliche Sparring-Partner."
  },
  method: {
    title: "Unsere",
    highlight: "Methodik",
    subtitle:
      "TRIAX® & Resonance Flow Framework – die Synthese aus Theorie und Praxis",
    triax: {
      title: "TRIAX®",
      text:
        "Unser systemisches Modell für Transformation: Kultur · Mensch · Struktur als lebendiges System verstehen – nicht als isolierte Säulen.",
      linkLabel: "Mehr über TRIAX®"
    },
    rff: {
      title: "Resonance Flow Framework",
      text:
        "Unsere skalierbare Methodik: 5 Phasen von Diagnose bis Anchoring – fließend, adaptiv, messbar.",
      linkLabel: "Mehr über RFF"
    },
    reasonsTitle: "Warum diese Kombination?",
    reasons: [
      {
        id: "systemic",
        title: "Systemisch",
        text: "TRIAX® adressiert das gesamte System – nicht nur einzelne Silos."
      },
      {
        id: "scalable",
        title: "Skalierbar",
        text: "RFF macht den Prozess wiederholbar und anschlussfähig über Projekte hinweg."
      },
      {
        id: "measurable",
        title: "Messbar",
        text: "Klare Deliverables und KPIs pro Phase – statt vager Wirkungsversprechen."
      }
    ]
  },
  cta: {
    titleBeforeHighlight: "Bereit für",
    highlight: "echte Transformation",
    text:
      "Lassen Sie uns im Executive Dialog herausfinden, ob wir zueinander passen. Keine Verkaufsgespräche, nur ehrlicher Austausch.",
    button: "Executive Dialog beginnen"
  }
},
servicesPage: {
  hero: {
    titleLine1: "Resonance Flow Framework",
    titleHighlight: "Unsere Arbeitsweise",
    subtitle:
      "Transformation als fließender Resonanz-Strom – tief wirksam, langanhaltend, subtil anpassbar. Wir beraten und begleiten. Die Entscheidung liegt bei Ihnen.",
    badge: "Interdisziplinär · Skalierbar · Wiederholbar"
  },
  rff: {
    titleBeforeHighlight: "Die 5 Kernphasen des",
    highlight: "Resonance Flow",
    subtitle:
      "Ein Flow-Modell mit kontinuierlichen Feedback-Loops – anpassbar an Ihre Bedürfnisse"
  },
  servicesSection: {
    titleBeforeHighlight: "Unsere",
    highlight: "Services im Detail",
    subtitle:
      "Klicken Sie auf einen Service für detaillierte Informationen"
  },
  serviceDetails: {
    approachTitle: "Unsere Vorgehensweise",
    whyUsLabel: "Warum wir:",
    faqTitle: "Häufige Fragen",
    phaseLabel: "Phase"
  },
  cta: {
    titleBeforeHighlight: "Bereit für",
    highlight: "echte Transformation",
    text:
      "Wir beraten und begleiten Sie – ohne leere Versprechen, aber mit bewährten Methoden und tiefem Verständnis. Die Entscheidung liegt allein bei Ihnen.",
    button: "Executive Dialog beginnen"
  },
  services: [
    {
      id: "change-management",
      title: "Systemisches Change Management",
      subtitle: "Resonance Flow Framework in der Praxis",
      intro:
        "Als Change Management Consultant mit ISO-EN-17024-Zertifizierung, akademischem Background und praktischer Expertise begleiten wir Ihr Unternehmen durch systemische Transformation.",
      description:
        "Transformation ist mehr als Prozessoptimierung. Wir adressieren das gesamte System – Kultur, Struktur und Mensch als lebendigen Organismus. Unser Resonance Flow Framework (RFF) verbindet TRIAX® mit indirektem Scrum/Agile, Cross-Cultural Business und personalisierten Coaching-Ansätzen.",
      approach: [
        {
          phase: "Auftragsklärung & Resonanz-Diagnose",
          description:
            "Wir klären den Change-Bedarf und diagnostizieren systemische Blockaden. Durch Design Thinking und TRIAX®-basierte Analysen schaffen wir Klarheit.",
          deliverables: [
            "Resonanz-Scan (Kultur, Mensch, Struktur)",
            "Stakeholder-Interviews",
            "Change-Readiness Assessment",
            "Cross-Culture Analyse (Hofstede-basiert)"
          ]
        },
        {
          phase: "Roadmap-Entwicklung & Coalition-Building",
          description:
            "Wir entwickeln eine anpassbare Roadmap und bauen eine Resonanz-Koalition aus C-Level und Key-Playern.",
          deliverables: [
            "Agile Change-Backlog",
            "TRIAX®-integrierte Roadmap",
            "Stakeholder-Alignment Workshops",
            "Widerstands-Management Plan"
          ]
        },
        {
          phase: "Umsetzung & Agile Iteration",
          description:
            "In Flow-Sprints setzen wir Change-Aktionen um – iterativ, mit Fokus auf Wirkung statt Perfektion.",
          deliverables: [
            "2-Wochen-Sprints mit Reviews",
            "Coaching-Sessions für Führungskräfte",
            "Team-Resilience Training",
            "Kontinuierliches Risiko-Monitoring"
          ]
        },
        {
          phase: "Feedback & Adjustment Loops",
          description:
            "Durch Agile Retros und Pulse-Surveys sammeln wir Feedback und justieren iterativ.",
          deliverables: [
            "Wöchentliche Check-ins",
            "Anonyme Feedback-Tools",
            "Sentiment-Analyse",
            "Anpassungs-Pläne"
          ]
        },
        {
          phase: "Anchoring & Follow-up",
          description:
            "Wir verankern den Wandel langfristig durch monatliche Follow-ups und kontinuierliche Verbesserung.",
          deliverables: [
            "Monatliche Coaching-Calls",
            "KPI-Monitoring",
            "Resilience Training",
            "Legacy-Dokumentation"
          ]
        }
      ],
      whyUs:
        "Ohne systemische Verankerung scheitern 70% aller Change-Projekte. Wir beraten und begleiten Sie durch alle Phasen – die Entscheidung liegt allein bei Ihnen.",
      faq: [
        {
          q: "Was unterscheidet RFF von Kotter oder klassischem Change?",
          a: "RFF ist fließend statt linear. Wir integrieren TRIAX®, Agile und Cross-Culture nahtlos und passen uns Ihrem Tempo an."
        },
        {
          q: "Für welche Unternehmensgröße ist RFF geeignet?",
          a: "Von 10 bis 1000+ Mitarbeitenden. Die Methodik skaliert durch modulare Anpassungen."
        }
      ]
    },
    {
      id: "business-coaching",
      title: "Business Coaching & Leadership Development",
      subtitle: "Resonanzfähigkeit für C-Level Executives",
      intro:
        "Führung bedeutet heute mehr als Entscheidungskraft. Es geht um Resonanzfähigkeit, kulturelle Intelligenz und die Kunst, Menschen durch Komplexität zu navigieren.",
      description:
        "Wir begleiten Führungskräfte in ihrer Entwicklung – von Executive Coaching bis Team-Development. Unsere Methodik verbindet systemisches Coaching mit interkulturellen Kompetenzen und agilen Führungsprinzipien.",
      approach: [
        {
          phase: "1:1 Executive Coaching",
          description:
            "Individuelle Begleitung für C-Level Führungskräfte mit Fokus auf authentisches Leadership und strategische Entscheidungsfindung.",
          deliverables: [
            "360° Feedback-Analyse",
            "Persönliche Entwicklungspläne",
            "Quarterly Deep-Dive Sessions",
            "Resilience & Stress-Management"
          ]
        },
        {
          phase: "Team-Coaching für High-Performance",
          description:
            "Wir begleiten Teams in Konfliktlösung, Kommunikation und kollaborativer Zusammenarbeit.",
          deliverables: [
            "Team-Diagnostik",
            "Konflikt-Moderation",
            "Vertrauensbildende Maßnahmen",
            "Agile Team-Rituale"
          ]
        },
        {
          phase: "Interkulturelle Führungskompetenz",
          description:
            "Speziell für DACH–MENA oder internationale Teams: Kulturelle Intelligenz entwickeln und praktisch anwenden.",
          deliverables: [
            "Hofstede-basierte Analysen",
            "Cross-Culture Workshops",
            "Praktische Verhaltenstipps",
            "Kommunikations-Playbooks"
          ]
        },
        {
          phase: "Leadership in Transformationsphasen",
          description:
            "Begleitung durch Change-Prozesse mit Fokus auf Widerstandsmanagement und Stakeholder-Engagement.",
          deliverables: [
            "Change-Leadership Workshops",
            "Strategische Sparring-Partner",
            "Resilienz-Aufbau",
            "Continuous Coaching"
          ]
        }
      ],
      whyUs:
        "85% der Führungskräfte fühlen sich auf globale Herausforderungen unvorbereitet. Wir beraten und begleiten – die Entscheidung liegt bei Ihnen.",
      faq: [
        {
          q: "Was ist \"Resonanz-Leadership\"?",
          a: "Authentische Führung, die emotional und kulturell anschlussfähig ist – keine Manipulation, sondern echte Verbindung."
        },
        {
          q: "Wie lange dauert ein Coaching-Programm?",
          a: "Individuell – von 3-Monats-Sprints bis zu Jahresprogrammen. Sie bestimmen das Tempo."
        }
      ]
    },
    {
      id: "scrum-for-sales",
      title: "SCRUM for Sales",
      subtitle: "Agile Vertriebsrevolution",
      intro:
        "Vertrieb ist kein linearer Prozess mehr. Mit SCRUM for Sales bringen wir agile Prinzipien in den Vertrieb und machen Ihr Team schneller, adaptiver und erfolgreicher.",
      description:
        "Wir übersetzen Scrum-Prinzipien (Sprints, Reviews, Retros) auf Vertriebsprozesse. Das Ergebnis: Teams, die 3x schneller auf Kundenbedürfnisse reagieren und messbar höhere Abschlussraten erzielen.",
      approach: [
        {
          phase: "Sales-Team Assessment",
          description:
            "Wir analysieren Ihre aktuellen Vertriebsprozesse und identifizieren Optimierungspotenziale.",
          deliverables: [
            "Sales-Process Mapping",
            "Bottleneck-Analyse",
            "Team-Performance Review",
            "Agile Readiness Check"
          ]
        },
        {
          phase: "Agile Vertriebsprozesse implementieren",
          description:
            "Sprint-Planning, Daily Standups und Sprint-Reviews für Vertriebsteams – praxisnah und sofort umsetzbar.",
          deliverables: [
            "Sprint-Setup (2-Wochen-Zyklen)",
            "KPI-Dashboards",
            "Team-Synchronisation Tools",
            "Agile Sales-Playbook"
          ]
        },
        {
          phase: "Performance Tracking & Iteration",
          description:
            "Data-driven Entscheidungen durch kontinuierliches Monitoring und Anpassung.",
          deliverables: [
            "Real-time Performance Dashboards",
            "Conversion-Tracking",
            "Sprint Retros",
            "Adaptive Strategie-Anpassung"
          ]
        },
        {
          phase: "Team-Coaching & Enablement",
          description:
            "Wir befähigen Ihr Team, agil und eigenverantwortlich zu arbeiten.",
          deliverables: [
            "Agile Sales Trainings",
            "Coaching für Sales Leader",
            "Peer-Learning Sessions",
            "Best Practice Sharing"
          ]
        }
      ],
      whyUs:
        "Traditionelle Vertriebsmodelle sind zu starr. Wir beraten und begleiten – ohne leere Versprechen, aber mit bewährten Methoden.",
      faq: [
        {
          q: "Funktioniert Scrum wirklich im Vertrieb?",
          a: "Ja – indirekt angepasst. Nicht dogmatisch, sondern pragmatisch auf Vertriebsrealität übersetzt."
        },
        {
          q: "Welche KPIs werden getrackt?",
          a: "Conversion Rates, Sales Cycle Length, Team-Engagement, Pipeline-Velocity – individuell angepasst."
        }
      ]
    },
    {
      id: "intercultural-intelligence",
      title: "Interkulturelle Business Intelligenz",
      subtitle: "DACH–MENA Expertise & Global Expansion",
      intro:
        "Globales Business scheitert selten an Strategien, sondern an kulturellen Missverständnissen. Wir übersetzen nicht nur Sprachen, sondern Geschäftskulturen.",
      description:
        "Mit Expertise in DACH und MENA-Regionen begleiten wir Unternehmen bei internationaler Expansion. Unsere Methodik verbindet Hofstede-Insights mit praktischen Playbooks und lokalem Insider-Wissen.",
      approach: [
        {
          phase: "Kulturelle Due Diligence",
          description:
            "Vor Markteintritt analysieren wir kulturelle Stolpersteine und Erfolgsfaktoren.",
          deliverables: [
            "Hofstede-Analysen",
            "Local Business Culture Reports",
            "Risiko-Assessments",
            "Stakeholder-Mapping"
          ]
        },
        {
          phase: "Interkulturelle Kommunikationstrainings",
          description:
            "Workshops für Teams, die über Kulturgrenzen hinweg arbeiten – praxisnah und sofort anwendbar.",
          deliverables: [
            "Cross-Culture Workshops",
            "Verhaltens-Playbooks",
            "Kommunikations-Do's & Don'ts",
            "Rollenspiele & Simulationen"
          ]
        },
        {
          phase: "Market Entry Strategies",
          description:
            "Wir entwickeln kulturell angepasste Go-to-Market Strategien mit lokalem Wissen.",
          deliverables: [
            "Market Entry Playbooks",
            "Partner-Scouting",
            "Negotiation Strategies",
            "Lokale Netzwerk-Vermittlung"
          ]
        },
        {
          phase: "Multikulturelle Teams aufbauen",
          description:
            "Begleitung beim Aufbau und der Führung von Teams mit diversen kulturellen Hintergründen.",
          deliverables: [
            "Team-Composition Beratung",
            "Onboarding-Programme",
            "Konflikt-Prävention",
            "Cultural Leadership Training"
          ]
        }
      ],
      whyUs:
        "Kulturelle Missverständnisse kosten deutsche Unternehmen jedes Jahr Millionen. Wir beraten und begleiten mit tiefem Verständnis – die Entscheidung liegt bei Ihnen.",
      faq: [
        {
          q: "Welche Regionen decken Sie ab?",
          a: "Primär DACH und MENA (Arabisch, Französisch, Deutsch). Weitere Regionen auf Anfrage."
        },
        {
          q: "Was ist der Unterschied zu klassischem Diversity Training?",
          a: "Wir fokussieren auf Business-Impact, nicht nur Sensibilisierung. Praktisch, messbar, umsetzbar."
        }
      ]
    }
  ]
},

signaturePage: {
  hero: {
    badge: "Premium Signature Programs",
    titleLine1: "Signature Programs",
    titleHighlight: "Transformation als Signature",
    subtitle:
      "Strukturierte Programme basierend auf unserem Resonance Flow Framework. Skalierbar, messbar, profitabel – für Sie und uns."
  },
  tierLabels: {
    small: "< 50 Mitarbeiter",
    medium: "50-250 Mitarbeiter",
    large: "250-1000 Mitarbeiter",
    enterprise: "1000+ Mitarbeiter"
  },
  signaturesSection: {
    titleBeforeHighlight: "Unsere",
    highlight: "Signature Programs",
    subtitle:
      "Strukturierte, bewährte Programme – individuell anpassbar"
  },
  programDetails: {
    programFlowTitle: "Programm-Ablauf",
    deliverableLabel: "DELIVERABLE:",
    includedTitle: "Enthaltene Leistungen",
    resultsTitle: "Erwartete Ergebnisse",
    investmentTitle: "Investment",
    investmentSubtitle: "Individuell auf Ihre Unternehmenssituation angepasst",
    requestButton: "Auf Anfrage",
    requestNote:
      "Erhalten Sie ein individuelles Angebot basierend auf Ihrer spezifischen Situation",
  },
  individualSection: {
    titleBeforeHighlight: "Services",
    highlight: "À la Carte",
    subtitle:
      "Individuelle Services ohne Signature-Programm – flexibel buchbar",
    whyNoPublicPricesTitle: "Warum keine öffentlichen Preise?",
    whyNoPublicPricesText:
      "Als Premium-Beratung passen wir jedes Engagement individuell an Ihre spezifische Situation, Unternehmensgröße und Ziele an. Unsere Investitionen orientieren sich an Ihrem tatsächlichen Bedarf und dem erwarteten ROI. Kontaktieren Sie uns für ein unverbindliches Erstgespräch und ein maßgeschneidertes Angebot."
  },
  whySection: {
    titleBeforeHighlight: "Warum",
    highlight: "Signature Programs",
    cards: [
      {
        title: "Bewährt & Strukturiert",
        text: "Klar definierte Phasen, messbare Deliverables, transparente Prozesse."
      },
      {
        title: "ROI-optimiert",
        text: "Investments, die sich auszahlen: häufig 3–5x ROI in 18 Monaten."
      },
      {
        title: "Individuell anpassbar",
        text: "Trotz klarer Struktur: Jedes Programm wird auf Ihre Organisation zugeschnitten."
      }
    ]
  },
  cta: {
    titleBeforeHighlight: "Bereit für Ihre",
    highlight: "Signature Transformation",
    text:
      "Lassen Sie uns im Executive Dialog herausfinden, welches Programm am besten zu Ihnen passt.",
    button: "Unverbindliches Erstgespräch",
    dialogProgramLabel: "Unverbindliches Erstgespräch"
  },
  signatures: [
    {
      id: "resonance-foundation",
      tier: "Einstieg",
      title: "Resonance Foundation",
      subtitle: "Change Management Essentials",
      duration: "3 Monate",
      description:
        "Der ideale Einstieg in systemische Transformation. Wir legen das Fundament für nachhaltigen Change.",
      forWhom: {
        title: "Für wen?",
        targets: [
          "Unternehmen vor ihrer ersten großen Transformation",
          "Teams mit moderatem Change-Bedarf",
          "Organisationen, die Change-Readiness aufbauen wollen",
          "KMUs, die professionelle Begleitung suchen"
        ]
      },
      setup: {
        phase1: {
          title: "Monat 1: Diagnose & Roadmap",
          activities: [
            "Resonanz-Scan (TRIAX®-basiert)",
            "Stakeholder-Interviews",
            "Change-Readiness Assessment",
            "Roadmap-Entwicklung"
          ],
          deliverable: "Change-Roadmap & Quick-Win Plan"
        },
        phase2: {
          title: "Monat 2: Implementierung",
          activities: [
            "2 Flow-Sprints à 2 Wochen",
            "Stakeholder-Alignment Workshops",
            "Widerstandsmanagement",
            "Team-Coaching (2 Sessions)"
          ],
          deliverable: "Erste messbare Erfolge"
        },
        phase3: {
          title: "Monat 3: Anchoring",
          activities: [
            "Feedback Loops",
            "Anpassungsplan",
            "Follow-up Coaching",
            "Dokumentation & Playbook"
          ],
          deliverable: "Legacy-Box & Abschluss-Report"
        }
      },
      included: [
        "TRIAX® Resonanz-Diagnose",
        "6 Coaching-Sessions (á 90 Min)",
        "4 Flow-Sprints mit Reviews",
        "Stakeholder-Alignment Workshops",
        "Change-Roadmap & Playbook",
        "Monatliche Follow-ups (3 Monate)",
        "E-Mail/Telefon-Support"
      ],
      results: [
        "Klare Transformation-Roadmap",
        "Stakeholder Buy-in erreicht",
        "Erste Quick-Wins realisiert",
        "Change-Readiness aufgebaut"
      ],
      pricing: {
        small: { base: 18500, region: { dach: 18500, mena: 16500, intl: 21000 } },
        medium: { base: 32000, region: { dach: 32000, mena: 28500, intl: 36500 } },
        large: { base: 52000, region: { dach: 52000, mena: 46500, intl: 59000 } },
        enterprise: { base: 85000, region: { dach: 85000, mena: 76000, intl: 96500 } }
      }
    },
    {
      id: "resonance-accelerator",
      tier: "Professionell",
      title: "Resonance Accelerator",
      subtitle: "Change + Leadership Development",
      duration: "6 Monate",
      description:
        "Die komplette Transformation mit Leadership-Development. Für Unternehmen, die Tiefgang und Geschwindigkeit verbinden wollen.",
      forWhom: {
        title: "Für wen?",
        targets: [
          "Unternehmen in aktiver Transformationsphase",
          "Organisationen mit Leadership-Gap",
          "Internationale Teams (DACH-MENA)",
          "Mittlere bis große Unternehmen mit Skalierungsbedarf"
        ]
      },
      setup: {
        phase1: {
          title: "Monat 1-2: Foundation & Coalition",
          activities: [
            "Umfassende TRIAX® Diagnose",
            "Leadership Assessment (360°)",
            "Coalition-Building Workshops",
            "Change-Architektur Design",
            "Executive Coaching (2x/Monat)"
          ],
          deliverable: "Transformation-Architektur & Leadership-Plan"
        },
        phase2: {
          title: "Monat 3-4: Activation & Iteration",
          activities: [
            "6 Flow-Sprints",
            "Leadership Development Program",
            "Team-Coaching (wöchentlich)",
            "Widerstandsmanagement",
            "Cross-Culture Workshops (falls MENA)"
          ],
          deliverable: "Messbare KPI-Verbesserungen"
        },
        phase3: {
          title: "Monat 5-6: Harmonization & Anchoring",
          activities: [
            "Feedback Loops & Adjustments",
            "Leadership Resonanz Atelier",
            "Capability Building",
            "Follow-up & Sustainment"
          ],
          deliverable: "Nachhaltige Verankerung & Legacy"
        }
      },
      included: [
        "Alles aus Foundation PLUS:",
        "Leadership Assessment (360°)",
        "12 Executive Coaching-Sessions",
        "6 Team-Coaching Sessions",
        "8 Flow-Sprints mit Retros",
        "Leadership Development Program",
        "Cross-Culture Workshops (optional)",
        "Bi-Weekly Check-ins",
        "Priority E-Mail/Telefon-Support",
        "3 Monate Post-Program Follow-up"
      ],
      results: [
        "Leadership-Effektivität +60%",
        "Team-Engagement +50%",
        "Change-Widerstand -70%",
        "Transformation nachhaltig verankert"
      ],
      pricing: {
        small: { base: 42000, region: { dach: 42000, mena: 37500, intl: 47500 } },
        medium: { base: 68000, region: { dach: 68000, mena: 61000, intl: 77000 } },
        large: { base: 115000, region: { dach: 115000, mena: 103000, intl: 130000 } },
        enterprise: { base: 185000, region: { dach: 185000, mena: 166000, intl: 210000 } }
      }
    },
    {
      id: "resonance-transformation",
      tier: "Elite",
      title: "Resonance Transformation",
      subtitle: "Full RFF - Komplettbegleitung",
      duration: "12 Monate",
      description:
        "Die Elite-Transformation. Full Resonance Flow Framework mit allen Services, maßgeschneidert für komplexe, internationale Transformationen.",
      forWhom: {
        title: "Für wen?",
        targets: [
          "Große Unternehmen mit komplexen Transformationen",
          "Internationale Expansion (DACH-MENA)",
          "Organisationen mit multiplen Change-Projekten",
          "C-Level, die umfassende Sparring-Partner suchen"
        ]
      },
      setup: {
        phase1: {
          title: "Q1: Diagnose, Coalition & Strategie",
          activities: [
            "Tiefgehende TRIAX® Systemanalyse",
            "Leadership Assessment & Development Plan",
            "Coalition-Building (C-Level + Key Players)",
            "Full Change-Architektur mit SCRUM4Sales Integration",
            "Cross-Culture Due Diligence (MENA)",
            "Executive Coaching (wöchentlich)"
          ],
          deliverable: "Transformation-Blueprint & Leadership-Roadmap"
        },
        phase2: {
          title: "Q2-Q3: Activation & Agile Iteration",
          activities: [
            "12 Flow-Sprints",
            "Leadership Resonanz Atelier (monatlich)",
            "Team-Coaching & Konfliktmoderation",
            "SCRUM4Sales Implementation",
            "Interkulturelle Trainings",
            "Continuous Feedback & Adjustment"
          ],
          deliverable: "Messbare Business-Impact & KPIs"
        },
        phase3: {
          title: "Q4: Harmonization, Scaling & Legacy",
          activities: [
            "Skalierung auf weitere Teams/Regionen",
            "Capability Building & Train-the-Trainer",
            "Performance Optimization",
            "Legacy Documentation & Playbooks",
            "Transition zu Internal Ownership"
          ],
          deliverable: "Selbsttragende Transformation & Dokumentation"
        }
      },
      included: [
        "Alles aus Accelerator PLUS:",
        "Dedizierter Strategic Partner (Full Year)",
        "24 Executive Coaching-Sessions",
        "12 Team-Coaching Sessions",
        "12 Flow-Sprints mit Full Retros",
        "SCRUM4Sales Full Implementation",
        "Interkulturelle Business Intelligence (DACH-MENA)",
        "Leadership Resonanz Atelier (12 Sessions)",
        "Train-the-Trainer Program",
        "On-Demand Support (24/48h Response)",
        "6 Monate Post-Program Follow-up",
        "Annual Strategic Review"
      ],
      results: [
        "Transformation erfolgreich verankert",
        "Leadership-Capacity +80%",
        "Internationale Expansion erfolgreich",
        "ROI: 3-5x Investment in 18 Monaten"
      ],
      pricing: {
        small: { base: 95000, region: { dach: 95000, mena: 85000, intl: 108000 } },
        medium: { base: 145000, region: { dach: 145000, mena: 130000, intl: 165000 } },
        large: { base: 240000, region: { dach: 240000, mena: 215000, intl: 272000 } },
        enterprise: { base: 380000, region: { dach: 380000, mena: 342000, intl: 432000 } }
      }
    },
    {
      id: "resonance-sos",
      tier: "Krisenintervention",
      title: "Resonance SOS",
      subtitle: "Schnelle Intervention bei akuten Krisen",
      duration: "4-8 Wochen",
      description:
        "Wenn es brennt. Schnelle, fokussierte Intervention für akute Transformationskrisen, Team-Konflikte oder Change-Blockaden.",
      forWhom: {
        title: "Für wen?",
        targets: [
          "Unternehmen in akuter Change-Krise",
          "Teams mit eskalierenden Konflikten",
          "Gescheiterte Transformation-Projekte",
          "Dringende Leadership-Interventionen"
        ]
      },
      setup: {
        phase1: {
          title: "Woche 1-2: Diagnose & Krisenplan",
          activities: [
            "48h-Schnell-Diagnose",
            "Krisenanalyse (Stakeholder, Konflikte)",
            "Sofort-Maßnahmen Plan",
            "Intensiv-Coaching (täglich verfügbar)"
          ],
          deliverable: "Krisenplan & Quick-Wins"
        },
        phase2: {
          title: "Woche 3-6: Intervention & Stabilisierung",
          activities: [
            "Intensive Flow-Sprints (wöchentlich)",
            "Konfliktmoderation",
            "Leadership-Sparring (3x/Woche)",
            "Team-Coaching & Vertrauensaufbau",
            "Kommunikations-Strategie"
          ],
          deliverable: "Stabilisierung & Momentum"
        },
        phase3: {
          title: "Woche 7-8: Transition & Handover",
          activities: [
            "Stabilisierungs-Plan",
            "Übergabe an internes Team",
            "Follow-up Coaching",
            "Dokumentation & Lessons Learned"
          ],
          deliverable: "Übergabe & Follow-up Plan"
        }
      },
      included: [
        "48h Response Time",
        "Intensive Diagnose (2 Tage vor Ort)",
        "Daily Availability (Phone/Video)",
        "10 Coaching-Sessions (wöchentlich)",
        "4 Konfliktmoderationen",
        "Krisen-Kommunikations-Support",
        "Prioritized Access (24h)",
        "4 Wochen Post-SOS Follow-up"
      ],
      results: [
        "Krise stabilisiert in 2-4 Wochen",
        "Konflikte deeskaliert",
        "Transformation wieder auf Kurs",
        "Leadership handlungsfähig"
      ],
      pricing: {
        small: { base: 28000, region: { dach: 28000, mena: 25000, intl: 32000 } },
        medium: { base: 45000, region: { dach: 45000, mena: 40500, intl: 51000 } },
        large: { base: 68000, region: { dach: 68000, mena: 61000, intl: 77000 } },
        enterprise: { base: 95000, region: { dach: 95000, mena: 85500, intl: 108000 } }
      }
    }
  ],
  individualServices: [
    {
      service: "Systemisches Change Management",
      description: "RFF Flow komplett (Diagnose bis Anchoring)",
      duration: "3-6 Monate",
      pricing: {
        small: { base: 22000 },
        medium: { base: 38000 },
        large: { base: 62000 },
        enterprise: { base: 98000 }
      }
    },
    {
      service: "Executive Coaching",
      description: "1:1 Leadership Development",
      duration: "Pro 6-Sitzungen-Paket",
      pricing: {
        small: { base: 6500 },
        medium: { base: 6500 },
        large: { base: 8500 },
        enterprise: { base: 11500 }
      }
    },
    {
      service: "SCRUM for Sales Implementation",
      description: "Agile Vertriebsprozesse aufsetzen",
      duration: "2-4 Monate",
      pricing: {
        small: { base: 18000 },
        medium: { base: 28000 },
        large: { base: 45000 },
        enterprise: { base: 72000 }
      }
    },
    {
      service: "Interkulturelle Business Intelligence",
      description: "DACH-MENA Expansion & Cross-Culture Training",
      duration: "1-3 Monate",
      pricing: {
        small: { base: 15000 },
        medium: { base: 24000 },
        large: { base: 38000 },
        enterprise: { base: 58000 }
      }
    },
    {
      service: "Team-Coaching",
      description: "High-Performance Teams entwickeln",
      duration: "Pro 4-Session-Paket",
      pricing: {
        small: { base: 5500 },
        medium: { base: 7500 },
        large: { base: 9500 },
        enterprise: { base: 12500 }
      }
    },
    {
      service: "Workshop/Training (Tagessatz)",
      description: "Individuelle Workshops vor Ort oder remote",
      duration: "Pro Tag",
      pricing: {
        small: { base: 2500 },
        medium: { base: 2500 },
        large: { base: 3500 },
        enterprise: { base: 4500 }
      }
    }
  ]
},

triaxPage: {
  hero: {
    titleBeforeHighlight: "Was ist",
    highlight: "TRIAX®",
    subtitle:
      "Unser systemischer Ansatz für nachhaltige Transformation verbindet drei fundamentale Dimensionen – Struktur, Kultur und Mensch – zu einem ganzheitlichen Modell."
  },

  why: {
    classical: {
      title: "Klassische Ansätze",
      text:
        "Die meisten Transformationsansätze konzentrieren sich auf einzelne Aspekte – entweder auf Struktur, Technologie oder Menschen. TRIAX® wurde entwickelt, um genau diese Lücke zu schließen.",
      bullets: {
        change: "Change Manager",
        changeText: "fokussieren auf Prozesse",
        coaches: "Coaches",
        coachesText: "arbeiten an Menschen",
        culture: "Kulturberater",
        cultureText: "fokussieren auf Werte"
      },
      footer: "→ Alle getrennt voneinander"
    },
    triax: {
      title: "TRIAX® Ansatz",
      text:
        "TRIAX® macht sichtbar, wie Entscheidungen in einer Dimension die anderen beeinflussen. Das macht Transformation proaktiv und steuerbar – statt reaktiv.",
      hint:
        "💡 Veränderung in einer Achse beeinflusst automatisch die anderen beiden."
    }
    ,
  },

  advantage: {
    title: "Ihr Vorteil als Führungsteam",
    cards: [
      {
        title: "Gemeinsames Referenzmodell",
        text: "Eine präzise Sprache für Komplexität."
      },
      {
        title: "Systemische Adressierung",
        text: "Konflikte, Risiken und Potenziale strukturiert angehen."
      },
      {
        title: "Nachhaltige Wirkung",
        text: "Langfristige, messbare Ergebnisse statt Strohfeuer."
      }
    ]
  },

  how: {
    titleBeforeHighlight: "Wie",
    highlight: "TRIAX®",
    titleAfterHighlight: "funktioniert",
    subtitle:
      "Drei Dimensionen – Struktur, Kultur und Mensch – bilden ein verbundenes System. Wird eine Achse bewegt, reagieren die anderen mit. TRIAX® macht diese Wechselwirkungen sichtbar.",
    examplesTitle: "Beispiele:",
    axisPromptTitle: "Klicken Sie auf eine Achse",
    axisPromptText:
      "Entdecken Sie, wie die drei Dimensionen zusammenwirken.",
    bottomNote:
      "Das Besondere am TRIAX®-Modell ist die systemische Betrachtung: Alle drei Dimensionen beeinflussen sich gegenseitig. Wird eine verändert, verschiebt sich das gesamte System."
  },

  axes: [
    {
      id: "struktur",
      label: "Was?",
      shortTitle: "Struktur",
      title: "Struktur-Achse",
      subtitle: "Prozesse, Methoden & Systeme",
      description:
        "Strukturen schaffen den Rahmen für effektive Zusammenarbeit. Moderne Organisationen brauchen agile Prozesse, klare Methoden und unterstützende Systeme.",
      examples: [
        "Agile Organisationsstrukturen",
        "Effiziente Prozessgestaltung",
        "Systematisches Projektmanagement",
        "Digitale Transformation"
      ]
    },
    {
      id: "kultur",
      label: "Wie?",
      shortTitle: "Kultur",
      title: "Kultur-Achse",
      subtitle: "Werte, Rituale, informelle Regeln",
      description:
        "Kultur ist das unsichtbare Betriebssystem einer Organisation. Sie entscheidet, wie entschieden, kommuniziert und gelernt wird.",
      examples: [
        "Gemeinsame Prinzipien & Entscheidungsrituale",
        "Psychologische Sicherheit & Feedback-Rhythmen",
        "Kulturdiagnostik & Heatmaps",
        "Übersetzungsarbeit zwischen Subkulturen"
      ]
    },
    {
      id: "mensch",
      label: "Wer?",
      shortTitle: "Mensch",
      title: "Mensch-Achse",
      subtitle: "Teams, Emotionen & Leadership",
      description:
        "Menschen sind das Herz jeder Organisation. Erfolgreiche Transformation erfordert emotionale Intelligenz, effektive Teamdynamik und authentische Führung.",
      examples: [
        "Emotionale Kompetenz stärken",
        "Teamdynamik optimieren",
        "Leadership Development",
        "Change-Bereitschaft fördern"
      ]
    }
  ],

  systemic: {
    titleHighlight: "Systemische Wirkung",
    subtitle:
      "Alle drei Dimensionen beeinflussen sich gegenseitig. Wird eine verändert, verschiebt sich das gesamte System.",
    professionalsLabel: "Fokus von:"
  },

  interactions: [
    {
      id: "kultur-mensch",
      from: "Kultur",
      to: "Mensch",
      title: "Kultur formt Beziehungen",
      description:
        "Kulturelle Intelligenz bestimmt, wie Menschen miteinander umgehen und Vertrauen aufbauen.",
      examples: [
        "Kulturelle Intelligenz verbessert Vertrauen",
        "Psychologische Sicherheit ermöglicht offenen Austausch",
        "Team-Effektivität steigt in interkulturellen Teams"
      ],
      professionals:
        "HR-Experten, Organizational Development, Change Manager"
    },
    {
      id: "mensch-struktur",
      from: "Mensch",
      to: "Struktur",
      title: "Menschen stabilisieren Strukturen",
      description:
        "Starke Teams und Leadership schaffen klare Prozesse, die im Alltag tatsächlich gelebt werden.",
      examples: [
        "Starke Teams schaffen klare Prozesse",
        "Leadership definiert sinnvolle Rollen",
        "Entscheidungswege werden im Alltag gelebt"
      ],
      professionals: "Team Leader, Project Manager, Coaches"
    },
    {
      id: "struktur-kultur",
      from: "Struktur",
      to: "Kultur",
      title: "Strukturen prägen Verhalten",
      description:
        "Klare Strukturen und faire Governance fördern eine offene, vertrauensvolle Kultur.",
      examples: [
        "Klare Strukturen schaffen Transparenz",
        "Faire Governance fördert Vertrauen",
        "Offene Kultur statt heimlicher Widerstände"
      ],
      professionals:
        "Change Manager, Process Engineers, Governance Specialists"
    }
  ],

  professionalsSection: {
    titleBeforeHighlight: "Was unterschiedliche",
    highlight: "Professionen",
    footer:
      "Der Unterschied: Während klassische Ansätze isoliert arbeiten, integriert TRIAX® alle drei Dimensionen für nachhaltige, systemische Transformation."
  },

  professionals: [
    {
      key: "change",
      role: "Change Manager",
      focus: "Strukturen & Prozesse",
      description:
        "Fokussieren sich auf Prozessoptimierung, organisatorische Strukturen und systematische Veränderung."
    },
    {
      key: "coaches",
      role: "Coaches",
      focus: "Menschen & Leadership",
      description:
        "Arbeiten an emotionaler Intelligenz, Teamdynamik und persönlicher Entwicklung."
    },
    {
      key: "triax",
      role: "TRIAX® Berater",
      focus: "Systemische Integration",
      description:
        "Verbinden alle drei Dimensionen für ganzheitliche, nachhaltige Transformation."
    }
  ],

  benefits: {
    titleBeforeHighlight: "Warum",
    highlight: "TRIAX®",
    cards: [
      {
        title: "Systemischer Ansatz",
        text:
          "Ganzheitliche Betrachtung aller Dimensionen statt isolierter Maßnahmen."
      },
      {
        title: "Wissenschaftlich fundiert",
        text:
          "Basiert auf über 15 Jahren internationaler Beratung und Forschung."
      },
      {
        title: "Praxiserprobt",
        text:
          "Bewährt in komplexen Transformationsprogrammen auf C-Level und Board-Ebene."
      },
      {
        title: "Nachhaltig wirksam",
        text:
          "Fokus auf langfristige, messbare Ergebnisse – nicht auf kurzfristige Effekte."
      }
    ]
  },

  cta: {
    titleBeforeHighlight: "Bereit für",
    highlight: "systemische Transformation",
    text:
      "Entdecken Sie, wie TRIAX® Ihre Organisation nachhaltig transformiert.",
    button: "TRIAX® Transformation starten"
  }
},

triaxPage: {
  hero: {
    titleBeforeHighlight: "Was ist",
    highlight: "TRIAX®",
    suffix: "?",
    subtitle:
      "Unser systemischer Ansatz für nachhaltige Transformation verbindet drei fundamentale Dimensionen – Struktur, Kultur und Mensch – zu einem ganzheitlichen Modell."
  },
  classical: {
    title: "Klassische Ansätze",
    text:
      "Die meisten Transformationsansätze konzentrieren sich auf einzelne Aspekte – entweder auf Struktur, Technologie oder Menschen. TRIAX® wurde entwickelt, um genau diese Lücke zu schließen.",
    bullets: [
      { bold: "Change Manager", text: " fokussieren auf Prozesse" },
      { bold: "Coaches", text: " arbeiten an Menschen" },
      { bold: "Kulturberater", text: " fokussieren auf Werte" }
    ],
    footer: "→ Alle getrennt voneinander"
  },
  triaxApproach: {
    title: "TRIAX® Ansatz",
    text:
      "TRIAX® macht sichtbar, wie Entscheidungen in einer Dimension die anderen beeinflussen. Das macht Transformation proaktiv und steuerbar – statt reaktiv.",
    highlight:
      "💡 Veränderung in einer Achse beeinflusst automatisch die anderen beiden."
  },
  advantage: {
    title: "Ihr Vorteil als Führungsteam",
    items: [
      {
        title: "Gemeinsames Referenzmodell",
        description: "Eine präzise Sprache für Komplexität im Führungskreis."
      },
      {
        title: "Systemische Adressierung",
        description:
          "Konflikte, Risiken und Potenziale systematisch und transparent adressieren."
      },
      {
        title: "Nachhaltige Wirkung",
        description:
          "Langfristige, messbare Ergebnisse statt kurzfristiger Aktionismus."
      }
    ]
  },
  how: {
    titleBeforeHighlight: "Wie",
    highlight: "TRIAX® funktioniert",
    subtitle:
      "Drei Dimensionen – Struktur, Kultur und Mensch – bilden ein verbundenes System. Wird eine Achse bewegt, reagieren die anderen mit. TRIAX® macht diese Wechselwirkungen sichtbar.",
    inactiveTitle: "Klicken Sie auf eine Achse",
    inactiveSubtitle:
      "Entdecken Sie, wie die drei Dimensionen zusammenwirken und welche Effekte eine Veränderung auslöst.",
    footnote:
      "Das Besondere am TRIAX®-Modell ist die systemische Betrachtung: Alle drei Dimensionen beeinflussen sich gegenseitig. Wird eine verändert, verschiebt sich das gesamte System."
  },
  axesSection: {
    examplesTitle: "Beispiele:"
  },
  axes: [
    {
      id: "struktur",
      label: "Was?",
      vennTitle: "Struktur",
      title: "Struktur-Achse",
      subtitle: "Prozesse, Methoden & Systeme",
      description:
        "Strukturen schaffen den Rahmen für effektive Zusammenarbeit. Moderne Organisationen brauchen agile Prozesse, klare Methoden und unterstützende Systeme.",
      examples: [
        "Agile Organisationsstrukturen",
        "Effiziente Prozessgestaltung",
        "Systematisches Projektmanagement",
        "Digitale Transformation"
      ]
    },
    {
      id: "kultur",
      label: "Wie?",
      vennTitle: "Kultur",
      title: "Kultur-Achse",
      subtitle: "Werte, Rituale, informelle Regeln",
      description:
        "Kultur ist das unsichtbare Betriebssystem einer Organisation. Sie entscheidet, wie entschieden, kommuniziert und gelernt wird.",
      examples: [
        "Gemeinsame Prinzipien & Entscheidungsrituale",
        "Psychologische Sicherheit & Feedback-Rhythmen",
        "Kulturdiagnostik & Heatmaps",
        "Übersetzungsarbeit zwischen Subkulturen"
      ]
    },
    {
      id: "mensch",
      label: "Wer?",
      vennTitle: "Mensch",
      title: "Mensch-Achse",
      subtitle: "Teams, Emotionen & Leadership",
      description:
        "Menschen sind das Herz jeder Organisation. Erfolgreiche Transformation erfordert emotionale Intelligenz, effektive Teamdynamik und authentische Führung.",
      examples: [
        "Emotionale Kompetenz stärken",
        "Teamdynamik optimieren",
        "Leadership Development",
        "Change-Bereitschaft fördern"
      ]
    }
  ],
  interactionsSection: {
    title: "Systemische Wirkung",
    subtitle:
      "Alle drei Dimensionen beeinflussen sich gegenseitig. Wird eine verändert, verschiebt sich das gesamte System.",
    focusLabel: "Fokus von:"
  },
  interactions: [
    {
      from: "Kultur",
      to: "Mensch",
      title: "Kultur formt Beziehungen",
      description:
        "Kulturelle Intelligenz bestimmt, wie Menschen miteinander umgehen, Entscheidungen lesen und Vertrauen aufbauen.",
      examples: [
        "Kulturelle Intelligenz verbessert Vertrauen",
        "Psychologische Sicherheit ermöglicht offenen Austausch",
        "Team-Effektivität steigt in interkulturellen Teams"
      ],
      professionals:
        "HR-Expert:innen, Organizational Development, Change Manager"
    },
    {
      from: "Mensch",
      to: "Struktur",
      title: "Menschen stabilisieren Strukturen",
      description:
        "Starke Teams und Leadership schaffen Strukturen, die im Alltag nicht nur existieren, sondern gelebt werden.",
      examples: [
        "Starke Teams schaffen klare Prozesse",
        "Leadership definiert sinnvolle Rollen",
        "Entscheidungswege werden im Alltag gelebt"
      ],
      professionals: "Teamleiter:innen, Projektmanager:innen, Coaches"
    },
    {
      from: "Struktur",
      to: "Kultur",
      title: "Strukturen prägen Verhalten",
      description:
        "Klare Strukturen und faire Governance fördern eine offene, vertrauensvolle Kultur – oder sie verhindern sie.",
      examples: [
        "Klare Strukturen schaffen Transparenz",
        "Faire Governance fördert Vertrauen",
        "Offene Kultur statt heimlicher Widerstände"
      ],
      professionals:
        "Change Manager, Process Engineers, Governance Specialists"
    }
  ],
  professionalsSection: {
    titleBeforeHighlight: "Was unterschiedliche",
    highlight: "Professionen adressieren",
    differenceText:
      "Der Unterschied: Während klassische Ansätze isoliert arbeiten, integriert TRIAX® alle drei Dimensionen für nachhaltige, systemische Transformation."
  },
  professionals: [
    {
      id: "change-manager",
      role: "Change Manager",
      focus: "Strukturen & Prozesse",
      description:
        "Fokussieren sich auf Prozessoptimierung, organisatorische Strukturen und systematische Veränderung."
    },
    {
      id: "coaches",
      role: "Coaches",
      focus: "Menschen & Leadership",
      description:
        "Arbeiten an emotionaler Intelligenz, Teamdynamik und persönlicher Entwicklung."
    },
    {
      id: "triax-consultants",
      role: "TRIAX® Berater",
      focus: "Systemische Integration",
      description:
        "Verbinden alle drei Dimensionen für ganzheitliche, nachhaltige Transformation."
    }
  ],
  benefitsSection: {
    titleBeforeHighlight: "Warum",
    highlight: "TRIAX®?"
  },
  benefits: [
    {
      id: "systemic",
      title: "Systemischer Ansatz",
      description:
        "Ganzheitliche Betrachtung aller Dimensionen statt isolierter Einzelmaßnahmen."
    },
    {
      id: "scientific",
      title: "Wissenschaftlich fundiert",
      description:
        "Basiert auf internationaler Beratungserfahrung und systemischen Forschungsansätzen."
    },
    {
      id: "practical",
      title: "Praxiserprobt",
      description:
        "Bewährt in komplexen Transformationsprogrammen auf C-Level- und Board-Ebene."
    },
    {
      id: "sustainable",
      title: "Nachhaltig wirksam",
      description:
        "Fokus auf langfristige, messbare Ergebnisse – nicht auf kurzfristige Effekte."
    }
  ],
  cta: {
    titleBeforeHighlight: "Bereit für",
    highlight: "systemische Transformation",
    text:
      "Entdecken Sie, wie TRIAX® Ihre Organisation nachhaltig transformiert – ohne Dogma, aber mit klarer Systemperspektive.",
    button: "TRIAX® Transformation starten"
  }
},
    
    sosPage: {
  hero: {
    badge: "Strategic Emergency Response",
    highlight: "SOS",
    titleLine: "Wenn 48 Stunden über Monate entscheiden",
    subtitle:
      "Für Situationen, die keine Wartezeit kennen: Krisenmanagement, Deal-Support, Transformation unter Zeitdruck.",
    bullets: ["Sofortige Reaktion", "Krisenmanagement", "Punktgenau"]
  },
  packagesSection: {
    title: "SOS",
    highlight: "Pakete",
    subtitle:
      "Drei bewährte Notfall-Lösungen für unterschiedliche Krisensituationen.",
    footnote: "*Dauer kann je nach Teamgröße variieren"
  },
  labels: {
    urgent: "URGENT"
  },
  packages: [
    {
      id: "culturebridge",
      title: "CultureBridge MENA",
      badge: "24h Reaktionszeit",
      duration:
        "1 Tag Training + 3 Wochen Coaching + 1 Kulturhandbuch",
      description:
        "Für DACH-Unternehmen in Vorbereitung auf Geschäfte mit arabischen Partnern.",
      features: [
        "Interkulturelle Do's & Don'ts + Deep Dive in Denkweisen",
        "Geschäftsetikette, Kommunikationsstile, Verhandlungskultur",
        "Praktische Vorbereitung auf Meetings und Verhandlungen",
        "Kulturhandbuch für nachhaltigen Erfolg"
      ]
    },
    {
      id: "scrum4sales",
      title: "Scrum4Sales Sprint",
      badge: "48h Reaktionszeit",
      duration: "12 Wochen agiles Coaching & Praxisbegleitung",
      description: "Für Vertriebsabteilungen im Umbruch.",
      features: [
        "Einführung agiler Sales-Rhythmen (Planung, Review, Retros)",
        "Kulturwandel & Verantwortungsarchitektur im Vertrieb",
        "Team-Alignment und Transparenz-Tools",
        "Kontinuierliche Optimierung der Sales-Prozesse"
      ]
    },
    {
      id: "change-sparring-6",
      title: "Change Sparring 6",
      badge: "Terminvergabe innerhalb 24h",
      duration: "6 Monate 1:1 Begleitung",
      description:
        "Für Führungskräfte in kritischen Transformationsphasen.",
      features: [
        "Systemische Analyse, Roadmap, Rollenklärung",
        "Konfliktnavigation & Resonanzräume",
        "Wöchentliche Sparring-Sessions",
        "Emergency-Support für kritische Situationen"
      ]
    }
  ],
  actions: {
    requestSOS: "Jetzt SOS anfordern"
  },
  resultsSection: {
    titleBeforeHighlight: "Bewiesene",
    highlight: "Ergebnisse",
    subtitle:
      "Unsere SOS-Pakete liefern messbare Resultate in kürzester Zeit."
  },
  results: [
    { id: "productivity", metric: "+40%", label: "Produktivität" },
    { id: "revenue", metric: "+35%", label: "Umsatz" },
    { id: "delays", metric: "-50%", label: "Verzögerungen" },
    {
      id: "decisions",
      metric: "+60%",
      label: "bessere Entscheidungen"
    }
  ],
  process: {
    titleBeforeHighlight: "So funktioniert",
    highlight: "SOS",
    steps: [
      {
        title: "Sofortkontakt",
        text:
          "Anruf oder E-Mail genügt. Wir reagieren innerhalb von 24–48 Stunden."
      },
      {
        title: "Schnellanalyse",
        text:
          "Kurzes Assessment der Situation und sofortige Handlungsempfehlungen."
      },
      {
        title: "Sofortige Umsetzung",
        text:
          "Direkter Start der Intervention mit bewährten SOS-Methoden."
      }
    ]
  },
  contact: {
    titleBeforeHighlight: "Ihre Situation ist",
    highlight: "kritisch",
    text:
      "Zögern Sie nicht. Jede Minute kann entscheidend sein. Unsere SOS-Expert:innen stehen bereit, um Ihnen sofort zu helfen.",
    bullets: [
      "24/7 Kontakt",
      "Krisenerprobte Expert:innen",
      "Sofortige Wirkung"
    ],
    hotlineButton: "Notfall-Hotline: +49 xxx xxx xxx",
    emailButton: "E-Mail: sos@globalegroupe.de"
  }
},
    contactPage: {
  hero: {
    highlight: "Transformation",
    titleRest: "beginnt nicht mit einem Kick-off",
    subtitle: "Sondern mit einem ehrlichen Gespräch.",
    bullets: ["24h Reaktionszeit", "Vertraulich", "Persönlich"]
  },
  form: {
    titleBeforeHighlight: "Lassen Sie uns",
    highlight: "sprechen",
    nameLabel: "Name",
    namePlaceholder: "Ihr Name",
    companyLabel: "Unternehmen",
    companyPlaceholder: "Ihr Unternehmen",
    emailLabel: "E-Mail",
    emailPlaceholder: "ihre@email.com",
    phoneLabel: "Telefon",
    phonePlaceholder: "+49 xxx xxx xxx",
    topicLabel: "Thema auswählen",
    topicPlaceholder: "Bitte auswählen",
    messageLabel: "Ihre Nachricht",
    messagePlaceholder: "Erzählen Sie uns von Ihrer Herausforderung...",
    submitLabel: "Nachricht senden",
    footerText:
      "Wir antworten innerhalb von 24 Stunden. Ihre Daten behandeln wir vertraulich.",
    topics: [
      "TRIAX® Transformation",
      "SOS-Paket anfordern",
      "Signature-Lösung",
      "Interkulturelle Beratung",
      "Leadership Coaching",
      "Erstberatung",
      "Anderes Thema"
    ]
  },
  contactInfo: {
    titleBeforeHighlight: "Direkte",
    highlight: "Kontakte",
    emailLabel: "E-Mail",
    email: "contact@globalegroupe.com",
    linkedinLabel: "LinkedIn",
    linkedin: "linkedin.com/company/globalegroupe",
    hotlineLabel: "SOS Hotline",
    hotlineNumber: "+49 xxx xxx xxx",
    hotlineNote: "Für dringende Fälle"
  },
  why: {
    title: "Warum GloBridge?",
    bullets: [
      "Erste Einschätzung innerhalb von 24 Stunden",
      "Kostenlose Erstberatung (30 Minuten)",
      "Vertrauliche Behandlung aller Informationen",
      "Konkrete Handlungsempfehlungen statt Theorie"
    ]
  },
  locations: {
    titleBeforeHighlight: "Unsere",
    highlight: "Standorte",
    subtitle: "DACH · Afrika · Golfländer – dort, wo Sie uns brauchen"
  },
  offices: [
    {
      region: "DACH",
      city: "Baden-Baden",
      address: "",
      phone: "+49 xx xxx xxx xxx",
      email: "dach@globalegroupe.com",
      gradient: "from-purple-600 to-blue-600"
    },
    {
      region: "MENA",
      city: "Dubai",
      address: "",
      phone: "+971 x xxx xxx xxx",
      email: "mena@globalegroupe.com",
      gradient: "from-orange-500 to-red-500"
    },
    {
      region: "North Africa",
      city: "Casablanca",
      address: "",
      phone: "+212 xxx xxx xxx",
      email: "africa@globalegroupe.com",
      gradient: "from-emerald-500 to-teal-600"
    }
  ],
  finalCTA: {
    titleBeforeHighlight: "Bereit für den",
    highlight: "ersten Schritt",
    text:
      "Transformation beginnt mit einem Gespräch. Lassen Sie uns gemeinsam herausfinden, wie wir Ihre Organisation in Resonanz bringen können.",
    primaryButton: "Termin vereinbaren",
    secondaryButton: "Kostenlose Erstberatung"
  }
},
contactPage: {
  hero: {
    highlight: "Transformation",
    titleRest: "beginnt nicht mit einem Kick-off",
    subtitle: "Sondern mit einem ehrlichen Gespräch.",
    bullets: ["24h Reaktionszeit", "Vertraulich", "Persönlich"]
  },
  form: {
    titleBeforeHighlight: "Lassen Sie uns",
    highlight: "sprechen",
    nameLabel: "Name",
    namePlaceholder: "Ihr Name",
    companyLabel: "Unternehmen",
    companyPlaceholder: "Ihr Unternehmen",
    emailLabel: "E-Mail",
    emailPlaceholder: "ihre@email.com",
    phoneLabel: "Telefon",
    phonePlaceholder: "+49 xxx xxx xxx",
    topicLabel: "Thema auswählen",
    topicPlaceholder: "Bitte auswählen",
    messageLabel: "Ihre Nachricht",
    messagePlaceholder: "Erzählen Sie uns von Ihrer Herausforderung...",
    submitLabel: "Nachricht senden",
    footerText:
      "Wir antworten innerhalb von 24 Stunden. Ihre Daten behandeln wir vertraulich.",
    topics: [
      "TRIAX® Transformation",
      "SOS-Paket anfordern",
      "Signature-Lösung",
      "Interkulturelle Beratung",
      "Leadership Coaching",
      "Erstberatung",
      "Anderes Thema"
    ]
  },
  contactInfo: {
    titleBeforeHighlight: "Direkte",
    highlight: "Kontakte",
    emailLabel: "E-Mail",
    email: "hello@globalegroupe.com",
    linkedinLabel: "LinkedIn",
    linkedin: "linkedin.com/company/globalegroupe",
    hotlineLabel: "SOS Hotline",
    hotlineNumber: "+49 xxx xxx xxx",
    hotlineNote: "Für dringende Fälle"
  },
  why: {
    title: "Warum GloBridge?",
    bullets: [
      "Erste Einschätzung innerhalb von 24 Stunden",
      "Kostenlose Erstberatung (30 Minuten)",
      "Vertrauliche Behandlung aller Informationen",
      "Konkrete Handlungsempfehlungen statt Theorie"
    ]
  },
  locations: {
    titleBeforeHighlight: "Unsere",
    highlight: "Standorte",
    subtitle: "DACH · Afrika · Golfländer – dort, wo Sie uns brauchen"
  },
  offices: [
    {
      region: "DACH",
      city: "Frankfurt am Main",
      address: "Bockenheimer Landstraße 123, 60325 Frankfurt",
      phone: "+49 69 123 456 789",
      email: "dach@globalegroupe.com",
      gradient: "from-purple-600 to-blue-600"
    },
    {
      region: "MENA",
      city: "Dubai",
      address: "DIFC, Gate Village 10, Level 5, Dubai",
      phone: "+971 4 123 456 789",
      email: "mena@globalegroupe.com",
      gradient: "from-orange-500 to-red-500"
    },
    {
      region: "North Africa",
      city: "Casablanca",
      address: "Twin Center, Tour A, Angle Boulevards",
      phone: "+212 522 123 456",
      email: "africa@globalegroupe.com",
      gradient: "from-emerald-500 to-teal-600"
    }
  ],
  finalCTA: {
    titleBeforeHighlight: "Bereit für den",
    highlight: "ersten Schritt",
    text:
      "Transformation beginnt mit einem Gespräch. Lassen Sie uns gemeinsam herausfinden, wie wir Ihre Organisation in Resonanz bringen können.",
    primaryButton: "Termin vereinbaren",
    secondaryButton: "Kostenlose Erstberatung"
  }
},
insightsPage: {
  hero: {
    chipLabel: "Erfolgsgeschichten & Erkenntnisse",
    titleHighlight: "Insights",
    titleRest: "Lernen aus der Praxis",
    subtitle:
      "Echte Projekte, messbare Ergebnisse, authentische Kundenstimmen. Entdecken Sie, wie TRIAX® und unsere Signature-Lösungen Organisationen transformieren."
  },
  tabs: {
    successStories: "Erfolgsgeschichten",
    caseStudies: "Case Studies",
    blogPlanned: "Blog (geplant)"
  },
  labels: {
    challenge: "Herausforderung",
    solution: "Lösung",
    results: "Ergebnisse mit Zahlen"
  },
  metrics: {
    timeline: "Timeline",
    roi: "ROI",
    satisfaction: "Zufriedenheit"
  },
  caseStudies: [
    {
      title: "Interkulturelles Missverständnis aufgelöst",
      category: "CultureBridge MENA",
      duration: "3 Monate",
      challenge:
        "Deutsche Automobilzulieferer scheiterte an MENA-Expansion durch kulturelle Barrieren.",
      solution:
        "TRIAX®-basierte Kulturanalyse und maßgeschneidertes CultureBridge-Programm.",
      results: [
        "150% Umsatzsteigerung in MENA-Region",
        "85% weniger Verhandlungsabbrüche",
        "Erfolgreiche Partnerschaft mit 3 lokalen Distributoren"
      ],
      quote:
        "\"CultureBridge hat nicht nur unsere Geschäfte gerettet, sondern uns eine ganze Region erschlossen.\"",
      author: "CEO, Automobilzulieferer (DAX)",
      metrics: {
        timeline: "6 Monate",
        roi: "400%",
        satisfaction: "9.8/10"
      },
      image:
        "https://images.unsplash.com/photo-1552084850-c6a1fc7cf717?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzU2MjQ4MzUzfDA&ixlib=rb-4.1.0&q=85"
    },
    {
      title: "Stockende Reorganisation wiederbelebt",
      category: "Change Sparring 6",
      duration: "6 Monate",
      challenge:
        "Reorganisation in Fintech-Startup führte zu Widerstand und Produktivitätsverlust.",
      solution:
        "Systematisches Change Sparring mit TRIAX®-Methodik für Führungskräfte.",
      results: [
        "60% Steigerung der Mitarbeiterengagement",
        "40% Reduktion der Fluktuation",
        "Erfolgreicher Abschluss der Reorganisation"
      ],
      quote:
        "\"Ohne das Change Sparring wären wir gescheitert. Die Begleitung war der Schlüssel zum Erfolg.\"",
      author: "Managing Director, FinTech",
      metrics: {
        timeline: "6 Monate",
        roi: "250%",
        satisfaction: "9.5/10"
      },
      image:
        "https://images.unsplash.com/photo-1675392347224-ae88c11def9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      title: "Vertrieb wird agil und erfolgreich",
      category: "Scrum4Sales Sprint",
      duration: "12 Wochen",
      challenge:
        "Traditioneller B2B-Vertrieb kämpfte mit langen Sales Cycles und geringer Teamleistung.",
      solution:
        "Scrum4Sales Implementation mit agilen Rhythmen und Transparenz-Tools.",
      results: [
        "45% kürzere Sales Cycles",
        "70% Steigerung der Abschlussrate",
        "80% höhere Team-Produktivität"
      ],
      quote:
        "\"Scrum4Sales hat unseren Vertrieb revolutioniert. Wir arbeiten jetzt als echtes Team.\"",
      author: "Head of Sales, B2B Software",
      metrics: {
        timeline: "3 Monate",
        roi: "320%",
        satisfaction: "9.7/10"
      },
      image:
        "https://images.unsplash.com/photo-1743842768257-e897326cd11e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85"
    }
  ],
  summary: {
    titleBeforeHighlight: "Zusammengefasste",
    highlight: "Erfolge",
    stats: [
      {
        metric: "50+",
        label: "Erfolgreich abgeschlossene Projekte"
      },
      {
        metric: "95%",
        label: "Kundenzufriedenheit"
      },
      {
        metric: "300%",
        label: "Durchschnittlicher ROI"
      },
      {
        metric: "15",
        label: "Länder & Märkte"
      }
    ]
  },
  yourStory: {
    titleBeforeHighlight: "Ihre",
    highlight: "Erfolgsgeschichte",
    text:
      "Diese Erfolge sind nicht zufällig entstanden. Sie sind das Ergebnis von systematischer Arbeit mit TRIAX® und unseren Signature-Lösungen. Lassen Sie uns gemeinsam Ihre nächste Erfolgsgeschichte schreiben.",
    tiles: [
      {
        title: "Bewährt",
        text: "Über 50 erfolgreiche Transformationen."
      },
      {
        title: "Messbar",
        text: "Durchschnittlich 300% Return on Investment."
      },
      {
        title: "Nachhaltig",
        text: "95% langfristige Kundenzufriedenheit."
      }
    ],
    buttonLabel: "Ihre Story beginnen"
  }
},

markets: {
  badgeLabel: 'Global Excellence',
  titleBeforeHighlight: 'Märkte &',
  highlight: 'Branchen',
  description:
    'Wir begleiten Organisationen in ausgewählten Regionen, in denen wir kulturell zu Hause sind – mit tiefem Verständnis für Marktlogiken, Business-Kulturen und Entscheidungswege.',
  connectionText:
    'Unsere globale Präsenz ermöglicht nahtlose interkulturelle Brücken.',
  regions: [
    {
      name: 'DACH',
      countries: ['Deutschland', 'Österreich', 'Schweiz'],
      image:
        'https://images.unsplash.com/photo-1617375402484-8a196422d93d?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      monument: 'Berlin Cathedral - German Architecture',
      specialty: 'Präzision & Effizienz',
      gradient: 'from-slate-600 to-blue-600',
      description: 'Das Herzstück europäischer Business-Exzellenz.'
    },
    {
      name: 'Mittlerer Osten',
      countries: ['UAE', 'Saudi-Arabien', 'Qatar'],
      image:
        'https://images.unsplash.com/photo-1653763843954-0ad7300268a6?q=80&w=435&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      monument: 'Emirates Towers & Museum of the Future',
      specialty: 'Partnerschaft & Vertrauen',
      gradient: 'from-orange-500 to-amber-500',
      description: 'Wo Tradition auf Innovation trifft.'
    },
    {
      name: 'Nordafrika',
      countries: ['Marokko', 'Tunesien', 'Ägypten'],
      image:
        'https://images.unsplash.com/photo-1699210260021-eac11ba4ff86?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      monument: 'Hassan II Mosque - Casablanca',
      specialty: 'Tradition & Innovation',
      gradient: 'from-emerald-600 to-teal-600',
      description: 'Kulturelle Brücke zwischen Kontinenten.'
    }
  ]
},

 expertise: {
  badgeElite: "Elite-Services",
  title: "Unsere",
  titleHighlight: "Signature-Expertise",
  description:
    "GLOBRIDGE bündelt systemisches Change Management, kulturelle Intelligenz und Executive Sparring in einem kuratierten Premium-Portfolio.",
  subDescription:
    "Vier Signature-Services, eine Logik: tiefe, messbare Transformation statt Slideware.",

  services: [
    {
      id: "change-management",
      iconName: "Zap",
      background:
        "https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-purple-600 to-blue-600",
      title: "Systemisches Change Management",
      subtitle: "Resonance Flow Framework",
      description:
        "End-to-End-Begleitung für komplexe Transformationen, von der Diagnose bis zur Verankerung.",
      features: [
        "TRIAX®-basierte Diagnose von Kultur, Struktur und Mensch",
        "Resonance Flow Framework über 5 Phasen hinweg",
        "C-Level-Sparring und Stakeholder-Alignment",
        "Klare Deliverables und KPIs für jede Phase"
      ],
      href: "/services",
      cta: "Unseren Change-Ansatz entdecken"
    },
    {
      id: "leadership-coaching",
      iconName: "Users",
      background:
        "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-emerald-500 to-teal-600",
      title: "Leadership & Executive Coaching",
      subtitle: "Resonanz für C-Level",
      description:
        "Sparring für Entscheidungsträger:innen in hochkritischen Transformationsphasen.",
      features: [
        "1:1 Executive Coaching für C-Level und Top-Talente",
        "Leadership-Entwicklung in Transformationsphasen",
        "Resilienz, Klarheit und Entscheidungskraft",
        "Vertrauliches Sparring auf Augenhöhe"
      ],
      href: "/services",
      cta: "Leadership stärken"
    },
    {
      id: "scrum4sales",
      iconName: "Target",
      background:
        "https://images.unsplash.com/photo-1556740749-887f6717d7e4?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-orange-500 to-red-500",
      title: "Scrum4Sales Sprint",
      subtitle: "Agiler Vertrieb",
      description:
        "Wir machen Vertriebsteams schnell, adaptiv und datengetrieben.",
      features: [
        "Agile Rhythmen für Vertriebsteams (Sprints, Reviews, Retros)",
        "Transparente Pipeline und geteilte Priorisierung",
        "Datenbasierte Entscheidungen statt Bauchgefühl",
        "Enablement für selbstorganisierte, verantwortungsstarke Teams"
      ],
      href: "/services",
      cta: "Scrum4Sales entdecken"
    },
    {
      id: "culturebridge-mena",
      iconName: "Star",
      background:
        "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-violet-500 to-purple-600",
      title: "CultureBridge MENA",
      subtitle: "Interkulturelle Business Intelligence",
      description:
        "Wir bauen DACH–MENA-Brücken für Expansion, kritische Deals und Joint Ventures.",
      features: [
        "Gezielte Vorbereitung auf DACH–MENA-Business-Settings",
        "Do’s & Don’ts, Verhandlungscodes und Entscheidungslogiken",
        "Begleitung bei kritischen Deals und Schlüsselpartnerschaften",
        "Culture-Handbook und praxisnahe Playbooks für Ihre Teams"
      ],
      href: "/sos",
      cta: "CultureBridge entdecken"
    }
  ],

  dna: {
    badge: "GLOBRIDGE DNA",
    titleBeforeHighlight: "Was uns zur",
    titleHighlight: "Top-1%-Elite",
    titleAfterHighlight: "unter Boutique-Beratungen macht",
    description:
      "Vier Exzellenzsäulen formen unser TRIAX®-System – systemisch, kulturell intelligent, messbar wirksam.",

    systemicDepth: {
      title: "Systemische Tiefe",
      line1: "Wir transformieren ganze Systeme,",
      line2: "nicht nur sichtbare Symptome.",
      chip: "TRIAX® Methodologie"
    },
    culturalIntelligence: {
      title: "Kulturelle Intelligenz",
      line1: "Wir übersetzen nahtlos zwischen",
      line2: "Kulturen und Märkten.",
      chip: "DACH × MENA"
    },
    humanResonance: {
      title: "Menschliche Resonanz",
      line1: "Wir schaffen emotionale Verbindung,",
      line2: "nicht nur Strategien auf Folien.",
      chip: "Resonance Leadership"
    },
    measurableImpact: {
      title: "Messbare Wirkung",
      line1: "Wir verpflichten uns zu nachprüfbaren",
      line2: "Ergebnissen und klarem ROI.",
      chip: "Performance-Nachweis"
    }
  },

  cta: {
    questionBeforeHighlight: "Bereit, Ihre Transformation auf",
    highlight: "Top-1%-Elite-Niveau",
    button: "Executive Beratung vereinbaren"
  }
},

readiness: {
  title: 'Transformation Readiness Check',
  subtitle: 'Testen Sie, wie bereit Ihr Team für Veränderung ist.',

  scoreLabel: 'Readiness Score',

  levelHigh: 'Hoch',
  levelMedium: 'Mittel',
  levelLow: 'Niedrig',

  messageHigh:
    'Ihr Team ist bereit! Fokus auf Optimierung, Skalierung und gezielte Hebel.',
  messageMedium:
    'Die Grundlage ist vorhanden. Wir empfehlen gezielte Coaching- und Change-Interventionen.',
  messageLow:
    'Intensive Begleitung empfohlen. Wir starten mit einer Resonanz-Diagnose und klarer Roadmap.',

  questions: {
    vision: {
      question: 'Wie klar ist Ihre Transformation-Vision im Team?',
      options: {
        veryClear: 'Sehr klar',
        partlyClear: 'Teilweise klar',
        unclear: 'Unklar',
        noVision: 'Keine Vision'
      }
    },
    resistance: {
      question: 'Wie hoch ist der Widerstand gegen Veränderung?',
      options: {
        veryLow: 'Sehr niedrig',
        moderate: 'Moderat',
        high: 'Hoch',
        veryHigh: 'Sehr hoch'
      }
    },
    culture: {
      question: 'Gibt es kulturelle Herausforderungen (z.B. DACH-MENA)?',
      options: {
        none: 'Nein',
        few: 'Wenige',
        some: 'Einige',
        many: 'Viele'
      }
    },
    salesAgility: {
      question: 'Wie agil arbeitet Ihr Vertriebsteam?',
      options: {
        veryAgile: 'Sehr agil',
        partlyAgile: 'Teilweise agil',
        traditional: 'Traditionell',
        rigid: 'Starr'
      }
    }
  }
},
    footer: {
      claim: "Resonanzraum Consulting – Wo Wandel wirkt. Und nicht nur aussieht wie Arbeit."
    }
  },
  
  
  
  
  en: {
    // Navigation
    nav: {
      home: "Home",
      about: "About Us",
      triax: "TRIAX®", 
      services: "Services",
      signature: "Signature",
      sos: "SOS",
      insights: "Insights",
      contact: "Contact"
    },
    navDropdown: {
  services: {
    change: {
      title: "Change beyond templates",
      description: "Systemic, tailored change management – not another standard blueprint."
    },
    bridges: {
      title: "Business between worlds",
      description: "Intercultural intelligence made tangible for cross-border collaboration."
    },
    scrum4sales: {
      title: "Scrum4Sales",
      description: "Agile sales reimagined – sprints, focus and clear closing momentum."
    },
    leadership: {
      title: "Leadership Resonance Atelier",
      description: "Coaching and sparring for executives and expats in complex systems."
    }
  },
  signature: {
    foundation: {
      title: "Resonance Foundation",
      description: "Essentials for sustainable change management."
    },
    accelerator: {
      title: "Resonance Accelerator",
      description: "Connecting change and leadership development in one architecture."
    },
    transformation: {
      title: "Resonance Transformation",
      description: "Full RFF – end-to-end guidance along the transformation journey."
    },
    sos: {
      title: "Resonance SOS",
      description: "Fast, precise intervention in acute crisis moments."
    }
  },
  insights: {
    successStories: {
      title: "Success stories",
      description: "Case studies with numbers, impact and executive-relevant insights."
    },
    caseStudies: {
      title: "Case studies",
      description: "Detailed project deep-dives into transformation architectures."
    },
    blog: {
      title: "Blog",
      description: "Strategic reflections and thought leadership (planned)."
    }
  }
},
    // Hero Slider
    hero: {
slide1: {
  headline: "Change    isn’t a project. It’s a language.",
  subheadline: "We speak it fluently, between systems and people, between strategy and impact, between DACH and MENA.",
  claim: "Where strategy meets humanity and initiatives turn into lasting outcomes.",
  cta: "Schedule an executive conversation"
},
slide2: {
  headline: "Intercultural intelligence   We build bridges where others hit walls.",
  subheadline: "The quiet competitive advantage.",
  cta: "Learn more"
},
slide3: {
  headline: "TRIAX®     our proprietary system for holistic transformation.",
  subheadline: "A research based approach that systematically unites structure, culture and people for change that actually works.",
  cta: "Discover TRIAX®"
},
slide4: {
  headline: "Scrum4Sales      sales redefined: collaborative, adaptive, high-performing.",
  subheadline: "Agility that sells.",
  cta: "Schedule an executive conversation"
}

    },
    // Welcome Section
    welcome: {
      title: "Welcome to GLOBRIDGE",
      subtitle: "Your partner for systemic transformation and intercultural intelligence. We connect worlds – culturally, technologically, humanly.",
      card1: {
        title: "TRIAX® Model",
        description: "The model for intercultural transformation in Europe: Between System & Human, between Strategy & Impact"
      },
      card2: {
        title: "Business Between Worlds",
        description: "Successful collaboration across cultural borders. Intercultural bridges between DACH and MENA regions"
      },
      card3: {
        title: "Premium Services & SOS Support",
        description: "Tailored solutions and immediate help for sustainable change processes and acute transformation crises"
      },
      cta: "Begin Executive Dialogue"
    },
    // Silent Epidemic New Section
    silentEpidemicNew: {
      title: "The Silent Epidemic in German Companies",
      subtitle: "While everyone talks about digitalization, 70% of all transformation projects fail. Why? Because people are forgotten.",
      stat1: "of all change projects fail because cultural and human factors are ignored.",
      stat2: "is wasted annually in Germany through failed transformations.",
      stat3: "of executives feel unprepared for international business.",
      billion: "Billion",
      bottomTitle: "The problem is not in the technology. It lies in the implementation.",
      bottomDescription: "Between vision and reality, between leadership and team, between cultures and markets. We are the interpreters for these invisible languages."
    },
    silentEpidemic: {
      badge: "The silent epidemic",
      title: "We live in a moment that accelerates everything and paralyzes at the same time.",
      description1: "Digitalization, artificial intelligence, social media and global tensions don't just change markets.",
      description1Highlight: "They change people.",
      description2: "Teams break apart, leadership becomes a feat of strength, cultures clash and behind every process stands a human who must decide, lead, function.",
      description3: "And yet many feel: It needs something that cannot be measured. Deeper. Truer. Something is missing.",
      description4: "No plan, tool or another strategy. But what lies in between.",
      description5: "Between what could be possible – and what remains reality.",
      quote: "This is the paradox of modern business: The louder technology becomes, the quieter human genius gets.",
      imageQuote: "GLOBRIDGE unfolds transformation like an exquisite perfume:",
      imageQuoteHighlight: "deep, precise, lasting.",
      imageSignature: "Resonance is our signature scent.",
      bottomTitle1: "We don't build strategies.",
      bottomTitle2: "We build resonance.",
      bottomDescription: "An invisible three-part system of culture, human and structure – finely tuned, courageously composed, perceptible in every movement.",
      cta1: "Schedule conversation",
      cta2: "Discover TRIAX"
    },
    expertise: {
      title: "Bringing impact into",
      titleHighlight: "motion",
      description: "Four powerful pillars that don't just promise transformation – but deliver measurably. Systemically thought, culturally intelligent, humanly effective.",
      subDescription: "This is not standard consulting. This is impact in its most intelligent form.",
      services: [
        {
          id: 'change',
          iconName: 'Zap',
          title: 'Systemic Change Management',
          subtitle: 'Transformation with Depth',
          description: 'Change that doesn\'t just work superficially, but is systemically anchored.',
          features: [
            'Cultural Change',
            'Structural Integration',
            'Human Acceptance',
            'Sustainable Anchoring'
          ],
          background: 'https://images.unsplash.com/photo-1709221387675-403ac1a6003a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBhYnN0cmFjdHxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NTY0ODQwNDJ8MA&ixlib=rb-4.1.0&q=85',
          cta: 'Discover Change Management',
          href: '/services#service-0',
          gradient: 'from-purple-600 to-blue-600'
        },
        {
          id: 'coaching',
          iconName: 'Users',
          title: 'Business Coaching',
          subtitle: 'Leadership Excellence',
          description: 'Executive development at the highest level for sustainable results.',
          features: [
            'Executive Coaching',
            'Team Development',
            'Leadership Resonance',
            'Performance Boost'
          ],
          background: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
          cta: 'Discover Coaching Program',
          href: '/services#service-1',
          gradient: 'from-emerald-500 to-teal-600'
        },
        {
          id: 'sales',
          iconName: 'Target',
          title: 'SCRUM for Sales',
          subtitle: 'Agile Sales Revolution',
          description: 'Transform sales teams agile for measurably higher closing rates.',
          features: [
            'Agile Sales Methodology',
            'Team Synchronization',
            'Performance Tracking',
            'Conversion Boost'
          ],
          background: 'https://images.unsplash.com/photo-1629471361722-e1306b0c0e42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw1fHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85',
          cta: 'Experience Scrum4Sales',
          href: '/services#service-2',
          gradient: 'from-orange-500 to-red-500'
        },
        {
          id: 'intercultural',
          iconName: 'Star',
          title: 'Intercultural Business Intelligence',
          subtitle: 'Global Expansion Excellence',
          description: 'Build cultural bridges for successful global business.',
          features: [
            'MENA Expertise',
            'Cultural Intelligence',
            'Market Entry Strategy',
            'Cross-Cultural Teams'
          ],
          background: 'https://images.unsplash.com/photo-1672664003230-106aa4f534c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85',
          cta: 'Discover Global Intelligence',
          href: '/services#service-3',
          gradient: 'from-violet-500 to-purple-600'
        }
      ]
    },
    markets: {
      title: "Markets &",
      description: "DACH · Middle East · North Africa – where cultural competence decides."
    },
    // Triax Section
    triaxSection: {
      title: "What and why TRIAX®?",
      classical: "Classical consulting separates silos",
      classicalDesc: "Process ↔ Culture ↔ Human separate.",
      triax: "TRIAX® integrates holistically", 
      triaxDesc: "Behavior, processes, performance as one system.",
      highlights: [
        "KPI increase through system harmonization",
        "Early warning system for resistance",
        "Transparency about interdependencies"
      ],
      cta: "We don't sell services. We deliver transformations."
    },
    // For Whom Section
    forWhom: {
      title: "For leading and ambitious companies",
      subtitle: "This is not an ordinary website. This is a strategic assessment of your readiness.",
      intro: "If 3+ of the following points apply, your company is ready for a partnership with us:",
      points: [
        "You implement cutting-edge AI technologies, but your meetings are more lifeless and unproductive than ever before.",
        "Expansion projects deliver excellent financial results, but feel more like acquisitions than partnerships.",
        "You are certified in Agile methodologies – but your organizational structure still works like the 80s.",
        "Your team speaks six different languages – except the language of mutual understanding.",
        "You are reading this text with increased pulse and growing awareness about your company."
      ],
      notFor: "Companies we don't serve:",
      notForDesc: "Superficial quick fixes · Projects just for appearance · Task-oriented instead of journey-oriented thinking · Lack of courage for uncomfortable truths.",
      whyDifferent: "What makes us different:",
      whyDifferentDesc: "German precision × authentic Eastern wisdom · Depth × pragmatism · Asking the right questions instead of selling solutions · Trainer/strategic partner/cultural translator."
    },
    journeyTimeline: {
  milestones: [
    {
      year: 'Origin',
      title: 'Raised between worlds',
      description:
        'Born between cultures, raised across continents. DACH, MENA, Europe – not as a visitor, but as a genuine part of several worlds.'
    },
    {
      year: 'Academia',
      title: 'International Business & Intercultural Studies',
      description:
        'Academic background in International Business, Intercultural Studies and systemic Change Management. Theory as a foundation – never as dogma.'
    },
    {
      year: 'Certification',
      title: 'ISO-EN-17024 Change Management Consultant',
      description:
        'International certification in Change Management. Not to collect badges, but because excellence requires clear standards.'
    },
    {
      year: 'Practice',
      title: 'Project Delivery & Transformation Support',
      description:
        'Years in the field: project delivery, change programmes, international teams. From mid-sized companies to corporates. From Munich to Morocco.'
    },
    {
      year: 'Innovation',
      title: 'TRIAX® & Resonance Flow Framework',
      description:
        'The synthesis: TRIAX® as a systemic model (culture–human–structure) and the Resonance Flow Framework as a scalable methodology.'
    },
    {
      year: 'Today',
      title: 'GLOBRIDGE – Boutique Consulting',
      description:
        'No corporate machine, no mass product. A boutique for organisations seeking deep transformation – with resonance, not just tools.'
    }
  ]
},
about: {
  hero: {
    badge: "Identity & Origin",
    titleLine1: "Born between worlds.",
    titleHighlight: "Built for worlds.",
    subtitle:
      "GLOBRIDGE was not founded to sell classic consulting. It was created to fill a gap others do not even see.",
    quoteLine1:
      "Between systems and humans. Between strategy and actual impact.",
    quoteLine2: "Between cultures and markets.",
    imageAlt: "Professional business context in an international environment"
  },
  story: {
    titleBeforeHighlight: "Who",
    titleHighlight: "we are",
    p1:
      "GLOBRIDGE is not a company in the traditional sense. It is the synthesis of a personal journey – raised between cultures, trained academically, proven in practice.",
    p2:
      "As a Change Management Consultant certified under ISO-EN-17024, with an academic background in International Business and Intercultural Studies and hands-on experience as a Project Delivery Manager, I learned one thing early on:",
    quote:
      "Transformation does not fail because of tools. It fails because people are forgotten.",
    p3:
      "Too often I witnessed brilliant strategies collapse due to cultural blind spots, internal resistance or the absence of real listening. GLOBRIDGE emerged as a boutique for systemic transformation – with depth, not volume.",
    closing:
      "Not to reinvent consulting. But to bridge the space between system and soul, between structure and humanity.",
    floatingQuote:
      "Impact does not emerge from methods alone – it emerges from resonance."
  },
  credentials: {
    title: "Foundation &",
    highlight: "Credentials",
    subtitle:
      "Not because we collect certificates, but because excellence requires standards",
    items: [
      {
        id: "iso",
        title: "ISO-EN-17024",
        subtitle: "Change Management Consultant",
        description:
          "International certification as a Change Management Consultant."
      },
      {
        id: "academic",
        title: "Academic background",
        subtitle: "International Business & Intercultural Studies",
        description:
          "Master-level expertise in International Business and intercultural communication."
      },
      {
        id: "delivery",
        title: "Project Delivery Manager",
        subtitle: "Practical expertise",
        description:
          "Years in the field: change programmes from mid-sized companies to large corporates."
      },
      {
        id: "dach-mena",
        title: "DACH–MENA expertise",
        subtitle: "Arabic · French · German",
        description:
          "Trilingual capability for cross-border and cross-cultural transformation."
      }
    ]
  },
  journey: {
    title: "The",
    highlight: "journey",
    subtitle: "From intercultural roots to systemic transformation"
  },
  values: {
    title: "Our",
    highlight: "philosophy",
    subtitle:
      "Values that guide us – not as slogans, but as lived practice",
    items: [
      {
        id: "resonance",
        title: "Resonance over perfection",
        description:
          "We do not believe in perfect strategies. We believe in human connection that makes transformation truly possible."
      },
      {
        id: "systemic",
        title: "Systemic – and system-critical",
        description:
          "We think in systems (TRIAX®), yet we challenge dogma. Methodology with humility and clear business focus."
      },
      {
        id: "cultural",
        title: "Cultural intelligence",
        description:
          "Transformation rarely fails because of tools – it fails on cultural blind spots. We translate between worlds."
      },
      {
        id: "boutique",
        title: "Boutique, not a corporate machine",
        description:
          "No mass product, no junior armies. Personal, senior support for executives and organisations that want depth."
      }
    ]
  },
  difference: {
    title: "What makes us",
    highlight: "different",
    subtitle: "Honesty instead of marketing speak",
    blocks: [
      {
        id: "not",
        title: "We are not a classic consultancy",
        points: [
          "No 200-page slide decks no one ever reads.",
          "No junior consultants reciting from textbooks.",
          "No one-size-fits-all frameworks.",
          "No empty promises."
        ]
      },
      {
        id: "offer",
        title: "Instead, we offer",
        points: [
          "Personal sparring partners at eye level.",
          "Systemic thinking with consistent execution.",
          "Cultural intelligence, not just awareness workshops.",
          "Honesty: we advise and accompany – you decide."
        ]
      }
    ],
    promiseLead: "The GLOBRIDGE promise:",
    promiseText:
      "We advise and accompany with depth, expertise and cultural intelligence. The decision always stays with you. No empty promises – just honest sparring partners."
  },
  method: {
    title: "Our",
    highlight: "methodology",
    subtitle:
      "TRIAX® & Resonance Flow Framework – the synthesis of theory and practice",
    triax: {
      title: "TRIAX®",
      text:
        "Our systemic model for transformation: understanding culture, human and structure as one living system – not isolated silos.",
      linkLabel: "Learn more about TRIAX®"
    },
    rff: {
      title: "Resonance Flow Framework",
      text:
        "Our scalable methodology: 5 phases from diagnosis to anchoring – fluid, adaptive and measurable.",
      linkLabel: "Learn more about RFF"
    },
    reasonsTitle: "Why this combination?",
    reasons: [
      {
        id: "systemic",
        title: "Systemic",
        text: "TRIAX® addresses the entire system, not just individual parts."
      },
      {
        id: "scalable",
        title: "Scalable",
        text:
          "RFF makes the process repeatable and transferable across initiatives."
      },
      {
        id: "measurable",
        title: "Measurable",
        text:
          "Clear deliverables and KPIs for each phase – instead of vague impact promises."
      }
    ]
  },
  cta: {
    titleBeforeHighlight: "Ready for",
    highlight: "real transformation",
    text:
      "Let’s explore in an executive conversation whether we are the right partner for you. No sales pitch – just an honest exchange.",
    button: "Start executive dialogue"
  }
},
servicesPage: {
  hero: {
    titleLine1: "Resonance Flow Framework",
    titleHighlight: "How we work",
    subtitle:
      "Transformation as a continuous flow of resonance – deep, sustainable and adaptable. We advise and accompany. The decision always stays with you.",
    badge: "Interdisciplinary · Scalable · Repeatable"
  },
  rff: {
    titleBeforeHighlight: "The 5 core phases of",
    highlight: "Resonance Flow",
    subtitle:
      "A flow model with continuous feedback loops – adaptable to your context and governance"
  },
  servicesSection: {
    titleBeforeHighlight: "Our",
    highlight: "services in detail",
    subtitle: "Click on a service for a deeper view into approach and deliverables"
  },
  serviceDetails: {
    approachTitle: "Our approach",
    whyUsLabel: "Why us:",
    faqTitle: "Frequently asked questions",
    phaseLabel: "Phase"
  },
  cta: {
    titleBeforeHighlight: "Ready for",
    highlight: "real transformation",
    text:
      "We support you with proven methodology and cultural intelligence – without overpromising. You stay in full control of pace and decisions.",
    button: "Start executive dialogue"
  },
  services: [
    {
      id: "change-management",
      title: "Systemic Change Management",
      subtitle: "Resonance Flow Framework in action",
      intro:
        "As a Change Management Consultant certified under ISO-EN-17024, with academic and practical experience, we guide your organisation through systemic transformation.",
      description:
        "Transformation is more than process optimisation. We address the entire system – culture, structure and people as one living organism. Our Resonance Flow Framework (RFF) combines TRIAX® with adapted Scrum/Agile, cross-cultural business insights and tailored coaching.",
      approach: [
        {
          phase: "Mandate clarification & resonance diagnosis",
          description:
            "We clarify the change mandate and diagnose systemic blockers. Using design thinking and TRIAX®-based analysis, we create clarity for executives.",
          deliverables: [
            "Resonance scan (culture, people, structure)",
            "Stakeholder interviews",
            "Change readiness assessment",
            "Cross-cultural analysis (based on Hofstede)"
          ]
        },
        {
          phase: "Roadmap design & coalition building",
          description:
            "We design an adaptable roadmap and build a resonance coalition across C-level and key influencers.",
          deliverables: [
            "Agile change backlog",
            "TRIAX®-integrated roadmap",
            "Stakeholder alignment workshops",
            "Resistance management plan"
          ]
        },
        {
          phase: "Execution & agile iteration",
          description:
            "In flow sprints we implement change actions – iterative, impact-driven and transparent.",
          deliverables: [
            "Two-week sprints with reviews",
            "Coaching sessions for leaders",
            "Team resilience training",
            "Continuous risk monitoring"
          ]
        },
        {
          phase: "Feedback & adjustment loops",
          description:
            "Using agile retrospectives and pulse surveys, we gather feedback and adjust the roadmap.",
          deliverables: [
            "Weekly check-ins",
            "Anonymous feedback tools",
            "Sentiment analysis",
            "Adjustment plans"
          ]
        },
        {
          phase: "Anchoring & follow-up",
          description:
            "We anchor the change through ongoing follow-up and continuous improvement.",
          deliverables: [
            "Monthly coaching calls",
            "KPI monitoring",
            "Resilience training",
            "Legacy & learning documentation"
          ]
        }
      ],
      whyUs:
        "Without systemic anchoring, up to 70% of change initiatives fail. We guide you through each phase – you decide the scope and depth.",
      faq: [
        {
          q: "How is RFF different from Kotter or classic change models?",
          a: "RFF is fluid instead of linear. We integrate TRIAX®, agile and cross-cultural lenses and adapt to your pace and governance."
        },
        {
          q: "Which organisation size is RFF suitable for?",
          a: "From 10 to 1000+ employees. The methodology scales through modular design and scope."
        }
      ]
    },
    {
      id: "business-coaching",
      title: "Business Coaching & Leadership Development",
      subtitle: "Resonant leadership for C-level executives",
      intro:
        "Leadership today is more than decision power. It is about resonance, cultural intelligence and guiding people through complexity.",
      description:
        "We accompany leaders in their development – from one-to-one executive coaching to team development. Our approach combines systemic coaching, intercultural competence and agile leadership principles.",
      approach: [
        {
          phase: "1:1 executive coaching",
          description:
            "Individual coaching for C-level leaders, focused on authentic leadership and strategic decision-making.",
          deliverables: [
            "360° feedback analysis",
            "Personal development plans",
            "Quarterly deep-dive sessions",
            "Resilience and stress management"
          ]
        },
        {
          phase: "High-performance team coaching",
          description:
            "We support teams in conflict resolution, communication and collaboration.",
          deliverables: [
            "Team diagnostics",
            "Conflict facilitation",
            "Trust-building interventions",
            "Agile team rituals"
          ]
        },
        {
          phase: "Intercultural leadership capability",
          description:
            "Especially for DACH–MENA and international teams: developing and applying cultural intelligence.",
          deliverables: [
            "Hofstede-based cultural insights",
            "Cross-cultural leadership workshops",
            "Practical behavioural guidelines",
            "Communication playbooks"
          ]
        },
        {
          phase: "Leadership in transformation phases",
          description:
            "Support for leaders during major change, focusing on resistance, energy and stakeholder engagement.",
          deliverables: [
            "Change leadership workshops",
            "Strategic sparring for executives",
            "Resilience building",
            "Continuous coaching"
          ]
        }
      ],
      whyUs:
        "Around 85% of leaders feel underprepared for global complexity. We act as sparring partners and advisors – you decide the mandate.",
      faq: [
        {
          q: "What do you mean by “resonant leadership”?",
          a: "Leadership that is emotionally and culturally attuned – no manipulation, but genuine connection and clarity."
        },
        {
          q: "How long does a coaching programme take?",
          a: "It depends on your context – from 3-month sprints to annual programmes. You define the rhythm."
        }
      ]
    },
    {
      id: "scrum-for-sales",
      title: "SCRUM for Sales",
      subtitle: "Agile sales transformation",
      intro:
        "Sales is no longer a linear pipeline. With SCRUM for Sales, we bring agile principles into commercial teams and increase speed, adaptability and conversion.",
      description:
        "We translate scrum principles (sprints, reviews, retrospectives) into sales processes. The result: teams that respond three times faster to client needs and achieve higher win rates.",
      approach: [
        {
          phase: "Sales team assessment",
          description:
            "We analyse your current sales processes and identify bottlenecks and opportunities.",
          deliverables: [
            "Sales process mapping",
            "Bottleneck analysis",
            "Team performance review",
            "Agile readiness check"
          ]
        },
        {
          phase: "Implement agile sales routines",
          description:
            "Sprint planning, daily stand-ups and sprint reviews tailored for sales teams – pragmatic and easy to adopt.",
          deliverables: [
            "Sprint setup (two-week cycles)",
            "Sales KPI dashboards",
            "Team synchronisation routines",
            "Agile sales playbook"
          ]
        },
        {
          phase: "Performance tracking & iteration",
          description:
            "We enable data-driven decisions through continuous monitoring and iteration.",
          deliverables: [
            "Real-time performance dashboards",
            "Conversion tracking",
            "Sprint retrospectives",
            "Adaptive strategy adjustments"
          ]
        },
        {
          phase: "Team coaching & enablement",
          description:
            "We enable your sales team to work in an agile and self-organised way.",
          deliverables: [
            "Agile sales trainings",
            "Coaching for sales leaders",
            "Peer-learning sessions",
            "Best-practice sharing"
          ]
        }
      ],
      whyUs:
        "Traditional sales models are too rigid for today’s markets. We bring structure, agility and clarity – without dogma.",
      faq: [
        {
          q: "Does scrum really work in sales?",
          a: "Yes – when adapted pragmatically. We use the principles, not the dogma, and translate them into sales reality."
        },
        {
          q: "Which KPIs do you focus on?",
          a: "Conversion rate, sales cycle length, team engagement and pipeline velocity – adjusted to your context."
        }
      ]
    },
    {
      id: "intercultural-intelligence",
      title: "Intercultural Business Intelligence",
      subtitle: "DACH–MENA expertise & global expansion",
      intro:
        "Global business rarely fails due to strategy – it fails due to cultural misunderstandings. We translate not only languages, but business cultures.",
      description:
        "With deep experience in DACH and MENA regions, we support companies in expansion and cross-border collaboration. Our approach combines Hofstede insights, local business know-how and practical playbooks.",
      approach: [
        {
          phase: "Cultural due diligence",
          description:
            "Before entering or scaling in a market, we analyse cultural risk and success factors.",
          deliverables: [
            "Hofstede-based country reports",
            "Local business culture briefings",
            "Risk assessments",
            "Stakeholder mapping"
          ]
        },
        {
          phase: "Intercultural communication training",
          description:
            "Hands-on workshops for teams working across cultures – immediately applicable in daily business.",
          deliverables: [
            "Cross-cultural communication workshops",
            "Behavioural playbooks",
            "Do’s & don’ts per market",
            "Role plays and simulations"
          ]
        },
        {
          phase: "Market entry strategies",
          description:
            "We design culturally aligned go-to-market strategies with local insight.",
          deliverables: [
            "Market entry playbooks",
            "Partner scouting support",
            "Negotiation strategies",
            "Access to local networks"
          ]
        },
        {
          phase: "Building multicultural teams",
          description:
            "Support in building and leading teams from diverse cultural backgrounds.",
          deliverables: [
            "Team composition advisory",
            "Onboarding programmes",
            "Conflict prevention measures",
            "Cultural leadership training"
          ]
        }
      ],
      whyUs:
        "Cultural misalignment can cost millions in lost deals and internal friction. We help you navigate with confidence and respect.",
      faq: [
        {
          q: "Which regions do you primarily focus on?",
          a: "Primarily DACH and MENA (Arabic, French, German). Other regions are possible on request."
        },
        {
          q: "How is this different from diversity & inclusion training?",
          a: "We focus on concrete business impact: deals, partnerships, team performance – not only on awareness."
        }
      ]
    }
  ]
},
signaturePage: {
  hero: {
    badge: "Premium Signature Programs",
    titleLine1: "Signature Programs",
    titleHighlight: "Transformation as a Signature Experience",
    subtitle:
      "Structured programs built on our Resonance Flow Framework – scalable, measurable, ROI-driven for both your organisation and ours."
  },
  tierLabels: {
    small: "< 50 employees",
    medium: "50-250 employees",
    large: "250-1000 employees",
    enterprise: "1000+ employees"
  },
  signaturesSection: {
    titleBeforeHighlight: "Our",
    highlight: "Signature Programs",
    subtitle:
      "Proven, structured programs – fully customisable to your context."
  },
  programDetails: {
    programFlowTitle: "Program journey",
    deliverableLabel: "DELIVERABLE:",
    includedTitle: "Included services",
    resultsTitle: "Expected outcomes",
    investmentTitle: "Investment",
    investmentSubtitle:
      "Tailored to your organisational context and scope",
    requestButton: "Request proposal",
    requestNote:
      "Receive a tailored proposal based on your specific situation and ambition level."
  },
  individualSection: {
    titleBeforeHighlight: "Services",
    highlight: "à la carte",
    subtitle:
      "Individual services outside of a full Signature Program – bookable with maximum flexibility.",
    whyNoPublicPricesTitle: "Why no public price list?",
    whyNoPublicPricesText:
      "As a boutique advisory, every engagement is tailored to your context, size and complexity. Our investment levels are aligned with your actual needs and the expected ROI. Reach out for an executive-level conversation and a bespoke proposal."
  },
  whySection: {
    titleBeforeHighlight: "Why",
    highlight: "Signature Programs",
    cards: [
      {
        title: "Proven & structured",
        text: "Clearly defined phases, tangible deliverables and transparent governance."
      },
      {
        title: "ROI-focused",
        text: "We design for measurable impact – often resulting in 3–5x ROI within 18 months."
      },
      {
        title: "Custom-fit",
        text: "A strong backbone plus full flexibility to adapt to your markets, culture and leadership style."
      }
    ]
  },
  cta: {
    titleBeforeHighlight: "Ready for your",
    highlight: "Signature Transformation",
    text:
      "Let’s explore together which program architecture fits your organisation, your leadership team and your current momentum.",
    button: "Book an executive conversation",
    dialogProgramLabel: "Executive conversation (initial)"
  },
  signatures: [
    {
      id: "resonance-foundation",
      tier: "Entry",
      title: "Resonance Foundation",
      subtitle: "Change Management Essentials",
      duration: "3 months",
      description:
        "The ideal entry point into systemic transformation. We build the foundation for sustainable change.",
      forWhom: {
        title: "Who is it for?",
        targets: [
          "Companies at the start of their first major transformation",
          "Teams with moderate but strategic change needs",
          "Organisations wanting to build change readiness",
          "SMEs looking for professional change support"
        ]
      },
      setup: {
        phase1: {
          title: "Month 1: Diagnosis & roadmap",
          activities: [
            "TRIAX®-based resonance scan",
            "Stakeholder interviews",
            "Change readiness assessment",
            "Roadmap design"
          ],
          deliverable: "Change roadmap & quick-win plan"
        },
        phase2: {
          title: "Month 2: Implementation",
          activities: [
            "Two flow sprints (2 weeks each)",
            "Stakeholder alignment workshops",
            "Resistance management",
            "Team coaching (2 sessions)"
          ],
          deliverable: "First measurable results"
        },
        phase3: {
          title: "Month 3: Anchoring",
          activities: [
            "Feedback loops",
            "Adaptation plan",
            "Follow-up coaching",
            "Documentation & playbook"
          ],
          deliverable: "Legacy box & final report"
        }
      },
      included: [
        "TRIAX® resonance diagnosis",
        "6 coaching sessions (90 minutes each)",
        "4 flow sprints with reviews",
        "Stakeholder alignment workshops",
        "Change roadmap & playbook",
        "Monthly follow-ups (3 months)",
        "Email/phone support"
      ],
      results: [
        "Clear transformation roadmap",
        "Stakeholder buy-in secured",
        "First quick wins delivered",
        "Organisational change readiness built"
      ],
      pricing: {
        small: { base: 18500, region: { dach: 18500, mena: 16500, intl: 21000 } },
        medium: { base: 32000, region: { dach: 32000, mena: 28500, intl: 36500 } },
        large: { base: 52000, region: { dach: 52000, mena: 46500, intl: 59000 } },
        enterprise: { base: 85000, region: { dach: 85000, mena: 76000, intl: 96500 } }
      }
    },
    {
      id: "resonance-accelerator",
      tier: "Professional",
      title: "Resonance Accelerator",
      subtitle: "Change + Leadership Development",
      duration: "6 months",
      description:
        "Full-scale transformation combined with leadership development – for organisations that need both depth and speed.",
      forWhom: {
        title: "Who is it for?",
        targets: [
          "Organisations in an active transformation phase",
          "Companies with a visible leadership capability gap",
          "International teams (e.g. DACH–MENA setup)",
          "Mid-sized to large organisations with scaling needs"
        ]
      },
      setup: {
        phase1: {
          title: "Months 1–2: Foundation & coalition",
          activities: [
            "Comprehensive TRIAX® diagnosis",
            "Leadership assessment (360°)",
            "Coalition-building workshops",
            "Change architecture design",
            "Executive coaching (twice per month)"
          ],
          deliverable: "Transformation architecture & leadership plan"
        },
        phase2: {
          title: "Months 3–4: Activation & iteration",
          activities: [
            "6 flow sprints",
            "Leadership development program",
            "Weekly team coaching",
            "Resistance management",
            "Cross-cultural workshops (if MENA involved)"
          ],
          deliverable: "Visible KPI improvements"
        },
        phase3: {
          title: "Months 5–6: Harmonisation & anchoring",
          activities: [
            "Feedback loops & adjustments",
            "Leadership Resonance Atelier",
            "Capability building",
            "Follow-up & sustainment"
          ],
          deliverable: "Sustained anchoring & leadership legacy"
        }
      },
      included: [
        "Everything from Foundation PLUS:",
        "Leadership assessment (360°)",
        "12 executive coaching sessions",
        "6 team-coaching sessions",
        "8 flow sprints with retrospectives",
        "Leadership development program",
        "Cross-cultural workshops (optional)",
        "Bi-weekly check-ins",
        "Priority email/phone support",
        "3 months post-program follow-up"
      ],
      results: [
        "Leadership effectiveness +60%",
        "Team engagement +50%",
        "Resistance to change −70%",
        "Transformation sustainably anchored"
      ],
      pricing: {
        small: { base: 42000, region: { dach: 42000, mena: 37500, intl: 47500 } },
        medium: { base: 68000, region: { dach: 68000, mena: 61000, intl: 77000 } },
        large: { base: 115000, region: { dach: 115000, mena: 103000, intl: 130000 } },
        enterprise: { base: 185000, region: { dach: 185000, mena: 166000, intl: 210000 } }
      }
    },
    {
      id: "resonance-transformation",
      tier: "Elite",
      title: "Resonance Transformation",
      subtitle: "Full RFF – comprehensive partnership",
      duration: "12 months",
      description:
        "The flagship transformation program. Full Resonance Flow Framework with all services, tailored for complex, multi-country transformations.",
      forWhom: {
        title: "Who is it for?",
        targets: [
          "Large organisations with complex transformation portfolios",
          "International expansion (e.g. DACH–MENA corridor)",
          "Companies running multiple parallel change initiatives",
          "C-level leaders looking for a strategic sparring partner"
        ]
      },
      setup: {
        phase1: {
          title: "Q1: Diagnosis, coalition & strategy",
          activities: [
            "Deep TRIAX® system analysis",
            "Leadership assessment & development plan",
            "Coalition-building (C-level and key players)",
            "Full change architecture incl. SCRUM4Sales integration",
            "Cross-cultural due diligence (MENA, if relevant)",
            "Weekly executive coaching"
          ],
          deliverable: "Transformation blueprint & leadership roadmap"
        },
        phase2: {
          title: "Q2–Q3: Activation & agile iteration",
          activities: [
            "12 flow sprints",
            "Monthly Leadership Resonance Atelier",
            "Team coaching & conflict facilitation",
            "SCRUM4Sales implementation",
            "Intercultural trainings",
            "Continuous feedback & adjustment"
          ],
          deliverable: "Measurable business impact & KPIs"
        },
        phase3: {
          title: "Q4: Harmonisation, scaling & legacy",
          activities: [
            "Scaling to additional teams/regions",
            "Capability building & train-the-trainer",
            "Performance optimisation",
            "Legacy documentation & playbooks",
            "Transition to internal ownership"
          ],
          deliverable: "Self-sustaining transformation & documented learnings"
        }
      },
      included: [
        "Everything from Accelerator PLUS:",
        "Dedicated strategic partner (full year)",
        "24 executive coaching sessions",
        "12 team-coaching sessions",
        "12 flow sprints with full retrospectives",
        "SCRUM4Sales full implementation",
        "Intercultural Business Intelligence (DACH–MENA)",
        "Leadership Resonance Atelier (12 sessions)",
        "Train-the-trainer program",
        "On-demand support (24/48h response)",
        "6 months post-program follow-up",
        "Annual strategic review"
      ],
      results: [
        "Transformation fully anchored and owned internally",
        "Leadership capacity +80%",
        "Successful international expansion",
        "ROI often 3–5x program investment within ~18 months"
      ],
      pricing: {
        small: { base: 95000, region: { dach: 95000, mena: 85000, intl: 108000 } },
        medium: { base: 145000, region: { dach: 145000, mena: 130000, intl: 165000 } },
        large: { base: 240000, region: { dach: 240000, mena: 215000, intl: 272000 } },
        enterprise: { base: 380000, region: { dach: 380000, mena: 342000, intl: 432000 } }
      }
    },
    {
      id: "resonance-sos",
      tier: "Crisis intervention",
      title: "Resonance SOS",
      subtitle: "Rapid intervention in acute crises",
      duration: "4–8 weeks",
      description:
        "When the system is on fire. A fast, focused intervention for acute transformation crises, team conflicts or stalled change initiatives.",
      forWhom: {
        title: "Who is it for?",
        targets: [
          "Companies in acute change or culture crisis",
          "Teams with escalating conflicts",
          "Transformation projects that have stalled or failed",
          "Leadership teams needing rapid, focused support"
        ]
      },
      setup: {
        phase1: {
          title: "Weeks 1–2: Diagnosis & crisis plan",
          activities: [
            "48-hour rapid diagnosis",
            "Crisis analysis (stakeholders, dynamics, conflicts)",
            "Immediate action plan",
            "Intensive coaching (daily availability)"
          ],
          deliverable: "Crisis plan & quick wins"
        },
        phase2: {
          title: "Weeks 3–6: Intervention & stabilisation",
          activities: [
            "Weekly intensive flow sprints",
            "Conflict facilitation and mediation",
            "Leadership sparring (up to 3x/week)",
            "Team coaching & trust building",
            "Communication strategy support"
          ],
          deliverable: "Stabilisation & renewed momentum"
        },
        phase3: {
          title: "Weeks 7–8: Transition & handover",
          activities: [
            "Stabilisation plan",
            "Handover to internal team",
            "Follow-up coaching",
            "Documentation & lessons learned"
          ],
          deliverable: "Handover and follow-up roadmap"
        }
      },
      included: [
        "48h response time",
        "Intensive on-site diagnosis (2 days)",
        "Daily availability (phone/video)",
        "10 coaching sessions",
        "4 conflict mediations",
        "Crisis communication support",
        "Prioritised access (24h)",
        "4 weeks of post-SOS follow-up"
      ],
      results: [
        "Crisis stabilised within 2–4 weeks in most cases",
        "Conflicts de-escalated",
        "Transformation back on track",
        "Leadership team regains decision-making capacity"
      ],
      pricing: {
        small: { base: 28000, region: { dach: 28000, mena: 25000, intl: 32000 } },
        medium: { base: 45000, region: { dach: 45000, mena: 40500, intl: 51000 } },
        large: { base: 68000, region: { dach: 68000, mena: 61000, intl: 77000 } },
        enterprise: { base: 95000, region: { dach: 95000, mena: 85500, intl: 108000 } }
      }
    }
  ],
  individualServices: [
    {
      service: "Systemic Change Management",
      description: "Full RFF flow – from diagnosis to anchoring",
      duration: "3–6 months",
      pricing: {
        small: { base: 22000 },
        medium: { base: 38000 },
        large: { base: 62000 },
        enterprise: { base: 98000 }
      }
    },
    {
      service: "Executive Coaching",
      description: "1:1 leadership development for senior executives",
      duration: "Per 6-session package",
      pricing: {
        small: { base: 6500 },
        medium: { base: 6500 },
        large: { base: 8500 },
        enterprise: { base: 11500 }
      }
    },
    {
      service: "SCRUM for Sales Implementation",
      description: "Setting up agile sales routines and processes",
      duration: "2–4 months",
      pricing: {
        small: { base: 18000 },
        medium: { base: 28000 },
        large: { base: 45000 },
        enterprise: { base: 72000 }
      }
    },
    {
      service: "Intercultural Business Intelligence",
      description: "DACH–MENA expansion & cross-cultural training",
      duration: "1–3 months",
      pricing: {
        small: { base: 15000 },
        medium: { base: 24000 },
        large: { base: 38000 },
        enterprise: { base: 58000 }
      }
    },
    {
      service: "Team Coaching",
      description: "Developing high-performance, resilient teams",
      duration: "Per 4-session package",
      pricing: {
        small: { base: 5500 },
        medium: { base: 7500 },
        large: { base: 9500 },
        enterprise: { base: 12500 }
      }
    },
    {
      service: "Workshop / Training (day rate)",
      description: "Tailored workshops on-site or remote",
      duration: "Per day",
      pricing: {
        small: { base: 2500 },
        medium: { base: 2500 },
        large: { base: 3500 },
        enterprise: { base: 4500 }
      }
    }
  ]
},

triaxPage: {
  hero: {
    titleBeforeHighlight: "What is",
    highlight: "TRIAX®",
    suffix: "?",
    subtitle:
      "Our systemic approach to sustainable transformation connects three core dimensions – structure, culture and people – into one coherent model."
  },
  classical: {
    title: "Classical approaches",
    text:
      "Most transformation approaches focus on a single dimension – structure, technology or people. TRIAX® was created to close exactly this gap.",
    bullets: [
      { bold: "Change managers", text: " focus mainly on processes" },
      { bold: "Coaches", text: " work primarily with individuals and teams" },
      { bold: "Culture consultants", text: " focus on values and narratives" }
    ],
    footer: "→ All working in parallel, rarely systemically connected"
  },
  triaxApproach: {
    title: "The TRIAX® approach",
    text:
      "TRIAX® makes visible how decisions in one dimension impact the others. This turns transformation from reactive fire-fighting into proactive system design.",
    highlight:
      "💡 A shift in one axis always influences the other two – whether you plan for it or not."
  },
  advantage: {
    title: "Your advantage as an executive team",
    items: [
      {
        title: "Shared reference model",
        description:
          "A precise language for complexity that aligns executives, HR, operations and change."
      },
      {
        title: "Systemic addressing",
        description:
          "Conflicts, risks and opportunities are tackled at system level, not just symptom level."
      },
      {
        title: "Sustainable impact",
        description:
          "Long-term, measurable results instead of short-term “transformation theatre”."
      }
    ]
  },
  how: {
    titleBeforeHighlight: "How",
    highlight: "TRIAX® works",
    subtitle:
      "Three dimensions – structure, culture and people – form one connected system. Move one axis and the others will respond. TRIAX® makes these dynamics visible and discussable.",
    inactiveTitle: "Click on one axis",
    inactiveSubtitle:
      "Explore how each dimension behaves – and what happens when you change structure, culture or leadership.",
    footnote:
      "The strength of the TRIAX® model lies in its systemic view: all three dimensions influence each other constantly. Changing one element will inevitably shift the entire system."
  },
  axesSection: {
    examplesTitle: "Examples:"
  },
  axes: [
    {
      id: "struktur",
      label: "What?",
      vennTitle: "Structure",
      title: "Structure axis",
      subtitle: "Processes, methods & systems",
      description:
        "Structures define how work flows through the organisation. Modern companies need agile processes, clear methods and enabling systems – not bureaucracy for its own sake.",
      examples: [
        "Agile organisational structures",
        "Efficient process design",
        "Systematic project and portfolio management",
        "Digital transformation and tooling"
      ]
    },
    {
      id: "kultur",
      label: "How?",
      vennTitle: "Culture",
      title: "Culture axis",
      subtitle: "Values, rituals & informal rules",
      description:
        "Culture is the invisible operating system of your organisation. It shapes how decisions are made, how conflict is handled and how people learn from success and failure.",
      examples: [
        "Decision-making principles and rituals",
        "Psychological safety & feedback rhythms",
        "Culture diagnostics & heatmaps",
        "Translation work between subcultures and silos"
      ]
    },
    {
      id: "mensch",
      label: "Who?",
      vennTitle: "People",
      title: "People axis",
      subtitle: "Teams, emotions & leadership",
      description:
        "People are the heartbeat of every organisation. Successful transformation requires emotional intelligence, healthy teams and leadership that resonates – not just manages.",
      examples: [
        "Strengthening emotional competence",
        "Optimising team dynamics and roles",
        "Leadership development & coaching",
        "Building readiness and energy for change"
      ]
    }
  ],
  interactionsSection: {
    title: "Systemic effects",
    subtitle:
      "All three dimensions constantly influence each other. If you move one, the entire system rebalances – either consciously or unconsciously.",
    focusLabel: "Typical focus of:"
  },
  interactions: [
    {
      from: "Culture",
      to: "People",
      title: "Culture shapes relationships",
      description:
        "Cultural intelligence defines how people relate, how trust is built and how much truth actually reaches the leadership team.",
      examples: [
        "Cultural awareness increases trust in diverse teams",
        "Psychological safety enables honest debate",
        "Intercultural teams perform better when culture is named explicitly"
      ],
      professionals:
        "HR, organisational development, senior change practitioners"
    },
    {
      from: "People",
      to: "Structure",
      title: "People stabilise structures",
      description:
        "Even the best process design fails if teams and leaders do not own it. Strong teams turn structures into lived routines.",
      examples: [
        "Strong teams co-create clear processes",
        "Leadership clarifies roles and decision rights",
        "Decision pathways are actually used – not bypassed"
      ],
      professionals: "Team leaders, project managers, coaches"
    },
    {
      from: "Structure",
      to: "Culture",
      title: "Structures shape behaviour",
      description:
        "Incentives, governance and reporting lines send powerful signals. They can foster openness and trust – or drive fear and politics.",
      examples: [
        "Clear structures increase transparency",
        "Fair governance builds trust",
        "Misaligned structures create hidden resistance and shadow politics"
      ],
      professionals:
        "Change managers, process engineers, governance & compliance experts"
    }
  ],
  professionalsSection: {
    titleBeforeHighlight: "What different",
    highlight: "professional roles focus on",
    differenceText:
      "The difference with TRIAX®: instead of working in isolated streams, we integrate all three dimensions into one systemic transformation roadmap."
  },
  professionals: [
    {
      id: "change-manager",
      role: "Change managers",
      focus: "Structure & process",
      description:
        "Focus on process optimisation, organisational structures and systematic implementation of change initiatives."
    },
    {
      id: "coaches",
      role: "Coaches",
      focus: "People & leadership",
      description:
        "Work with emotional intelligence, team dynamics and personal development on individual and group level."
    },
    {
      id: "triax-consultants",
      role: "TRIAX® consultants",
      focus: "Systemic integration",
      description:
        "Connect structure, culture and people to design coherent, sustainable transformation instead of isolated projects."
    }
  ],
  benefitsSection: {
    titleBeforeHighlight: "Why",
    highlight: "TRIAX®?"
  },
  benefits: [
    {
      id: "systemic",
      title: "Systemic by design",
      description:
        "A holistic lens on structure, culture and people – instead of local optimisation in one silo."
    },
    {
      id: "scientific",
      title: "Evidence-informed",
      description:
        "Grounded in systemic thinking, intercultural research and more than a decade of international practice."
    },
    {
      id: "practical",
      title: "Battle-tested in practice",
      description:
        "Applied in complex transformation programmes on C-level and board level across different industries."
    },
    {
      id: "sustainable",
      title: "Sustainable impact",
      description:
        "Built for long-term behavioural and cultural shifts – not just for the next slide deck."
    }
  ],
  cta: {
    titleBeforeHighlight: "Ready for",
    highlight: "systemic transformation",
    text:
      "Let’s explore how TRIAX® could support your organisation – in a conversation that is honest, strategic and free of hype.",
    button: "Start TRIAX® conversation"
  }
},

sosPage: {
  hero: {
    badge: "Strategic emergency response",
    highlight: "SOS",
    titleLine: "When 48 hours decide the next months",
    subtitle:
      "For situations that cannot wait: crisis management, deal support and transformation under pressure.",
    bullets: ["Immediate response", "Crisis management", "Laser-focused"]
  },
  packagesSection: {
    title: "SOS",
    highlight: "packages",
    subtitle:
      "Three proven emergency offerings for different critical situations.",
    footnote: "*Duration may vary depending on team size"
  },
  labels: {
    urgent: "URGENT"
  },
  packages: [
    {
      id: "culturebridge",
      title: "CultureBridge MENA",
      badge: "24h response time",
      duration:
        "1 day of training + 3 weeks of coaching + 1 culture playbook",
      description:
        "For DACH-based companies preparing to do business with Arab partners.",
      features: [
        "Intercultural do’s & don’ts plus deep dive into mindsets",
        "Business etiquette, communication styles, negotiation culture",
        "Hands-on preparation for meetings and negotiations",
        "Culture playbook for lasting success"
      ]
    },
    {
      id: "scrum4sales",
      title: "Scrum4Sales Sprint",
      badge: "48h response time",
      duration: "12 weeks of agile coaching & on-the-job support",
      description: "For sales organisations in transition.",
      features: [
        "Implementation of agile sales rhythms (planning, review, retro)",
        "Culture shift & accountability architecture in sales",
        "Team alignment and transparency tools",
        "Continuous optimisation of sales processes"
      ]
    },
    {
      id: "change-sparring-6",
      title: "Change Sparring 6",
      badge: "Slot confirmed within 24h",
      duration: "6 months of 1:1 executive sparring",
      description:
        "For executives navigating critical transformation phases.",
      features: [
        "Systemic analysis, roadmap and role clarification",
        "Conflict navigation & resonance spaces",
        "Weekly sparring sessions",
        "Emergency support for critical situations"
      ]
    }
  ],
  actions: {
    requestSOS: "Request SOS now"
  },
  resultsSection: {
    titleBeforeHighlight: "Proven",
    highlight: "results",
    subtitle:
      "Our SOS packages create measurable impact in a very short timeframe."
  },
  results: [
    { id: "productivity", metric: "+40%", label: "productivity" },
    { id: "revenue", metric: "+35%", label: "revenue" },
    { id: "delays", metric: "-50%", label: "delays" },
    {
      id: "decisions",
      metric: "+60%",
      label: "better decisions"
    }
  ],
  process: {
    titleBeforeHighlight: "How",
    highlight: "SOS works",
    steps: [
      {
        title: "Immediate contact",
        text:
          "A call or email is enough. We respond within 24–48 hours."
      },
      {
        title: "Rapid assessment",
        text:
          "Short, sharp assessment of the situation plus immediate recommendations."
      },
      {
        title: "Immediate implementation",
        text:
          "Direct start of the intervention using proven SOS methods."
      }
    ]
  },
  contact: {
    titleBeforeHighlight: "Is your situation",
    highlight: "critical",
    text:
      "Don’t hesitate. Every hour can make a difference. Our SOS experts are ready to support you immediately.",
    bullets: [
      "24/7 availability",
      "Crisis-tested experts",
      "Immediate impact"
    ],
    hotlineButton: "Emergency hotline: +49 xxx xxx xxx",
    emailButton: "Email: sos@globalegroupe.de"
  }
},
contactPage: {
  hero: {
    highlight: "Transformation",
    titleRest: "doesn’t start with a kick-off",
    subtitle: "It starts with an honest conversation.",
    bullets: ["24h response time", "Confidential", "Personal"]
  },
  form: {
    titleBeforeHighlight: "Let’s",
    highlight: "talk",
    nameLabel: "Name",
    namePlaceholder: "Your name",
    companyLabel: "Company",
    companyPlaceholder: "Your company",
    emailLabel: "Email",
    emailPlaceholder: "your@email.com",
    phoneLabel: "Phone",
    phonePlaceholder: "+49 xxx xxx xxx",
    topicLabel: "Select topic",
    topicPlaceholder: "Please select",
    messageLabel: "Your message",
    messagePlaceholder: "Tell us about your challenge...",
    submitLabel: "Send message",
    footerText:
      "We respond within 24 hours. Your information is treated confidentially.",
    topics: [
      "TRIAX® transformation",
      "Request SOS package",
      "Signature solution",
      "Intercultural advisory",
      "Leadership coaching",
      "Initial consultation",
      "Other topic"
    ]
  },
  contactInfo: {
    titleBeforeHighlight: "Direct",
    highlight: "contacts",
    emailLabel: "Email",
    email: "hello@globalegroupe.com",
    linkedinLabel: "LinkedIn",
    linkedin: "linkedin.com/company/globalegroupe",
    hotlineLabel: "SOS hotline",
    hotlineNumber: "+49 xxx xxx xxx",
    hotlineNote: "For urgent cases"
  },
  why: {
    title: "Why GloBridge?",
    bullets: [
      "First brief assessment within 24 hours",
      "Complimentary initial consultation (30 minutes)",
      "Strictly confidential handling of all information",
      "Concrete recommendations, not theory decks"
    ]
  },
  locations: {
    titleBeforeHighlight: "Our",
    highlight: "locations",
    subtitle: "DACH · Africa · GCC – wherever you need us"
  },
  offices: [
    {
      region: "DACH",
      city: "Frankfurt am Main",
      address: "Bockenheimer Landstraße 123, 60325 Frankfurt",
      phone: "+49 69 123 456 789",
      email: "dach@globalegroupe.com",
      gradient: "from-purple-600 to-blue-600"
    },
    {
      region: "MENA",
      city: "Dubai",
      address: "DIFC, Gate Village 10, Level 5, Dubai",
      phone: "+971 4 123 456 789",
      email: "mena@globalegroupe.com",
      gradient: "from-orange-500 to-red-500"
    },
    {
      region: "North Africa",
      city: "Casablanca",
      address: "Twin Center, Tour A, Angle Boulevards",
      phone: "+212 522 123 456",
      email: "africa@globalegroupe.com",
      gradient: "from-emerald-500 to-teal-600"
    }
  ],
  finalCTA: {
    titleBeforeHighlight: "Ready for the",
    highlight: "first step",
    text:
      "Transformation starts with a conversation. Let’s explore how we can bring your organisation into resonance.",
    primaryButton: "Book a meeting",
    secondaryButton: "Free initial consultation"
  }
},
insightsPage: {
  hero: {
    chipLabel: "Success stories & insights",
    titleHighlight: "Insights",
    titleRest: "Learning from real practice",
    subtitle:
      "Real projects, measurable outcomes, authentic client voices. Discover how TRIAX® and our signature solutions transform organisations."
  },
  tabs: {
    successStories: "Success stories",
    caseStudies: "Case studies",
    blogPlanned: "Blog (coming soon)"
  },
  labels: {
    challenge: "Challenge",
    solution: "Solution",
    results: "Results in numbers"
  },
  metrics: {
    timeline: "Timeline",
    roi: "ROI",
    satisfaction: "Satisfaction"
  },
  caseStudies: [
    {
      title: "Resolving an intercultural breakdown",
      category: "CultureBridge MENA",
      duration: "3 months",
      challenge:
        "A German automotive supplier struggled to expand into MENA due to cultural barriers and repeated misunderstanding.",
      solution:
        "TRIAX®-based cultural analysis and a tailored CultureBridge programme.",
      results: [
        "150% revenue increase in the MENA region",
        "85% fewer negotiations breaking down",
        "Successful partnerships with 3 local distributors"
      ],
      quote:
        "\"CultureBridge not only saved our business – it opened up an entire region for us.\"",
      author: "CEO, automotive supplier (DAX)",
      metrics: {
        timeline: "6 months",
        roi: "400%",
        satisfaction: "9.8/10"
      },
      image:
        "https://images.unsplash.com/photo-1552084850-c6a1fc7cf717?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzU2MjQ4MzUzfDA&ixlib=rb-4.1.0&q=85"
    },
    {
      title: "Restarting a stalled reorganisation",
      category: "Change Sparring 6",
      duration: "6 months",
      challenge:
        "A reorganisation in a fintech start-up triggered resistance, friction and visible productivity loss.",
      solution:
        "Structured Change Sparring for the leadership team using the TRIAX® methodology.",
      results: [
        "60% increase in employee engagement",
        "40% reduction in turnover",
        "Reorganisation successfully completed"
      ],
      quote:
        "\"Without Change Sparring we would not have made it. The sparring was the key success factor.\"",
      author: "Managing Director, FinTech",
      metrics: {
        timeline: "6 months",
        roi: "250%",
        satisfaction: "9.5/10"
      },
      image:
        "https://images.unsplash.com/photo-1675392347224-ae88c11def9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      title: "Sales becomes agile – and wins",
      category: "Scrum4Sales Sprint",
      duration: "12 weeks",
      challenge:
        "A traditional B2B sales organisation struggled with long sales cycles and low team performance.",
      solution:
        "Scrum4Sales implementation with agile rhythms, transparency tools and clear sprint structures.",
      results: [
        "45% shorter sales cycles",
        "70% increase in close rate",
        "80% higher team productivity"
      ],
      quote:
        "\"Scrum4Sales has transformed our sales team. We finally operate as one high-performing unit.\"",
      author: "Head of Sales, B2B software",
      metrics: {
        timeline: "3 months",
        roi: "320%",
        satisfaction: "9.7/10"
      },
      image:
        "https://images.unsplash.com/photo-1743842768257-e897326cd11e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85"
    }
  ],
  summary: {
    titleBeforeHighlight: "Consolidated",
    highlight: "results",
    stats: [
      {
        metric: "50+",
        label: "Projects successfully delivered"
      },
      {
        metric: "95%",
        label: "Client satisfaction"
      },
      {
        metric: "300%",
        label: "Average ROI"
      },
      {
        metric: "15",
        label: "Countries & markets"
      }
    ]
  },
  yourStory: {
    titleBeforeHighlight: "Ready to create",
    highlight: "your success story",
    text:
      "These outcomes are not random. They are the result of systematic work with TRIAX® and our signature solutions. Let’s co-create your next success story.",
    tiles: [
      {
        title: "Proven",
        text: "More than 50 successful transformations."
      },
      {
        title: "Measurable",
        text: "On average, 300% return on investment."
      },
      {
        title: "Sustainable",
        text: "95% long-term client satisfaction."
      }
    ],
    buttonLabel: "Start your story"
  }
},

markets: {
  badgeLabel: 'Global excellence',
  titleBeforeHighlight: 'Markets &',
  highlight: 'industries',
  description:
    'We partner with organisations in selected regions where we truly understand the cultural, political and business context – beyond the surface level.',
  connectionText:
    'Our global presence enables seamless intercultural bridges.',
  regions: [
    {
      name: 'DACH',
      countries: ['Germany', 'Austria', 'Switzerland'],
      image:
        'https://images.unsplash.com/photo-1617375402484-8a196422d93d?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      monument: 'Berlin Cathedral - German architecture',
      specialty: 'Precision & efficiency',
      gradient: 'from-slate-600 to-blue-600',
      description: 'The core of European business excellence.'
    },
    {
      name: 'Middle East',
      countries: ['UAE', 'Saudi Arabia', 'Qatar'],
      image:
        'https://images.unsplash.com/photo-1653763843954-0ad7300268a6?q=80&w=435&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      monument: 'Emirates Towers & Museum of the Future',
      specialty: 'Partnership & trust',
      gradient: 'from-orange-500 to-amber-500',
      description: 'Where tradition meets innovation.'
    },
    {
      name: 'North Africa',
      countries: ['Morocco', 'Tunisia', 'Egypt'],
      image:
        'https://images.unsplash.com/photo-1699210260021-eac11ba4ff86?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      monument: 'Casablanca Hassan II Mosque ',
      specialty: 'Tradition & innovation',
      gradient: 'from-emerald-600 to-teal-600',
      description: 'A cultural bridge between continents.'
    }
  ]
}, 

expertise: {
  badgeElite: "Elite services",
  title: "Our",
  titleHighlight: "signature expertise",
  description:
    "GLOBRIDGE brings together systemic change management, cultural intelligence and executive sparring in a curated premium portfolio.",
  subDescription:
    "Four signature services, one logic: deep, measurable transformation instead of slideware.",

  services: [
    {
      id: "change-management",
      iconName: "Zap",
      background:
        "https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-purple-600 to-blue-600",
      title: "Systemic change management",
      subtitle: "Resonance Flow Framework",
      description:
        "End-to-end support for complex transformations – from diagnosis to anchoring.",
      features: [
        "TRIAX®-based diagnosis of culture, structure and people",
        "Resonance Flow Framework across 5 phases",
        "C-level sparring and stakeholder alignment",
        "Clear deliverables and KPIs for each phase"
      ],
      href: "/services",
      cta: "Explore our change approach"
    },
    {
      id: "leadership-coaching",
      iconName: "Users",
      background:
        "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-emerald-500 to-teal-600",
      title: "Leadership & executive coaching",
      subtitle: "Resonance for C-level",
      description:
        "Sparring for decision-makers navigating high-stakes transformation.",
      features: [
        "1:1 executive coaching for C-level and top talent",
        "Leadership development in transformation phases",
        "Resilience, clarity and decision-making power",
        "Confidential sparring at eye level"
      ],
      href: "/services",
      cta: "Strengthen leadership"
    },
    {
      id: "scrum4sales",
      iconName: "Target",
      background:
        "https://images.unsplash.com/photo-1556740749-887f6717d7e4?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-orange-500 to-red-500",
      title: "Scrum4Sales sprint",
      subtitle: "Agile sales",
      description:
        "We turn sales teams into fast, adaptive and data-driven units.",
      features: [
        "Agile rhythms for sales teams (sprints, reviews, retros)",
        "Transparent pipeline and shared prioritisation",
        "Data-driven decisions instead of gut feeling",
        "Enablement for self-managed, accountable teams"
      ],
      href: "/services",
      cta: "Discover Scrum4Sales"
    },
    {
      id: "culturebridge-mena",
      iconName: "Star",
      background:
        "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-violet-500 to-purple-600",
      title: "CultureBridge MENA",
      subtitle: "Intercultural business intelligence",
      description:
        "Building DACH–MENA bridges for expansion, critical deals and joint ventures.",
      features: [
        "Targeted preparation for DACH–MENA business settings",
        "Do’s & don’ts, negotiation codes and decision logics",
        "Support for critical deals and key partnerships",
        "Culture handbook and practical playbooks for your teams"
      ],
      href: "/sos",
      cta: "Explore CultureBridge"
    }
  ],

  dna: {
    badge: "GLOBRIDGE DNA",
    titleBeforeHighlight: "What makes us part of the",
    titleHighlight: "top 1%",
    titleAfterHighlight: "of advisory boutiques",
    description:
      "Four pillars of excellence form our TRIAX® system – systemic, culturally intelligent, measurably effective.",

    systemicDepth: {
      title: "Systemic depth",
      line1: "We transform entire systems,",
      line2: "not just visible symptoms.",
      chip: "TRIAX® methodology"
    },
    culturalIntelligence: {
      title: "Cultural intelligence",
      line1: "We translate seamlessly between",
      line2: "cultures and markets.",
      chip: "DACH × MENA"
    },
    humanResonance: {
      title: "Human resonance",
      line1: "We create emotional connection,",
      line2: "not just strategies on slides.",
      chip: "Resonance leadership"
    },
    measurableImpact: {
      title: "Measurable impact",
      line1: "We commit to verifiable",
      line2: "results and clear ROI.",
      chip: "Performance evidence"
    }
  },

  cta: {
    questionBeforeHighlight: "Ready to move your transformation to",
    highlight: "top-1% elite level",
    button: "Book an executive consultation"
  }
},

readiness: {
  title: 'Transformation readiness check',
  subtitle: 'Assess how ready your organisation really is for change.',

  scoreLabel: 'Readiness score',

  levelHigh: 'High',
  levelMedium: 'Medium',
  levelLow: 'Low',

  messageHigh:
    'Your organisation is ready. Focus on optimisation, scaling and prioritising the right bets.',
  messageMedium:
    'Solid foundation. We recommend targeted coaching and selective change interventions.',
  messageLow:
    'Intensive guidance recommended. We start with a resonance diagnosis and a clear transformation roadmap.',

  questions: {
    vision: {
      question: 'How clear is your transformation vision within the team?',
      options: {
        veryClear: 'Very clear',
        partlyClear: 'Partly clear',
        unclear: 'Unclear',
        noVision: 'No vision'
      }
    },
    resistance: {
      question: 'How strong is the resistance to change?',
      options: {
        veryLow: 'Very low',
        moderate: 'Moderate',
        high: 'High',
        veryHigh: 'Very high'
      }
    },
    culture: {
      question:
        'Do you experience cultural challenges (for example DACH–MENA collaboration)?',
      options: {
        none: 'No',
        few: 'A few',
        some: 'Some',
        many: 'Many'
      }
    },
    salesAgility: {
      question: 'How agile is your sales team working today?',
      options: {
        veryAgile: 'Very agile',
        partlyAgile: 'Partly agile',
        traditional: 'Traditional',
        rigid: 'Rigid'
      }
    }
  }
},
    footer: {
      claim: "Resonance space consulting – Where change works. And doesn't just look like work."
    }
  },
  
  ar: {
    // Navigation
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      triax: "TRIAX®",
      services: "خدماتنا", 
      signature: "برامجنا المميزة",
      sos: "الدعم الفوري",
      insights: "رؤى",
      contact: "تواصل معنا"
    },
    navDropdown: {
  services: {
    change: {
      title: "تغيير بلا قوالب جاهزة",
      description: "إدارة تغيير منهجية ومصممة خصيصاً، بعيداً عن النماذج العامة الجاهزة."
    },
    bridges: {
      title: "أعمال بين العوالم",
      description: "ذكاء متعدد الثقافات لشراكات عملية بين أسواق مختلفة وحدود ثقافية متباينة."
    },
    scrum4sales: {
      title: "SCRUM للمبيعات",
      description: "رؤية جديدة للمبيعات الرشيقة – سبرنتات، تركيز، وزخم حقيقي لإغلاق الصفقات."
    },
    leadership: {
      title: "مرسم رنين القيادة",
      description: "تدريب وسبرنت تفكير للقيادات والإكسبات في بيئات عالية التعقيد."
    }
  },
  signature: {
    foundation: {
      title: "Resonance Foundation",
      description: "أساسيات إدارة تغيير مستدامة وقابلة للقياس."
    },
    accelerator: {
      title: "Resonance Accelerator",
      description: "دمج مسار التحول مع تطوير القيادة ضمن منظومة واحدة."
    },
    transformation: {
      title: "Resonance Transformation",
      description: "Full RFF – مرافقة شاملة لرحلة التحول من البداية حتى تحقيق الأثر."
    },
    sos: {
      title: "Resonance SOS",
      description: "تدخل سريع ودقيق في لحظات الأزمات والتحول الحاد."
    }
  },
  insights: {
    successStories: {
      title: "قصص نجاح",
      description: "دراسات حالة بأرقام وأثر حقيقي ورؤى تنفيذية."
    },
    caseStudies: {
      title: "دراسات حالة",
      description: "قراءة متعمقة لمشاريع التحول وهندسة المنظومات."
    },
    blog: {
      title: "المدونة",
      description: "أفكار استراتيجية وتأملات قيادية (قريباً)."
    }
  }
},
    // Welcome Section - Dubai C-Level Adapted
    welcome: {
      title: "مرحباً بكم في GLOBRIDGE",
      subtitle: "شريككم في التحول المؤسسي والذكاء متعدد الثقافات. نبني جسوراً بين العوالم - ثقافياً، تقنياً، إنسانياً.",
      card1: {
        title: "نموذج TRIAX®",
        description: "نموذج التحول متعدد الثقافات: بين النظام والإنسان، بين الاستراتيجية والتأثير"
      },
      card2: {
        title: "أعمال بين العوالم",
        description: "تعاون ناجح عبر الحدود الثقافية. جسور بين منطقة DACH والشرق الأوسط وشمال أفريقيا"
      },
      card3: {
        title: "خدمات متميزة ودعم فوري",
        description: "حلول مصممة خصيصاً ومساعدة فورية لعمليات التغيير المستدامة وأزمات التحول العاجلة"
      },
      cta: "ابدأ الحوار التنفيذي"
    },
    // Silent Epidemic New Section - Dubai Business Context
    silentEpidemicNew: {
      title: "التحدي الصامت في المؤسسات الرائدة",
      subtitle: "بينما يتحدث الجميع عن التحول الرقمي، تفشل 70% من مشاريع التغيير. لماذا؟ لأن العنصر البشري يُنسى.",
      stat1: "من مشاريع التغيير تفشل بسبب تجاهل العوامل الثقافية والبشرية",
      stat2: "تُهدر سنوياً بسبب التحولات الفاشلة",
      stat3: "من القادة يشعرون بعدم الاستعداد للأعمال الدولية",
      billion: "مليار",
      bottomTitle: "المشكلة ليست في التقنية. إنها في التنفيذ.",
      bottomDescription: "بين الرؤية والواقع، بين القيادة والفريق، بين الثقافات والأسواق. نحن المترجمون لهذه اللغات غير المرئية."
    },
    // Hero Slider
    hero: {
slide1: {
  headline: "التحول     ليس مجرد مشروع. إنه لغة نتقنها.",
  subheadline: "نتحدثها بسلاسة لنربط بين الأنظمة والعنصر البشري، بين الاستراتيجية والأثر المستدام، وبين مناطق DACH والشرق الأوسط وشمال أفريقيا.",
  claim: "حيث تلتقي الاستراتيجية بالبعد الإنساني، وتحقق المشاريع تأثيرًا يدوم.",
  cta: "حجز استشارة مجانية"
},
slide2: {
  headline: "الكفاءة الثقافية العابرة     نبني جسورًا حيث يواجه الآخرون حواجز.",
  subheadline: "الميزة التنافسية الهادئة التي تغير المعادلة.",
  cta: "اكتشف المزيد"
},
slide3: {
  headline: "TRIAX®      إطارنا الحصري للتحول المتكامل.",
  subheadline: "نهج علمي مدعوم يجمع بين الهيكل والثقافة والعنصر البشري بشكل منهجي لتغييرات حقيقية ومستدامة.",
  cta: "استكشف TRIAX®"
},
slide4: {
  headline: "Scrum4Sales     إعادة تصميم المبيعات  تعاونية، مرنة، فائزة.",
  subheadline: "المرونة التي تحول الصفقات إلى نجاحات.",
  cta: "حجز استشارة مجانية"
}
    },
    silentEpidemic: {
      badge: "الوباء الصامت",
      title: "نعيش في لحظة تسرّع كل شيء وتشلّه في الوقت نفسه.",
      description1: "الرقمنة والذكاء الاصطناعي ووسائل التواصل الاجتماعي والتوترات العالمية لا تغير الأسواق فقط.",
      description1Highlight: "إنها تغير البشر.",
      description2: "الفرق تتفكك، والقيادة تصبح عملاً بطولياً، والثقافات تتصادم، وخلف كل عملية يقف إنسان عليه أن يقرر ويقود ويعمل.",
      description3: "ومع ذلك يشعر الكثيرون: نحتاج شيئاً لا يمكن قياسه. أعمق. أصدق. شيء مفقود.",
      description4: "ليس خطة أو أداة أو استراتيجية أخرى. بل ما يقع بينها.",
      description5: "بين ما يمكن أن يكون ممكناً – وما يبقى واقعاً.",
      quote: "هذه هي مفارقة الأعمال الحديثة: كلما ارتفع صوت التكنولوجيا، خف صوت العبقرية البشرية.",
      imageQuote: "GLOBRIDGE تنشر التحول مثل عطر راقٍ:",
      imageQuoteHighlight: "عميق، دقيق، دائم.",
      imageSignature: "الرنين هو عطرنا المميز.",
      bottomTitle1: "نحن لا نبني استراتيجيات.",
      bottomTitle2: "نبني رنيناً.",
      bottomDescription: "نظام ثلاثي غير مرئي من الثقافة والإنسان والهيكل – مضبوط بدقة، مؤلف بشجاعة، محسوس في كل حركة.",
      cta1: "حدد موعد محادثة",
      cta2: "اكتشف TRIAX"
    },
    expertise: {
      title: "تحريك التأثير",
      titleHighlight: "نحو الحركة",
      description: "أربعة أعمدة قوية لا تعد بالتحول فحسب – بل تقدمه بشكل قابل للقياس. مفكرة بشكل منهجي، ذكية ثقافياً، فعالة إنسانياً.",
      subDescription: "هذه ليست استشارة عادية. هذا تأثير في أذكى أشكاله.",
      services: [
        {
          id: 'change',
          iconName: 'Zap',
          title: 'إدارة التغيير المنهجي',
          subtitle: 'تحول بعمق',
          description: 'تغيير لا يعمل سطحياً فقط، بل يترسخ منهجياً.',
          features: [
            'التغيير الثقافي',
            'التكامل الهيكلي',
            'القبول البشري',
            'الترسيخ المستدام'
          ],
          background: 'https://images.unsplash.com/photo-1709221387675-403ac1a6003a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBhYnN0cmFjdHxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NTY0ODQwNDJ8MA&ixlib=rb-4.1.0&q=85',
          cta: 'اكتشف إدارة التغيير',
          href: '/services#service-0',
          gradient: 'from-purple-600 to-blue-600'
        },
        {
          id: 'coaching',
          iconName: 'Users',
          title: 'التدريب المؤسسي',
          subtitle: 'تميز القيادة',
          description: 'تطوير تنفيذي على أعلى مستوى لنتائج مستدامة.',
          features: [
            'التدريب التنفيذي',
            'تطوير الفريق',
            'رنين القيادة',
            'دفع الأداء'
          ],
          background: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
          cta: 'اكتشف برنامج التدريب',
          href: '/services#service-1',
          gradient: 'from-emerald-500 to-teal-600'
        },
        {
          id: 'sales',
          iconName: 'Target',
          title: 'SCRUM للمبيعات',
          subtitle: 'ثورة المبيعات الرشيقة',
          description: 'تحويل فرق المبيعات بطريقة رشيقة لمعدلات إغلاق أعلى قابلة للقياس.',
          features: [
            'منهجية المبيعات الرشيقة',
            'تزامن الفريق',
            'تتبع الأداء',
            'دفع التحويل'
          ],
          background: 'https://images.unsplash.com/photo-1629471361722-e1306b0c0e42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw1fHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85',
          cta: 'اختبر Scrum4Sales',
          href: '/services#service-2',
          gradient: 'from-orange-500 to-red-500'
        },
        {
          id: 'intercultural',
          iconName: 'Star',
          title: 'الذكاء التجاري المتعدد الثقافات',
          subtitle: 'تميز التوسع العالمي',
          description: 'بناء جسور ثقافية للأعمال العالمية الناجحة.',
          features: [
            'خبرة منطقة الشرق الأوسط وشمال أفريقيا',
            'الذكاء الثقافي',
            'استراتيجية دخول السوق',
            'الفرق متعددة الثقافات'
          ],
          background: 'https://images.unsplash.com/photo-1672664003230-106aa4f534c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85',
          cta: 'اكتشف الذكاء العالمي',
          href: '/services#service-3',
          gradient: 'from-violet-500 to-purple-600'
        }
      ]
    },
    markets: {
      title: "الأسواق و",
      description: "DACH · الشرق الأوسط · شمال أفريقيا – حيث تحسم الكفاءة الثقافية."
    },
    // Triax Section
    triaxSection: {
      title: "ما هو ولماذا TRIAX®؟",
      classical: "الاستشارة الكلاسيكية تفصل الصوامع",
      classicalDesc: "العملية ↔ الثقافة ↔ الإنسان منفصلة.",
      triax: "TRIAX® يدمج بشكل شامل",
      triaxDesc: "السلوك والعمليات والأداء كنظام واحد.",
      highlights: [
        "زيادة مؤشرات الأداء من خلال محاذاة النظام",
        "نظام إنذار مبكر للعوائق",
        "الشفافية حول الترابط"
      ],
      cta: "لا نبيع خدمات، نقدم تحولات."
    },
    // For Whom Section
    forWhom: {
      title: "للمؤسسات الرائدة والطموحة",
      subtitle: "هذا ليس موقع إلكتروني تقليدي. هذا تقييم استراتيجي لاستعدادكم.",
      intro: "إذا انطبقت 3+ نقاط من التالي، فمؤسستكم مهيأة للشراكة معنا:",
      points: [
        "تطبقون تقنيات الذكاء الاصطناعي المتقدمة، لكن اجتماعاتكم تفتقر للحيوية والتفاعل الحقيقي أكثر من أي وقت مضى.",
        "مشاريع التوسع تحقق نتائج مالية ممتازة، لكنها تشعر وكأنها استحواذات بدلاً من شراكات استراتيجية.",
        "حاصلون على شهادات في المنهجيات الرشيقة \"Agile\" - لكن الهيكل التنظيمي لا يزال يعمل بأساليب الثمانينيات.",
        "فريقكم يتحدث ست لغات مختلفة - باستثناء لغة التفاهم المتبادل والتواصل الفعال.",
        "تقرؤون هذا النص بنبض متسارع وإدراك تدريجي لحقائق مؤسستكم."
      ],
      notFor: "المؤسسات التي لا نتعامل معها:",
      notForDesc: "البحث عن حلول سطحية · مشاريع للإنجاز الشكلي فقط · التفكير في المهام المنعزلة بدلاً من الرحلة الشاملة · الافتقار للشجاعة في مواجهة الحقائق المؤسسية.",
      whyDifferent: "ما يميزنا عن غيرنا:",
      whyDifferentDesc: "الدقة الأوروبية × الحكمة الشرقية الأصيلة · العمق الفكري × البراغماتية التطبيقية · طرح الأسئلة الجوهرية بدلاً من الحلول الجاهزة · مدرب/شريك استراتيجي/مترجم ثقافي."
    },
    // Markets Section
    markets: {
      title: "الأسواق والمناطق",
      subtitle: "حيث نبني الجسور",
      dach: {
        title: "DACH",
        description: "ألمانيا، النمسا، سويسرا - دقة أوروبية مع ذكاء ثقافي"
      },
      mena: {
        title: "MENA",
        description: "الشرق الأوسط وشمال أفريقيا - فهم ثقافي عميق وشبكات محلية"
      },
      international: {
        title: "دولي",
        description: "التوسع العالمي مع حساسية ثقافية"
      }
    },
    // About Page - Complete
    about: {
      hero: {
        badge: "الهوية والأصل",
        title: "وُلدنا بين العوالم.",
        titleHighlight: "بُنينا للعوالم.",
        subtitle: "لم تُؤسس GLOBRIDGE لبيع الاستشارات التقليدية. بل لملء فراغ لا يراه الآخرون.",
        quote: "بين النظام والإنسان. بين الاستراتيجية والتأثير. بين الثقافات والأسواق."
      },
      story: {
        title: "من",
        titleHighlight: "نحن",
        paragraph1: "GLOBRIDGE ليست شركة بالمعنى التقليدي. إنها خلاصة رحلة شخصية - نشأت بين الثقافات، تدربت أكاديمياً، أُثبتت عملياً.",
        paragraph2: "كمستشار معتمد في إدارة التغيير ISO-EN-17024، مع خلفية أكاديمية في الأعمال الدولية والدراسات متعددة الثقافات، وخبرة عملية كمدير تسليم المشاريع، تعلمت درساً مبكراً:",
        quote: "التحول لا يفشل بسبب الأدوات. يفشل لأن الإنسان يُنسى.",
        paragraph3: "كثيراً ما رأيت استراتيجيات رائعة تنهار بسبب الجهل الثقافي، أو المقاومة الداخلية، أو غياب الاستماع. لذا نشأت GLOBRIDGE كمتجر متخصص للتحول المنهجي - بعمق، وليس بكميات.",
        paragraph4: "ليس لإعادة اختراع الاستشارات. بل لملء الفراغ بين النظام والروح، بين الهيكل والإنسانية."
      },
      credentials: {
        title: "الأساس",
        titleHighlight: "والاعتمادات",
        subtitle: "ليس لأننا نجمع الشهادات، بل لأن التميز يحتاج معايير"
      },
      cta: {
        title: "مستعدون",
        titleHighlight: "للتحول الحقيقي؟",
        description: "دعونا نكتشف في حوار تنفيذي ما إذا كنا مناسبين لبعضنا. لا محادثات بيع، فقط تبادل صادق.",
        button: "ابدأ الحوار التنفيذي"
      }
    },
    // Contact Page - Complete
    contact: {
      title: "لنبدأ",
      titleHighlight: "الحوار",
      subtitle: "التحول الحقيقي يبدأ بمحادثة صادقة. دعونا نكتشف معاً ما إذا كنا الشريك المناسب لكم.",
      form: {
        name: "الاسم الكامل",
        namePlaceholder: "د. أحمد الشريف",
        email: "البريد الإلكتروني",
        emailPlaceholder: "ahmed@company.ae",
        company: "الشركة",
        companyPlaceholder: "شركتكم",
        position: "المنصب",
        positionPlaceholder: "الرئيس التنفيذي / المدير العام",
        message: "رسالتكم",
        messagePlaceholder: "أخبرونا عن التحدي الذي تواجهونه...",
        submit: "إرسال الطلب",
        sending: "جاري الإرسال...",
        success: "شكراً! سنتواصل معكم قريباً.",
        error: "حدث خطأ. يرجى المحاولة مرة أخرى."
      },
      info: {
        title: "معلومات الاتصال",
        email: "info@globalegroupe.consulting",
        phone: "+49 (0) 123 456 789",
        address: "ميونخ، ألمانيا"
      },
      alternative: {
        title: "طرق أخرى للتواصل",
        linkedin: "LinkedIn",
        schedule: "حجز مكالمة مباشرة",
        emergency: "دعم SOS فوري"
      }
    },
    journeyTimeline: {
  milestones: [
    {
      year: 'البدايات',
      title: 'النشأة بين عوالم متعددة',
      description:
        'نشأة بين ثقافات مختلفة وعلى أكثر من قارة. أوروبا، منطقة DACH، الشرق الأوسط وشمال أفريقيا – ليس كسائح، بل كجزء حي من أكثر من عالم.'
    },
    {
      year: 'المسار الأكاديمي',
      title: 'إدارة أعمال دولية ودراسات متعددة الثقافات',
      description:
        'خلفية أكاديمية في إدارة الأعمال الدولية، والدراسات متعددة الثقافات، وإدارة التغيير المنهجية. النظرية هنا منصة انطلاق، وليست قيداً على الواقع.'
    },
    {
      year: 'الاعتماد المهني',
      title: 'استشاري إدارة تغيير معتمد ISO-EN-17024',
      description:
        'اعتماد دولي في إدارة التغيير – ليس لمجرد جمع شهادات، بل لأن التميز يحتاج إلى معايير واضحة يمكن القياس عليها.'
    },
    {
      year: 'الخبرة العملية',
      title: 'إدارة تسليم المشاريع ومرافقة التحول',
      description:
        'سنوات من العمل الميداني: تسليم مشاريع معقدة، مبادرات تغيير، وفرق دولية. من الشركات المتوسطة إلى المجموعات الكبرى، من ميونخ إلى مدن شمال أفريقيا.'
    },
    {
      year: 'الابتكار',
      title: 'TRIAX® وإطار Resonance Flow',
      description:
        'النتيجة الطبيعية لهذه الرحلة: نموذج TRIAX® كنظام يربط بين الثقافة والإنسان والهيكل، وإطار Resonance Flow كمنهجية قابلة للتوسّع والتنفيذ عملياً.'
    },
    {
      year: 'اليوم',
      title: 'GLOBRIDGE – استشارات بوتيك',
      description:
        'لسنا كياناً ضخماً ولا منتجاً جماعياً. نحن بوتيك استشاري لمنظمات تبحث عن تحوّل عميق، قائم على الرنين الحقيقي لا على الأدوات فقط.'
    }
  ]
},
about: {
  hero: {
    badge: "الهوية والجذور",
    titleLine1: "وُلِدنا بين عوالم متعددة.",
    titleHighlight: "وصُمِّمنا لبناء الجسور بينها.",
    subtitle:
      "لم تُنشأ GLOBRIDGE لبيع استشارات تقليدية، بل لسدّ فجوة استراتيجية لا يراها كثيرون – الفجوة بين النظام والإنسان.",
    quoteLine1:
      "بين النظام والإنسان. بين الاستراتيجية والتأثير الحقيقي.",
    quoteLine2: "بين الثقافات والأسواق.",
    imageAlt: "سياق أعمال احترافي في بيئة دولية متعددة الثقافات"
  },
  story: {
    titleBeforeHighlight: "من",
    titleHighlight: "نحن",
    p1:
      "GLOBRIDGE ليست شركة بالمعنى التقليدي، بل نتيجة رحلة شخصية نشأة بين ثقافات مختلفة، وتعليم أكاديمي عميق، وتجربة عملية في بيئات دولية.",
    p2:
      "بصفتي مستشار إدارة تغيير معتمد وفق ISO-EN-17024، مع خلفية أكاديمية في الأعمال الدولية والدراسات متعددة الثقافات، وخبرة عملية كمسؤول تسليم مشاريع، تعلّمت مبكراً حقيقة بسيطة ومهمة:",
    quote:
      "التحول لا يفشل بسبب نقص الأدوات، بل عندما يغيب الإنسان عن معادلة القرار.",
    p3:
      "شاهدت كثيراً من الاستراتيجيات اللامعة تنهار بسبب سوء فهم ثقافي، أو مقاومة داخلية، أو غياب حقيقي للاستماع. من هنا وُلدت GLOBRIDGE كبوتيك استشاري للتحول المنهجي العميق، بعيداً عن الحلول الجاهزة.",
    closing:
      "ليست مهمتنا إعادة اختراع الاستشارات، بل خلق مساحة حقيقية بين النظام والروح، بين الهيكل والإنسانية، حيث يمكن للشراكة أن تنمو.",
    floatingQuote:
      "الأثر الحقيقي لا يولد من المنهجيات وحدها، بل من رنين الثقة بين الشركاء."
  },
  credentials: {
    title: "الأساس و",
    highlight: "الاعتمادات",
    subtitle:
      "لسنا نسعى لتجميع الشهادات، بل لضمان معايير جودة واضحة يمكن الوثوق بها",
    items: [
      {
        id: "iso",
        title: "ISO-EN-17024",
        subtitle: "استشاري إدارة تغيير معتمد",
        description:
          "اعتماد دولي في إدارة التغيير يتماشى مع المعايير الأوروبية ويخدم بيئات أعمال معقدة."
      },
      {
        id: "academic",
        title: "خلفية أكاديمية",
        subtitle: "إدارة أعمال دولية ودراسات متعددة الثقافات",
        description:
          "تكوين علمي متقدم في الأعمال الدولية والتواصل بين الثقافات، مع فهم عميق لديناميكيات الأسواق."
      },
      {
        id: "delivery",
        title: "Project Delivery Manager",
        subtitle: "خبرة تنفيذية عملية",
        description:
          "سنوات من قيادة وتنفيذ مبادرات تغيير وتحول في مؤسسات مختلفة الأحجام والهياكل."
      },
      {
        id: "dach-mena",
        title: "خبرة DACH–MENA",
        subtitle: "العربية · الفرنسية · الألمانية",
        description:
          "قدرة تواصل ثلاثية اللغة تربط أوروبا بالشرق الأوسط وشمال أفريقيا في سياق أعمال وشراكات طويلة الأمد."
      }
    ]
  },
  journey: {
    title: "رحلة",
    highlight: "التشكّل",
    subtitle:
      "من جذور متعددة الثقافات إلى منهجية تحول منهجي متكاملة"
  },
  values: {
    title: "فلسفتنا",
    highlight: "العملية",
    subtitle:
      "قيم نمارسها مع الشركاء، وليست مجرد شعارات في عرض تقديمي",
    items: [
      {
        id: "resonance",
        title: "الرنين قبل الكمال النظري",
        description:
          "لا نطارد الاستراتيجيات المثالية بقدر ما نبني مساحات تواصل حقيقي تسمح بقرارات شجاعة وتحول فعّال."
      },
      {
        id: "systemic",
        title: "منهجية نظامية بنظرة نقدية",
        description:
          "نفكر بمنطق الأنظمة (TRIAX®) ونراجع الافتراضات باستمرار. المنهجية لدينا أداة لخدمة القرار، لا غاية بحد ذاتها."
      },
      {
        id: "cultural",
        title: "ذكاء ثقافي عملي",
        description:
          "في البيئات الدولية، الفشل غالباً ليس تقنياً، بل ثقافياً. دورنا ترجمة السياقات والعقليات بين الفرق والأسواق."
      },
      {
        id: "boutique",
        title: "بوتيك استشاري، لا مصنع تقارير",
        description:
          "لا فرق كبيرة من المستشارين المبتدئين، بل مرافقة شخصية على مستوى C-level، بعدد محدود من الشراكات في نفس الوقت."
      }
    ]
  },
  difference: {
    title: "ما الذي يجعلنا",
    highlight: "مختلفين",
    subtitle: "وضوح مباشر بدلاً من لغة تسويقية براقة",
    blocks: [
      {
        id: "not",
        title: "ما لا نقدمه",
        points: [
          "لا نقدم عروضاً مكوّنة من مئات الشرائح بلا قيمة تنفيذية.",
          "لا نعتمد على فرق من المبتدئين يكررون نظريات عامة.",
          "لا نبيع حلولاً موحّدة للجميع دون اعتبار للسياق.",
          "لا نَعِد بوعود لا يمكن تحويلها إلى نتائج فعلية."
        ]
      },
      {
        id: "offer",
        title: "ما نلتزم بتقديمه",
        points: [
          "شراكة فكرية على مستوى الإدارة العليا، وليست علاقة مورد–عميل.",
          "تفكير نظامي مرتبط بخطة تنفيذ واقعية قابلة للقياس.",
          "ذكاء ثقافي حقيقي يدعم التوسع والتغيير عبر الحدود.",
          "شفافية كاملة: ننصح ونرافق، وأنتم تتخذون القرار النهائي."
        ]
      }
    ],
    promiseLead: "وعد GLOBRIDGE:",
    promiseText:
      "نرافقكم بعمق وخبرة وذكاء ثقافي، ونضع على الطاولة ما تحتاجون سماعه، لا ما تريدون سماعه فقط. القرار دائماً يبقى في أيديكم، ونحن نبقى شريكاً موثوقاً في الخلفية."
  },
  method: {
    title: "منهجيتنا",
    highlight: "العملية",
    subtitle:
      "TRIAX® وإطار Resonance Flow – مزج منضبط بين النظرية والتنفيذ والواقع الثقافي",
    triax: {
      title: "TRIAX®",
      text:
        "نموذجنا النظامي للتحول: قراءة الثقافة والإنسان والبنية كمنظومة واحدة، بدلاً من التعامل معها كجزر منفصلة.",
      linkLabel: "اكتشف TRIAX®"
    },
    rff: {
      title: "Resonance Flow Framework",
      text:
        "إطار عمل قابل للتوسع من خمس مراحل، من قراءة الوضع الحالي وحتى ترسيخ التغيير – مرن، متدرج، ومرتبط بمؤشرات أداء واضحة.",
      linkLabel: "اكتشف Resonance Flow"
    },
    reasonsTitle: "لماذا هذه التركيبة؟",
    reasons: [
      {
        id: "systemic",
        title: "منهجي",
        text:
          "TRIAX® يضمن أننا ننظر إلى المنظمة كاملة – الثقافة، القيادة، العمليات – ككيان واحد مترابط."
      },
      {
        id: "scalable",
        title: "قابل للتوسّع",
        text:
          "إطار Resonance Flow يجعل ما ينجح قابلاً للتكرار في وحدات ومناطق مختلفة دون فقدان الحساسية المحلية."
      },
      {
        id: "measurable",
        title: "قابل للقياس",
        text:
          "مخرجات ومؤشرات أداء محددة في كل مرحلة، بحيث تبقى القيادة قادرة على المتابعة واتخاذ القرار في الوقت المناسب."
      }
    ]
  },
  cta: {
    titleBeforeHighlight: "هل أنتم مستعدون لمرحلة",
    highlight: "تحول حقيقي",
    text:
      "دعونا نفتح حواراً تنفيذياً نستكشف فيه معاً إذا كنا الشريك المناسب لمرحلتكم القادمة. لا عرض بيع، بل نقاش صريح ومحترم على مستوى C-level.",
    button: "بدء حوار تنفيذي"
  }
},

servicesPage: {
  hero: {
    titleLine1: "Resonance Flow Framework",
    titleHighlight: "كيف نعمل معكم",
    subtitle:
      "ننظر إلى التحول كتيار مستمر من الرنين – عميق، مستدام، وقابل للضبط وفقاً لسياقكم. نحن نشارككم الرأي ونرافقكم، بينما تبقى قرارات المسار والسرعة في أيديكم.",
    badge: "متعدد التخصصات · قابل للتوسع · قابل لإعادة التطبيق"
  },
  rff: {
    titleBeforeHighlight: "خمس مراحل محورية في",
    highlight: "Resonance Flow",
    subtitle:
      "نموذج عمل ديناميكي يعتمد على حلقات تغذية راجعة مستمرة، يمكن تكييفه مع هيكل الحوكمة وثقافة العمل في مؤسستكم."
  },
  servicesSection: {
    titleBeforeHighlight: "خدماتنا",
    highlight: "بصورة عملية",
    subtitle:
      "اضغط على أي خدمة لاستكشاف المنهجية، المخرجات، وقيمة الشراكة على مستوى C-level."
  },
  serviceDetails: {
    approachTitle: "منهجية العمل",
    whyUsLabel: "لماذا نحن:",
    faqTitle: "أسئلة متكررة",
    phaseLabel: "المرحلة"
  },
  cta: {
    titleBeforeHighlight: "هل أنتم مستعدون لمرحلة",
    highlight: "تحول حقيقي",
    text:
      "نقدم لكم مزيجاً من منهجيات مثبتة وذكاء ثقافي وفهم عميق لديناميكيات القيادة في المنطقة. بدون وعود مبالغ فيها، وبدون إملاءات – بل شراكة فكرية محترمة.",
    button: "بدء حوار تنفيذي"
  },
  services: [
    {
      id: "change-management",
      title: "إدارة التغيير المنهجي",
      subtitle: "Resonance Flow في التطبيق العملي",
      intro:
        "بفضل اعتماد ISO-EN-17024 في إدارة التغيير، وخلفية أكاديمية في الأعمال الدولية، وخبرة عملية في بيئات متعددة، نرافق مؤسستكم في رحلات تحول معقدة دون فقدان الحس الإنساني.",
      description:
        "التحول الحقيقي يتجاوز إعادة هندسة العمليات. نحن نتعامل مع الثقافة والهيكل والإنسان كمنظومة واحدة حية. إطار Resonance Flow Framework (RFF) يجمع نموذج TRIAX® مع مبادئ Agile وScrum المعدّلة، ومع ذكاء ثقافي عملي يناسب بيئات DACH–MENA.",
      approach: [
        {
          phase: "توضيح التكليف وقراءة الرنين",
          description:
            "نبدأ بتوضيح التكليف على مستوى مجلس الإدارة أو القيادة التنفيذية، ونشخّص نقاط الانسداد في النظام عبر تحليلات نوعية وورش عمل مركزة.",
          deliverables: [
            "Resonance Scan للثقافة والهيكل والقيادة",
            "مقابلات مع أصحاب المصلحة الرئيسيين",
            "تقييم جاهزية التغيير",
            "تحليل ثقافي مستند إلى نموذج Hofstede"
          ]
        },
        {
          phase: "تصميم خارطة الطريق وبناء تحالف التغيير",
          description:
            "نشارككم في تصميم خارطة طريق مرنة، وبناء تحالف داخلي داعم من صناع القرار وقادة المحاور.",
          deliverables: [
            "Backlog تغيير بأسلوب Agile",
            "خارطة طريق مدمجة مع TRIAX®",
            "ورش مواءمة لأصحاب المصلحة",
            "خطة إدارة المقاومة للتغيير"
          ]
        },
        {
          phase: "التنفيذ عبر سبرنتات وتحسينات متدرجة",
          description:
            "ننقل خارطة الطريق إلى سبرنتات عملية قصيرة، مع مراجعات منتظمة تركز على الأثر وليس على الشكل.",
          deliverables: [
            "سبرنتات لمدة أسبوعين مع مراجعات",
            "جلسات Coaching للقيادة",
            "تدريبات على المرونة والقدرة على التكيف",
            "رصد مستمر للمخاطر والتوترات"
          ]
        },
        {
          phase: "حلقات تغذية راجعة وتعديل المسار",
          description:
            "نستخدم Retrospectives واستطلاعات نبض الفريق لإعادة ضبط الإيقاع والمسار بشكل توافقي.",
          deliverables: [
            "اجتماعات متابعة أسبوعية",
            "أدوات Feedback مجهولة الهوية",
            "تحليل الانطباع والمشاعر داخل المنظمة",
            "خطط تعديل محسوبة ومجدولة"
          ]
        },
        {
          phase: "الترسيخ والمتابعة الاستراتيجية",
          description:
            "نساعدكم في ترسيخ التغيير عبر متابعات شهرية، ومؤشرات أداء واضحة، وتعلم مؤسسي مستمر.",
          deliverables: [
            "مكالمات Coaching شهرية مع القيادة",
            "Monitoring لمؤشرات نجاح التحول",
            "برامج لبناء المرونة المؤسسية",
            "توثيق دروس مستفادة ورأس مال معرفي"
          ]
        }
      ],
      whyUs:
        "نسبة كبيرة من مبادرات التغيير تتعثر لأنها لا تُرسَّخ في النظام. نحن نعمل معكم كشريك تفكير طويل المدى، وليس كمورد مؤقت.",
      faq: [
        {
          q: "كيف يختلف RFF عن نماذج التغيير الكلاسيكية مثل Kotter؟",
          a: "RFF لا يعتمد على خطوات خطية ثابتة بل على تدفق مرن. ندمج TRIAX® والمبادئ الرشيقة والبعد الثقافي في إطار واحد قابل للتكيّف مع واقعكم."
        },
        {
          q: "هل الإطار مناسب فقط للمؤسسات الكبيرة؟",
          a: "يمكن تطبيقه على كيانات تبدأ من 10 أفراد وحتى آلاف الموظفين، مع ضبط الحجم والعمق بحسب الهيكل والحاجة."
        }
      ]
    },
    {
      id: "business-coaching",
      title: "Business Coaching & Leadership Development",
      subtitle: "قيادة ذات رنين على مستوى C-Level",
      intro:
        "القيادة في دبي والمنطقة لم تعد مرتبطة بالقرار السريع فقط، بل بالقدرة على خلق ثقة، وقراءة السياق الثقافي، وإدارة فرق متعددة الخلفيات بثبات واحترام.",
      description:
        "نرافق القادة فردياً وكمجموعات – من Coaching تنفيذي إلى تطوير فرق قيادة. منهجيتنا تمزج Coaching منهجي، وفهماً ثقافياً عميقاً، ومبادئ قيادة رشيقة تناسب بيئات عالية السرعة.",
      approach: [
        {
          phase: "Coaching تنفيذي فردي (1:1)",
          description:
            "مساحات آمنة لقيادات عليا لمراجعة القرارات، الأدوار، ونمط القيادة بعيداً عن الضجيج اليومي.",
          deliverables: [
            "تحليل Feedback 360° عند الحاجة",
            "خطط تطوير شخصية متوافقة مع أهداف العمل",
            "جلسات تعمق ربع سنوية",
            "أدوات عملية لإدارة الضغط والتوازن الشخصي"
          ]
        },
        {
          phase: "Coaching فرق القيادة والأداء العالي",
          description:
            "مساندة فرق C-Level أو فرق عمل حرجة لتحسين الثقة والتنسيق وحل النزاعات.",
          deliverables: [
            "تشخيص ديناميكيات الفريق",
            "تيسير وحل نزاعات حساسة",
            "ممارسات لبناء الثقة والتغذية الراجعة الفعالة",
            "رسم روتين عمل مشترك بأسلوب Agile"
          ]
        },
        {
          phase: "القيادة في بيئات متعددة الثقافات",
          description:
            "تصميم مهارات قيادية تناسب فرقاً تجمع جنسيات وخلفيات مختلفة في الخليج وأوروبا.",
          deliverables: [
            "تحليلات ثقافية مستندة لمراجع معروفة مثل Hofstede",
            "Workshops حول أنماط القيادة المقبولة حسب الثقافة",
            "إرشادات سلوكية عملية (Do’s & Don’ts)",
            "Playbooks للتواصل مع فرق متعددة الجنسيات"
          ]
        },
        {
          phase: "القيادة في فترات التحول والضغط",
          description:
            "Sparring مستمر للقادة خلال التحولات، مع تركيز على الطاقة، المعنى، وإدارة المقاومة.",
          deliverables: [
            "ورش عمل حول Change Leadership",
            "جلسات Sparring استراتيجية فردية",
            "بناء المرونة لدى القائد والفريق",
            "Coaching متدرج خلال دورة المشروع"
          ]
        }
      ],
      whyUs:
        "عدد كبير من القادة يشعر بأن التحديات الثقافية والإنسانية تتسارع أسرع من أدواته. نحن لا نقدم وصفات جاهزة، بل شراكة تفكير وسؤال ونقاش على مستوى C-Level.",
      faq: [
        {
          q: "ما المقصود بـ \"قيادة الرنين\" في هذا السياق؟",
          a: "قيادة تخلق صدى حقيقياً لدى الفرق والشركاء – تجمع بين الحزم والإنصات، وبين وضوح القرار واحترام الإنسان."
        },
        {
          q: "ما هو الإطار الزمني الأنسب لبرامج Coaching؟",
          a: "يتراوح عادة بين ثلاثة أشهر واثني عشر شهراً، مع تصميم خاص حسب جدول القائد ومرحلة التحول."
        }
      ]
    },
    {
      id: "scrum-for-sales",
      title: "SCRUM for Sales",
      subtitle: "ثورة رشيقة في فرق المبيعات",
      intro:
        "لم يعد مسار المبيعات خطاً مستقيماً من عرض إلى إغلاق. في الأسواق سريعة الإيقاع، تحتاج فرق المبيعات إلى إيقاع رشيق يشبه إيقاع فرق التكنولوجيا.",
      description:
        "نحوّل مبادئ Scrum – مثل السبرنتات، المراجعات، والرِتروسبيكتيف – إلى روتين عملي لفرق المبيعات. الهدف: استجابة أسرع لاحتياجات العملاء، رؤية أوضح للبايبلاين، وتحسين ملموس في نسب الإغلاق.",
      approach: [
        {
          phase: "تشخيص فريق المبيعات",
          description:
            "نقوم بتحليل مسار المبيعات الحالي ونقاط الاحتكاك من أول اتصال وحتى التوقيع.",
          deliverables: [
            "خرائط عمليات المبيعات الحالية",
            "تحليل الاختناقات في البايبلاين",
            "مراجعة أداء الفريق والأدوار",
            "Agile Readiness Check لبيئة المبيعات"
          ]
        },
        {
          phase: "تطبيق روتين Agile في المبيعات",
          description:
            "تصميم سبرنتات مبيعات، اجتماعات يومية قصيرة، ومراجعات دورية تركز على الصفقات أولاً.",
          deliverables: [
            "تهيئة سبرنتات مبيعات (دورات أسبوعين)",
            "Dashboards لمؤشرات الأداء الرئيسية",
            "روتينات Synchronisation للفريق",
            "Sales Playbook بأسلوب Agile"
          ]
        },
        {
          phase: "تتبع الأداء والتعديل المستمر",
          description:
            "العمل على قرارات مدعومة بالبيانات، مع تحديث مستمر لطرق الاستهداف والأولويات.",
          deliverables: [
            "لوحات متابعة آنية للأداء",
            "Tracking لنسب التحويل وطول دورة المبيعات",
            "جلسات Retrospective لكل سبرنت",
            "تعديلات استراتيجية تدريجية على مستوى السوق"
          ]
        },
        {
          phase: "تمكين الفريق وبناء الاستقلالية",
          description:
            "تدريب وتمكين مديري ومديرات المبيعات لبناء فرق قادرة على إدارة رتم العمل بنفسها.",
          deliverables: [
            "تدريبات على المبيعات الرشيقة",
            "Coaching لقيادات المبيعات",
            "جلسات تبادل خبرات بين الأقران",
            "تجميع Best Practices قابلة لإعادة الاستخدام"
          ]
        }
      ],
      whyUs:
        "نماذج المبيعات التقليدية غالباً بطيئة مقارنة بسرعة العميل في المنطقة. نحن نساعدكم على رفع السرعة دون التضحية بالجودة أو عمق العلاقة.",
      faq: [
        {
          q: "هل يمكن فعلاً تطبيق Scrum في المبيعات دون تعقيد زائد؟",
          a: "نعم، عندما نستخدم المبادئ لا القالب الحرفي. ن adapté الفكرة لبيئتكم بدلاً من فرض نموذج جامد."
        },
        {
          q: "ما هي المؤشرات التي تركزون عليها عادة؟",
          a: "نسب التحويل، طول دورة المبيعات، نشاط الفريق، وسرعة حركة البايبلاين – مع تكييف التفاصيل حسب قطاعكم."
        }
      ]
    },
    {
      id: "intercultural-intelligence",
      title: "Intercultural Business Intelligence",
      subtitle: "خبرة DACH–MENA وتوسّع عالمي متوازن",
      intro:
        "في التوسّع عبر الحدود، الخطأ الثقافي الصغير يمكن أن يخلق فجوة كبيرة في الثقة. دورنا أن نكون مترجِماً أميناً بين الثقافات business، لا مجرد مفسّر لغوي.",
      description:
        "نعمل عند تقاطع أوروبا الناطقة بالألمانية ومنطقة الشرق الأوسط وشمال أفريقيا، مع فهم عملي لأساليب التفاوض، اتخاذ القرار، وبناء الشراكات. ندمج تحليلات ثقافية مع خبرة ميدانية وشبكات محلية.",
      approach: [
        {
          phase: "Cultural Due Diligence",
          description:
            "قبل الدخول إلى سوق جديد أو شراكة استراتيجية، نقوم بقراءة حساسة للرموز والعوامل الثقافية الحرجة.",
          deliverables: [
            "تقارير ثقافية مستندة إلى نماذج معترف بها",
            "Briefings عن أسلوب الأعمال المحلي",
            "تقييم مخاطر ثقافية وسلوكية",
            "خارطة أصحاب المصلحة والعلاقات المؤثرة"
          ]
        },
        {
          phase: "تدريبات عملية على التواصل بين الثقافات",
          description:
            "ورش عمل موجهة للفرق التي تتعامل مباشرة مع شركاء أو عملاء من ثقافات مختلفة.",
          deliverables: [
            "Workshops للتواصل بين الثقافات",
            "Guides لسلوكيات مناسبة لكل سوق",
            "قوائم Do’s & Don’ts في الاجتماعات والتفاوض",
            "تمثيل أدوار وسيناريوهات من واقع الأعمال"
          ]
        },
        {
          phase: "استراتيجيات دخول وتنمية الأسواق",
          description:
            "مرافقة في تصميم استراتيجيات Go-to-Market أو إعادة تموضع تحترم الحساسية المحلية وتطلعات المقر الرئيسي.",
          deliverables: [
            "Playbooks لدخول وتطوير الأسواق",
            "دعم في اختيار وبناء الشركاء المحليين",
            "منهجيات تفاوض تأخذ الثقافة بعين الاعتبار",
            "فتح قنوات مع شبكات وخبراء محليين"
          ]
        },
        {
          phase: "بناء فرق متعددة الثقافات وقيادتها",
          description:
            "دعم الموارد البشرية والقيادات في بناء فرق تجمع كفاءات من بلدان مختلفة دون خلق «معسكرات» داخل المؤسسة.",
          deliverables: [
            "استشارات في تركيب الفرق وتوازن الجنسيات",
            "برامج Onboarding تراعي اختلاف الخلفيات",
            "خطط للوقاية من النزاعات الثقافية",
            "تدريبات على القيادة في بيئات متعددة الثقافات"
          ]
        }
      ],
      whyUs:
        "سوء الفهم الثقافي لا يظهر دائماً في التقارير، لكنه ينعكس في تأخير القرارات، تعثر الصفقات، واستنزاف الطاقة. مهمتنا جعل السياق أوضح حتى تصبح قراراتكم أكثر ثقة.",
      faq: [
        {
          q: "ما هي المناطق التي تركزون عليها عملياً؟",
          a: "بشكل أساسي دول DACH والشرق الأوسط وشمال أفريقيا، مع قدرة على الربط بين ثلاث لغات: العربية، الفرنسية، والألمانية."
        },
        {
          q: "كيف يختلف عملكم عن برامج \"التنوع والشمول\" التقليدية؟",
          a: "نركز على تأثير مباشر في الأعمال: الصفقات، الشراكات، أداء الفرق – وليس فقط على الحساسية النظرية للموضوع."
        }
      ]
    }
  ]
},

signaturePage: {
  hero: {
    badge: "برامج Signature متميزة",
    titleLine1: "Signature Programs",
    titleHighlight: "تحول يُحسّ بكل تفاصيله",
    subtitle:
      "برامج مُصممة على إطار Resonance Flow Framework – بهيكل واضح، عمق إنساني، وتركيز حقيقي على العائد على الاستثمار."
  },
  tierLabels: {
    small: "< 50 موظف",
    medium: "50-250 موظف",
    large: "250-1000 موظف",
    enterprise: "1000+ موظف"
  },
  signaturesSection: {
    titleBeforeHighlight: "برامجنا",
    highlight: "Signature",
    subtitle:
      "أطر عمل مجرَّبة، بهيكل واضح وقابلة للتخصيص بالكامل وفق واقع مؤسستكم."
  },
  programDetails: {
    programFlowTitle: "مسار البرنامج",
    deliverableLabel: "المخرجات:",
    includedTitle: "الخدمات المشمولة",
    resultsTitle: "النتائج المتوقعة",
    investmentTitle: "الاستثمار",
    investmentSubtitle:
      "يُحدَّد بعد فهم حجم وتعقيد وسياق مؤسستكم",
    requestButton: "عرض سعر مخصص",
    requestNote:
      "سنعيد التواصل معكم بعرض مصمم على قياس وضعكم الحالي وطموحكم في التحول."
  },
  individualSection: {
    titleBeforeHighlight: "خدمات",
    highlight: "À la Carte",
    subtitle:
      "خدمات مستقلة خارج برامج Signature – يمكن حجزها وفق الحاجة والمرحلة.",
    whyNoPublicPricesTitle: "لماذا لا نعرض الأسعار بشكل علني؟",
    whyNoPublicPricesText:
      "بصفتنا Boutique Consulting، نعتبر كل تعاون شراكة فريدة. لذلك نضبط مستوى الاستثمار بناءً على السياق، حجم المنظمة، وتعقيد التحديات. الخطوة الأولى دائماً: حوار تنفيذي صريح، ثم عرض مخصص وواضح."
  },
  whySection: {
    titleBeforeHighlight: "لماذا نعمل بأسلوب",
    highlight: "Signature Programs",
    cards: [
      {
        title: "منهجية مجرّبة وواضحة",
        text: "مراحل محددة، مخرجات موثقة، وصورة شفافة للحالة أمام الإدارة والفرق."
      },
      {
        title: "تركيز على العائد",
        text: "تم تصميم البرامج لتوليد أثر ملموس على الأعمال – غالباً بعائد 3–5 أضعاف الاستثمار خلال 18 شهراً."
      },
      {
        title: "مرونة مع المحافظة على الهيكل",
        text: "إطار عمل ثابت بالحد الكافي، ومرن بالقدر الذي يسمح بتكييفه مع ثقافة وأسواق ومراحل مؤسستكم."
      }
    ]
  },
  cta: {
    titleBeforeHighlight: "جاهزون لبدء",
    highlight: "Signature Transformation",
    text:
      "دعونا نستكشف معاً أي برنامج، بأي عمق، وبأي إيقاع يناسبكم أنتم، وليس فقط ما يناسب المنهجية.",
    button: "حجز حوار تنفيذي أولي",
    dialogProgramLabel: "حوار تنفيذي (لقاء أولي)"
  },
  signatures: [
    {
      id: "resonance-foundation",
      tier: "بداية",
      title: "Resonance Foundation",
      subtitle: "أساسيات إدارة التغيير",
      duration: "3 أشهر",
      description:
        "انطلاقة منهجية نحو تحول منظومي حقيقي. نساعدكم على بناء أساس واضح وقابل للقياس للتغيير.",
      forWhom: {
        title: "لمن هذا البرنامج؟",
        targets: [
          "شركات تقترب من أول مشروع تحول كبير",
          "فرق لديها حاجة واضحة للتغيير ولكن ضمن نطاق محدد",
          "منظمات ترغب في بناء جاهزية حقيقية للتغيير",
          "شركات متوسطة تبحث عن شريك محترف في إدارة التغيير"
        ]
      },
      setup: {
        phase1: {
          title: "الشهر 1: التشخيص وبناء خارطة الطريق",
          activities: [
            "Resonance Scan وفق نموذج TRIAX®",
            "مقابلات مع أصحاب المصلحة الرئيسيين",
            "تقييم جاهزية التغيير Change Readiness",
            "تصميم خارطة طريق للتغيير"
          ],
          deliverable: "خارطة طريق للتغيير وخطة Quick Wins"
        },
        phase2: {
          title: "الشهر 2: التنفيذ",
          activities: [
            "سبرنتين (Flow Sprints) مدة كل منهما أسبوعان",
            "ورش مواءمة لأصحاب المصلحة",
            "خطة لإدارة المقاومة",
            "جلسات Coaching للفريق (جلستان)"
          ],
          deliverable: "نتائج أولية قابلة للقياس"
        },
        phase3: {
          title: "الشهر 3: الترسـيخ",
          activities: [
            "حلقات Feedback منظمة",
            "خطة تعديلات على خارطة الطريق",
            "Coaching متابعة",
            "توثيق كامل + Playbook"
          ],
          deliverable: "Legacy Box وتقرير ختامي"
        }
      },
      included: [
        "تشخيص Resonance وفق نموذج TRIAX®",
        "6 جلسات Coaching (90 دقيقة)",
        "4 Flow Sprints مع Reviews",
        "ورش Alignment لأصحاب المصلحة",
        "خارطة طريق للتغيير + Playbook",
        "متابعة شهرية لمدة 3 أشهر",
        "دعم عبر الإيميل والهاتف"
      ],
      results: [
        "خارطة طريق واضحة للتحول",
        "حصول على Buy-in من الأطراف الأساسية",
        "تحقيق Quick Wins مبكرة",
        "رفع جاهزية المنظمة للتغيير"
      ],
      pricing: {
        small: { base: 18500, region: { dach: 18500, mena: 16500, intl: 21000 } },
        medium: { base: 32000, region: { dach: 32000, mena: 28500, intl: 36500 } },
        large: { base: 52000, region: { dach: 52000, mena: 46500, intl: 59000 } },
        enterprise: { base: 85000, region: { dach: 85000, mena: 76000, intl: 96500 } }
      }
    },
    {
      id: "resonance-accelerator",
      tier: "احترافي",
      title: "Resonance Accelerator",
      subtitle: "تحول + تطوير قيادة",
      duration: "6 أشهر",
      description:
        "برنامج متكامل يجمع بين إدارة التغيير وبناء قدرات القيادة – مخصص لمؤسسات تحتاج إلى عمق وسرعة في آن واحد.",
      forWhom: {
        title: "لمن هذا البرنامج؟",
        targets: [
          "مؤسسات في منتصف رحلة تحول قائمة بالفعل",
          "منظمات لديها فجوة في قدرات القيادة",
          "فرق دولية تعمل بين DACH وMENA",
          "شركات متوسطة وكبيرة تبحث عن نموذج قابل للتوسع"
        ]
      },
      setup: {
        phase1: {
          title: "الشهر 1–2: الأساس وبناء التحالف",
          activities: [
            "تشخيص شامل وفق TRIAX®",
            "Leadership Assessment (360°)",
            "ورش لبناء تحالف داخلي راعٍ للتغيير",
            "تصميم معمارية التغيير",
            "Coaching تنفيذي (مرتان شهرياً)"
          ],
          deliverable: "معمارية التحول وخطة تطوير القيادة"
        },
        phase2: {
          title: "الشهر 3–4: التفعيل والتكرار",
          activities: [
            "6 Flow Sprints",
            "برنامج تطوير القيادة Leadership Development",
            "Coaching أسبوعي للفرق",
            "إدارة المقاومة",
            "ورش Cross-Culture (عند وجود بعد MENA)"
          ],
          deliverable: "تحسن ملموس في مؤشرات الأداء KPI"
        },
        phase3: {
          title: "الشهر 5–6: المواءمة والترسيخ",
          activities: [
            "حلقات Feedback وتعديلات مستمرة",
            "Leadership Resonanz Atelier",
            "بناء القدرات الداخلية",
            "Follow-up & Sustainment"
          ],
          deliverable: "ترسيخ مستدام وأثر طويل المدى"
        }
      },
      included: [
        "كل ما في Foundation PLUS:",
        "Leadership Assessment (360°)",
        "12 جلسة Coaching تنفيذي",
        "6 جلسات Coaching للفريق",
        "8 Flow Sprints مع Retrospectives",
        "برنامج كامل لتطوير القيادة",
        "ورش عمل Cross-Culture اختيارية",
        "Check-ins نصف شهرية",
        "دعم أولوية عبر الإيميل والهاتف",
        "متابعة لمدة 3 أشهر بعد البرنامج"
      ],
      results: [
        "تحسن في فعالية القيادة بنسبة تقارب 60%",
        "ارتفاع Engagement الفرق بنسبة تقارب 50%",
        "انخفاض مقاومة التغيير بشكل ملحوظ",
        "ترسيخ التحول في الثقافة والنظم"
      ],
      pricing: {
        small: { base: 42000, region: { dach: 42000, mena: 37500, intl: 47500 } },
        medium: { base: 68000, region: { dach: 68000, mena: 61000, intl: 77000 } },
        large: { base: 115000, region: { dach: 115000, mena: 103000, intl: 130000 } },
        enterprise: { base: 185000, region: { dach: 185000, mena: 166000, intl: 210000 } }
      }
    },
    {
      id: "resonance-transformation",
      tier: "Elite",
      title: "Resonance Transformation",
      subtitle: "Full RFF – شراكة تحوّل شاملة",
      duration: "12 شهراً",
      description:
        "برنامج النخبة. تطبيق كامل لإطار Resonance Flow Framework مع جميع الخدمات، مصمم للتحولات المعقّدة والمتعددة الدول.",
      forWhom: {
        title: "لمن هذا البرنامج؟",
        targets: [
          "مؤسسات كبيرة لديها عدة مسارات تحول متزامنة",
          "شركات في مرحلة توسّع دولي (خاصة محور DACH–MENA)",
          "منظمات تدير مشاريع Change متعددة ومتداخلة",
          "قيادات C-Level تبحث عن شريك تفكير استراتيجي طويل الأمد"
        ]
      },
      setup: {
        phase1: {
          title: "الربع 1: التشخيص، التحالف والاستراتيجية",
          activities: [
            "تحليل منظومي عميق بحسب TRIAX®",
            "Assessment وخطة تطوير للقيادة",
            "بناء تحالف C-Level + Key Players",
            "معمارية Change كاملة مع دمج SCRUM4Sales",
            "Cultural Due Diligence (خاصة في أسواق MENA)",
            "Coaching تنفيذي أسبوعي"
          ],
          deliverable: "Transformation Blueprint & Leadership Roadmap"
        },
        phase2: {
          title: "الربع 2–3: التفعيل والتكرار الرشيق",
          activities: [
            "12 Flow Sprints",
            "Leadership Resonanz Atelier شهري",
            "Coaching للفرق وإدارة النزاعات",
            "تنفيذ SCRUM4Sales",
            "تدريبات Intercultural",
            "حلقات Feedback وتعديل مستمر"
          ],
          deliverable: "أثر Business قابل للقياس ومؤشرات أداء واضحة"
        },
        phase3: {
          title: "الربع 4: المواءمة، التوسعة والـ Legacy",
          activities: [
            "توسعة التطبيق لفِرق / مناطق أخرى",
            "بناء قدرات داخلية + Train-the-Trainer",
            "تحسين الأداء Performance Optimization",
            "توثيق Playbooks وLessons Learned",
            "نقل الملكية الكاملة للداخل"
          ],
          deliverable: "تحوّل ذاتي الاستدامة موثق بالكامل"
        }
      },
      included: [
        "كل ما في Accelerator PLUS:",
        "شريك استراتيجي مخصص طوال العام",
        "24 جلسة Coaching تنفيذي",
        "12 جلسة Coaching للفريق",
        "12 Flow Sprints مع Retros كاملة",
        "تنفيذ كامل لـ SCRUM4Sales",
        "Intercultural Business Intelligence (DACH–MENA)",
        "Leadership Resonanz Atelier (12 جلسة)",
        "برنامج Train-the-Trainer",
        "دعم On-Demand بوقت استجابة 24/48 ساعة",
        "متابعة لمدة 6 أشهر بعد البرنامج",
        "مراجعة استراتيجية سنوية"
      ],
      results: [
        "ترسيخ التحول وامتلاكه بالكامل من قبل الفرق الداخلية",
        "زيادة في قدرة القيادة بما يصل إلى 80%",
        "توسع دولي أكثر أماناً واتساقاً",
        "ROI متوقع بين 3–5 أضعاف الاستثمار خلال ~18 شهراً"
      ],
      pricing: {
        small: { base: 95000, region: { dach: 95000, mena: 85000, intl: 108000 } },
        medium: { base: 145000, region: { dach: 145000, mena: 130000, intl: 165000 } },
        large: { base: 240000, region: { dach: 240000, mena: 215000, intl: 272000 } },
        enterprise: { base: 380000, region: { dach: 380000, mena: 342000, intl: 432000 } }
      }
    },
    {
      id: "resonance-sos",
      tier: "تدخّل في الأزمات",
      title: "Resonance SOS",
      subtitle: "تدخّل سريع في الأزمات الحادة",
      duration: "4–8 أسابيع",
      description:
        "عندما تكون حرارة النظام مرتفعة. تدخّل مركز ومكثّف في حالات الأزمات، النزاعات الحادة داخل الفرق، أو توقف مشاريع التحول.",
      forWhom: {
        title: "لمن هذا البرنامج؟",
        targets: [
          "شركات تمر بأزمة تحول أو أزمة ثقافية",
          "فرق تعيش نزاعات متصاعدة",
          "مشاريع Change متوقفة أو فاشلة",
          "قيادات تحتاج إلى دعم مكثّف سريع"
        ]
      },
      setup: {
        phase1: {
          title: "الأسبوع 1–2: التشخيص وخطة الأزمة",
          activities: [
            "تشخيص سريع خلال 48 ساعة",
            "تحليل الأزمة (أصحاب مصلحة، نزاعات، ديناميكيات)",
            "خطة إجراءات فورية",
            "Coaching مكثّف مع إتاحة يومية تقريباً"
          ],
          deliverable: "خطة أزمة واضحة وQuick Wins أولية"
        },
        phase2: {
          title: "الأسبوع 3–6: التدخّل والاستقرار",
          activities: [
            "Flow Sprints أسبوعية مكثفة",
            "تيسير وحل النزاعات",
            "Leadership Sparring حتى 3 مرات أسبوعياً",
            "Coaching للفرق وبناء الثقة",
            "دعم في استراتيجية الاتصال خلال الأزمة"
          ],
          deliverable: "استقرار نسبي واستعادة الزخم"
        },
        phase3: {
          title: "الأسبوع 7–8: الانتقال والتسليم",
          activities: [
            "خطة استقرار على المدى المتوسط",
            "تسليم منظم للفرق الداخلية",
            "Coaching متابعة",
            "توثيق Lessons Learned وخارطة متابعة"
          ],
          deliverable: "Handover وخطة متابعة واضحة"
        }
      },
      included: [
        "زمن استجابة 48 ساعة",
        "تشخيص مكثّف (يومان On-site عند الحاجة)",
        "إتاحة شبه يومية (هاتف / أونلاين)",
        "10 جلسات Coaching",
        "4 جلسات تيسير نزاعات",
        "دعم في التواصل أثناء الأزمة",
        "أولوية في الوصول (استجابة خلال 24 ساعة)",
        "متابعة لمدة 4 أسابيع بعد SOS"
      ],
      results: [
        "استقرار أولي للأزمة خلال 2–4 أسابيع في معظم الحالات",
        "خفض حدّة النزاعات وإعادة ضبط العلاقات",
        "إعادة مشاريع التحول إلى المسار",
        "استعادة قدرة القيادة على اتخاذ القرار بهدوء نسبي"
      ],
      pricing: {
        small: { base: 28000, region: { dach: 28000, mena: 25000, intl: 32000 } },
        medium: { base: 45000, region: { dach: 45000, mena: 40500, intl: 51000 } },
        large: { base: 68000, region: { dach: 68000, mena: 61000, intl: 77000 } },
        enterprise: { base: 95000, region: { dach: 95000, mena: 85500, intl: 108000 } }
      }
    }
  ],
  individualServices: [
    {
      service: "Systemic Change Management",
      description: "تطبيق كامل لإطار RFF – من التشخيص حتى الترسـيخ",
      duration: "3–6 أشهر",
      pricing: {
        small: { base: 22000 },
        medium: { base: 38000 },
        large: { base: 62000 },
        enterprise: { base: 98000 }
      }
    },
    {
      service: "Executive Coaching",
      description: "Coaching فردي 1:1 لقيادات الصف الأول",
      duration: "باقة من 6 جلسات",
      pricing: {
        small: { base: 6500 },
        medium: { base: 6500 },
        large: { base: 8500 },
        enterprise: { base: 11500 }
      }
    },
    {
      service: "SCRUM for Sales Implementation",
      description: "تصميم وتنفيذ روتين مبيعات Agile",
      duration: "2–4 أشهر",
      pricing: {
        small: { base: 18000 },
        medium: { base: 28000 },
        large: { base: 45000 },
        enterprise: { base: 72000 }
      }
    },
    {
      service: "Intercultural Business Intelligence",
      description: "توسع بين DACH–MENA + تدريبات Cross-Culture",
      duration: "1–3 أشهر",
      pricing: {
        small: { base: 15000 },
        medium: { base: 24000 },
        large: { base: 38000 },
        enterprise: { base: 58000 }
      }
    },
    {
      service: "Team Coaching",
      description: "بناء فرق عالية الأداء والمرونة",
      duration: "باقة من 4 جلسات",
      pricing: {
        small: { base: 5500 },
        medium: { base: 7500 },
        large: { base: 9500 },
        enterprise: { base: 12500 }
      }
    },
    {
      service: "Workshop / Training (يومي)",
      description: "ورش عمل مصممة حسب الحاجة – حضورياً أو أونلاين",
      duration: "لكل يوم",
      pricing: {
        small: { base: 2500 },
        medium: { base: 2500 },
        large: { base: 3500 },
        enterprise: { base: 4500 }
      }
    }
  ]
},

triaxPage: {
  hero: {
    titleBeforeHighlight: "ما هو",
    highlight: "TRIAX®",
    suffix: "؟",
    subtitle:
      "نهج منهجي للتحول المستدام يربط بين ثلاث أبعاد أساسية في المؤسسة – الهيكل، الثقافة، والإنسان – في نموذج واحد متكامل يمكن قيادته على مستوى الإدارة العليا."
  },
  classical: {
    title: "المقاربات الكلاسيكية للتحول",
    text:
      "غالبية نماذج التحول تركز على بعد واحد فقط: الهيكل، أو التقنية، أو الأفراد. نموذج TRIAX® صُمِّم تحديداً لسد الفجوة بين هذه العوالم الثلاثة.",
    bullets: [
      { bold: "مديرو التغيير", text: " يركزون على العمليات والهياكل" },
      { bold: "المدربون (Coaches)", text: " يعملون مع الأفراد والفرق" },
      {
        bold: "مستشارو الثقافة",
        text: " يركزون على القيم والسلوكيات الظاهرة"
      }
    ],
    footer: "→ جهود جيدة، ولكن غالباً في مسارات منفصلة وليست رؤية نظام واحد"
  },
  triaxApproach: {
    title: "منهجية TRIAX®",
    text:
      "TRIAX® يجعل تأثير أي قرار في الهيكل، الثقافة أو القيادة مرئياً على باقي النظام. بهذه الطريقة يتحول العمل من “إطفاء حرائق” إلى تصميم واعٍ لبنية المؤسسة.",
    highlight:
      "💡 أي تغيير في أحد الأبعاد الثلاثة (هيكل، ثقافة، إنسان) يُحدث بالضرورة حركة في البعدين الآخرين – السؤال فقط: هل نقوده بوعي أم نتركه يحدث وحده؟"
  },
  advantage: {
    title: "قيمة TRIAX® لفريق القيادة",
    items: [
      {
        title: "لغة مشتركة للحديث عن التعقيد",
        description:
          "إطار واحد يجمع مجلس الإدارة، الموارد البشرية، العمليات والتكنولوجيا حول نفس الصورة الذهنية للنظام."
      },
      {
        title: "معالجة نظامية للتحديات",
        description:
          "الصراعات والمخاطر والفرص تُرى في سياقها الكلي، وليس كأحداث منفصلة في قسم واحد."
      },
      {
        title: "أثر طويل المدى",
        description:
          "التركيز على نتائج قابلة للقياس والاستدامة، لا على مبادرات قصيرة الأمد أو شعارات مؤقتة."
      }
    ]
  },
  how: {
    titleBeforeHighlight: "كيف يعمل",
    highlight: "TRIAX®",
    subtitle:
      "الهيكل، الثقافة، والإنسان ليست ثلاث جزر منفصلة، بل أجزاء من نظام حي واحد. عندما نغير بعداً واحداً، يتغير توزيع الطاقة والقرارات في بقية الأبعاد.",
    inactiveTitle: "اضغط على أحد المحاور",
    inactiveSubtitle:
      "استكشف معنى كل محور – وما الذي يحدث عندما تغيّر الهيكل، أو الثقافة، أو أسلوب القيادة.",
    footnote:
      "قوة نموذج TRIAX® أنه يعامل مؤسستكم كنظام واحد مترابط: كل تعديل في الهيكل، الثقافة أو الإنسان يعيد تشكيل التوازن الكلي بطريقة ما – إيجابية أو سلبية."
  },
  axesSection: {
    examplesTitle: "أمثلة:"
  },
  axes: [
    {
      id: "struktur",
      label: "ماذا؟",
      vennTitle: "الهيكل",
      title: "محور الهيكل",
      subtitle: "العمليات، المنهجيات، والأنظمة",
      description:
        "الهيكل يحدد كيف يتحرك العمل داخل المؤسسة: من القرار إلى التنفيذ. الهدف ليس تعقيد الإجراءات، بل بناء عمليات واضحة، سريعة، وداعمة للفرق.",
      examples: [
        "هياكل تنظيمية مرنة أو Agile",
        "إعادة تصميم العمليات لتناسب العميل",
        "إدارة المشاريع والمحافظ بشكل منهجي",
        "خارطة طريق للتحول الرقمي والأدوات"
      ]
    },
    {
      id: "kultur",
      label: "كيف؟",
      vennTitle: "الثقافة",
      title: "محور الثقافة",
      subtitle: "القيم، الطقوس، والقواعد غير المكتوبة",
      description:
        "الثقافة هي نظام التشغيل الخفي للمؤسسة. هي التي تحدد كيف تُتخذ القرارات، كيف تُدار الخلافات، وما إذا كان الناس يتحدثون بصراحة أم بصوت منخفض في الممرات.",
      examples: [
        "مبادئ واضحة لاتخاذ القرار",
        "مستويات أمان نفسي تسمح بالتغذية الراجعة الصادقة",
        "قراءة وتحليل الثقافة عبر استطلاعات و Heatmaps",
        "ترجمة بين ثقافات فرعية (مقر vs. فروع، HQ vs. Region)"
      ]
    },
    {
      id: "mensch",
      label: "من؟",
      vennTitle: "الإنسان",
      title: "محور الإنسان",
      subtitle: "الفرق، المشاعر، والقيادة",
      description:
        "الإنسان هو مركز كل قصة تغيير. بدون قيادة حقيقية، وفرق صحية، وقدرة على التعامل مع المشاعر، تبقى أفضل الاستراتيجيات حبراً على ورق.",
      examples: [
        "تعزيز الذكاء العاطفي لدى القادة",
        "تطوير ديناميكيات فرق عالية الأداء",
        "برامج تطوير Leadership مع Coaching",
        "رفع جاهزية المنظمة للتغيير (Change Readiness)"
      ]
    }
  ],
  interactionsSection: {
    title: "التأثيرات النظامية بين الأبعاد",
    subtitle:
      "كل بعد من الأبعاد الثلاثة يؤثر في الآخرين بشكل مستمر. اختياركم هو: هل تتركون هذه التأثيرات غير مرئية، أم تجعلونها جزءاً واعياً من استراتيجية القيادة؟",
    focusLabel: "مجالات تركيز مهنية:"
  },
  interactions: [
    {
      from: "الثقافة",
      to: "الإنسان",
      title: "الثقافة تشكل العلاقات",
      description:
        "درجة النضج الثقافي في المؤسسة تحدد مدى الثقة، مستوى الصراحة، ومتى يختار الناس الكلام أو الصمت أمام الإدارة.",
      examples: [
        "فهم الفروقات الثقافية يزيد من الثقة في الفرق المتنوعة",
        "وجود أمان نفسي يسمح بنقاش صريح حول المخاطر",
        "الفرق متعددة الجنسيات تزدهر عندما تكون الثقافة جزءاً من الحوار"
      ],
      professionals:
        "الموارد البشرية، تطوير المنظمات، مسؤولو برامج التحول والتغيير"
    },
    {
      from: "الإنسان",
      to: "الهيكل",
      title: "الناس هم من يثبتون الهيكل أو يكسرونه",
      description:
        "حتى أجمل المخططات التنظيمية لن تعمل إذا لم يتبنَّها القادة والفرق. الناس هم من يحولون المخطط إلى ممارسة يومية.",
      examples: [
        "الفرق القوية تشارك في تصميم العمليات بدلاً من مجرد تنفيذها",
        "القيادة الواضحة تحدد الأدوار ومسارات اتخاذ القرار",
        "عندما يفهم الناس \"لماذا\"، يلتزمون بالهيكل بدلاً من التحايل عليه"
      ],
      professionals: "المديرون، قادة الفرق، مدربو الفرق (Team Coaches)"
    },
    {
      from: "الهيكل",
      to: "الثقافة",
      title: "الهياكل ترسل رسائل ثقافية",
      description:
        "طرق الحوافز، أنظمة التقييم، وقنوات التقرير تبني ثقافة حقيقية حتى لو كان الخطاب الرسمي مختلفاً تماماً.",
      examples: [
        "هياكل واضحة تعزز الشفافية والمسؤولية",
        "حوكمة عادلة تبني شعوراً بالثقة والإنصاف",
        "هياكل غير منسجمة تنتج مقاومة صامتة وسياسات ظل"
      ],
      professionals:
        "مديرو التغيير، مهندسو العمليات، خبراء الحوكمة والامتثال"
    }
  ],
  professionalsSection: {
    titleBeforeHighlight: "ما الذي تركز عليه",
    highlight: "المهن المختلفة في منظومة التغيير",
    differenceText:
      "قيمة TRIAX® أنه لا يلغي هذه الأدوار، بل يربط بينها في إطار واحد متكامل – بحيث تعمل جهود الهيكل، الثقافة والإنسان في اتجاه واحد، لا في اتجاهات متفرقة."
  },
  professionals: [
    {
      id: "change-manager",
      role: "Change Managers",
      focus: "الهيكل والعمليات",
      description:
        "يعملون على تصميم وتحسين الهياكل التنظيمية ومسارات العمل وبرامج التغيير على مستوى المؤسسة."
    },
    {
      id: "coaches",
      role: "Coaches",
      focus: "الإنسان والقيادة",
      description:
        "يدعمون القادة والفرق في بناء الوعي الذاتي، الذكاء العاطفي، والقدرة على العمل في بيئات عالية الضغط والتنوع."
    },
    {
      id: "triax-consultants",
      role: "TRIAX® Consultants",
      focus: "التكامل النظامي بين الأبعاد الثلاثة",
      description:
        "يربطون بين القرارات الهيكلية، الثقافة الفعلية، وتجربة الإنسان داخل المؤسسة لصناعة تحول متماسك وقابل للاستمرار."
    }
  ],
  benefitsSection: {
    titleBeforeHighlight: "لماذا",
    highlight: "TRIAX®؟"
  },
  benefits: [
    {
      id: "systemic",
      title: "رؤية نظامية واحدة",
      description:
        "قراءة شاملة للهيكل، الثقافة، والإنسان – بدلاً من التركيز على بعد واحد وعلاج الأعراض فقط."
    },
    {
      id: "scientific",
      title: "مستند إلى فكر وبحوث",
      description:
        "مستوحى من الفكر النظامي، أبحاث الثقافة، وتجربة عملية في بيئات DACH–MENA على مستوى الإدارة العليا."
    },
    {
      id: "practical",
      title: "مجُرَّب على أرض الواقع",
      description:
        "طُبِّق في برامج تحول معقدة، وعلى مستوى مجالس الإدارة والـ C-Level في قطاعات مختلفة."
    },
    {
      id: "sustainable",
      title: "أثر مستدام",
      description:
        "مصمم لإحداث تحولات حقيقية في السلوك والثقافة، وليس فقط إطلاق مبادرات جديدة أو شعارات داخلية."
    }
  ],
  cta: {
    titleBeforeHighlight: "هل أنتم مستعدون لمرحلة",
    highlight: "تحول نظامي حقيقي",
    text:
      "إذا كنتم ترغبون في نقاش تنفيذي عميق بعيد عن لغة التسويق، يمكننا معاً استكشاف أين يقف نظامكم اليوم وأين يمكن أن يأخذكم TRIAX®.",
    button: "بدء حوار TRIAX® تنفيذي"
  }
},
sosPage: {
  hero: {
    badge: "استجابة طارئة إستراتيجية",
    highlight: "SOS",
    titleLine: "عندما تحدِّد ٤٨ ساعة شكل الأشهر القادمة",
    subtitle:
      "للمواقف التي لا تحتمل الانتظار: إدارة أزمات، دعم صفقات حاسمة، وتحويل تحت ضغط الوقت.",
    bullets: [
      "استجابة فورية",
      "إدارة أزمات",
      "تدخّل دقيق وموجّه"
    ]
  },
  packagesSection: {
    title: "عروض",
    highlight: "SOS",
    subtitle:
      "ثلاث حزم طارئة مجرَّبة لسيناريوهات أزمات مختلفة.",
    footnote:
      "*قد يختلف مدى البرنامج حسب حجم الفريق وعدد المشاركين"
  },
  labels: {
    urgent: "عاجل"
  },
  packages: [
    {
      id: "culturebridge",
      title: "CultureBridge MENA",
      badge: "استجابة خلال ٢٤ ساعة",
      duration:
        "يوم واحد تدريب + ٣ أسابيع Coaching + دليل ثقافي واحد",
      description:
        "للشركات في منطقة DACH التي تستعد لعقد شراكات وأعمال مع شركاء من المنطقة العربية.",
      features: [
        "قائمة عملية بـ Do’s & Don’ts بين الثقافات + فهم عميق لطريقة التفكير",
        "إتيكيت الأعمال، أساليب التواصل، وثقافة التفاوض في المنطقة",
        "تهيئة عملية للاجتماعات والمفاوضات الحاسمة",
        "دليل ثقافي يساعد الفريق على النجاح بشكل مستدام"
      ]
    },
    {
      id: "scrum4sales",
      title: "Scrum4Sales Sprint",
      badge: "استجابة خلال ٤٨ ساعة",
      duration:
        "١٢ أسبوعاً من Coaching Agile ومرافقة تطبيقية على أرض الواقع",
      description:
        "لفرق المبيعات التي تمر بمرحلة تغيير أو إعادة تنظيم.",
      features: [
        "تصميم إيقاعات عمل Agile للمبيعات (تخطيط، Review، Retrospective)",
        "تحريك الثقافة وبناء معمارية واضحة للمسؤوليات",
        "مواءمة الفريق وأدوات شفافية عملية",
        "تحسين مستمر لعمليات المبيعات بناءً على البيانات"
      ]
    },
    {
      id: "change-sparring-6",
      title: "Change Sparring 6",
      badge: "تأكيد موعد خلال ٢٤ ساعة",
      duration: "٦ أشهر من مرافقة 1:1 مع Executive Sparring",
      description:
        "لقادة في مراحل تحوّل حرجة يحتاجون إلى مساحة آمنة وسريعة لاتخاذ قرارات عالية المخاطر.",
      features: [
        "تحليل نظامي للموقف، Roadmap، وتوضيح للأدوار والمسؤوليات",
        "مرافقة في إدارة الصراع وخلق مساحات حوار عالية الثقة",
        "جلسات Sparring أسبوعية عالية التركيز",
        "دعم طارئ عند ظهور مواقف حساسة أو قرارات حاسمة"
      ]
    }
  ],
  actions: {
    requestSOS: "طلب تدخل SOS الآن"
  },
  resultsSection: {
    titleBeforeHighlight: "نتائج",
    highlight: "مثبتة",
    subtitle:
      "حزم SOS مصمَّمة لتوليد نتائج ملموسة خلال فترة زمنية قصيرة جداً."
  },
  results: [
    { id: "productivity", metric: "+40%", label: "زيادة في الإنتاجية" },
    { id: "revenue", metric: "+35%", label: "نمو في الإيرادات" },
    { id: "delays", metric: "-50%", label: "انخفاض في التأخيرات" },
    {
      id: "decisions",
      metric: "+60%",
      label: "تحسّن في جودة القرارات"
    }
  ],
  process: {
    titleBeforeHighlight: "كيف يعمل",
    highlight: "SOS",
    steps: [
      {
        title: "اتصال فوري",
        text:
          "مكالمة هاتفية أو بريد إلكتروني يكفي. نعود إليكم خلال ٢٤–٤٨ ساعة."
      },
      {
        title: "تشخيص سريع",
        text:
          "قراءة سريعة وعميقة للموقف مع توصيات عملية فورية للأولويات."
      },
      {
        title: "تنفيذ مباشر",
        text:
          "بدء التدخّل مباشرة باستخدام منهجيات SOS مجرَّبة في بيئات عالية الضغط."
      }
    ]
  },
  contact: {
    titleBeforeHighlight: "هل وضعكم",
    highlight: "حرِج",
    text:
      "لا تترددوا. كل ساعة يمكن أن تصنع فرقاً. فريق SOS جاهز لمساندتكم فوراً على مستوى القيادة والتنفيذ.",
    bullets: [
      "جاهزية على مدار 24/7",
      "خبراء متمرّسون في إدارة الأزمات",
      "تأثير سريع وملموس"
    ],
    hotlineButton: "خط طوارئ: ‎+49 xxx xxx xxx",
    emailButton: "البريد الإلكتروني: sos@globalegroupe.de"
  }
},
contactPage: {
  hero: {
    highlight: "التحول",
    titleRest: "لا يبدأ باجتماع Kick-off",
    subtitle: "بل يبدأ بحوار صادق وواضح.",
    bullets: ["استجابة خلال ٢٤ ساعة", "سرية تامة", "تواصل شخصي"]
  },
  form: {
    titleBeforeHighlight: "دعونا",
    highlight: "نتحدث",
    nameLabel: "الاسم",
    namePlaceholder: "اسمك الكامل",
    companyLabel: "الشركة",
    companyPlaceholder: "اسم شركتك (اختياري)",
    emailLabel: "البريد الإلكتروني",
    emailPlaceholder: "you@example.com",
    phoneLabel: "رقم الهاتف",
    phonePlaceholder: "+49 xxx xxx xxx",
    topicLabel: "اختر الموضوع",
    topicPlaceholder: "يرجى الاختيار",
    messageLabel: "رسالتك",
    messagePlaceholder:
      "شاركنا باختصار التحدي أو الموقف الذي تود مناقشته...",
    submitLabel: "إرسال الرسالة",
    footerText:
      "نعود إليك خلال ٢٤ ساعة كحد أقصى. جميع بياناتك تُعامل بسرية تامة.",
    topics: [
      "تحول TRIAX®",
      "طلب حزمة SOS طارئة",
      "حل من برامج Signature",
      "استشارات متعددة الثقافات",
      "Coaching للقيادة",
      "جلسة استشارية أولية",
      "موضوع آخر"
    ]
  },
  contactInfo: {
    titleBeforeHighlight: "قنوات تواصل",
    highlight: "مباشرة",
    emailLabel: "البريد الإلكتروني",
    email: "hello@globalegroupe.com",
    linkedinLabel: "LinkedIn",
    linkedin: "linkedin.com/company/globalegroupe",
    hotlineLabel: "خط الطوارئ SOS",
    hotlineNumber: "+49 xxx xxx xxx",
    hotlineNote: "للحالات العاجلة فقط"
  },
  why: {
    title: "لماذا GloBridge؟",
    bullets: [
      "قراءة أولية للموقف خلال ٢٤ ساعة",
      "جلسة تعريفية مجانية (٣٠ دقيقة)",
      "سرية كاملة في التعامل مع المعلومات",
      "توصيات عملية وواضحة بعيداً عن التنظير"
    ]
  },
  locations: {
    titleBeforeHighlight: "مكاتبنا",
    highlight: "الرئيسية",
    subtitle: "منطقة DACH · أفريقيا · دول الخليج – حيث تتواجدون أنتم"
  },
  offices: [
    {
      region: "منطقة DACH",
      city: "فرانكفورت",
      address: "Bockenheimer Landstraße 123, 60325 Frankfurt",
      phone: "+49 69 123 456 789",
      email: "dach@globalegroupe.com",
      gradient: "from-purple-600 to-blue-600"
    },
    {
      region: "منطقة MENA",
      city: "دبي",
      address: "DIFC, Gate Village 10, Level 5, Dubai",
      phone: "+971 4 123 456 789",
      email: "mena@globalegroupe.com",
      gradient: "from-orange-500 to-red-500"
    },
    {
      region: "شمال أفريقيا",
      city: "الدار البيضاء",
      address: "Twin Center, Tour A, Angle Boulevards",
      phone: "+212 522 123 456",
      email: "africa@globalegroupe.com",
      gradient: "from-emerald-500 to-teal-600"
    }
  ],
  finalCTA: {
    titleBeforeHighlight: "جاهزون لاتخاذ",
    highlight: "الخطوة الأولى",
    text:
      "التحول الحقيقي يبدأ من حوار صادق. لنكتشف معاً كيف يمكننا وضع منظمتكم في حالة رنين صحي وفعّال.",
    primaryButton: "حجز موعد",
    secondaryButton: "استشارة أولية مجانية"
  }
},
insightsPage: {
  hero: {
    chipLabel: "قصص نجاح ورؤى عملية",
    titleHighlight: "Insights",
    titleRest: "تعلّم من التجارب الحقيقية",
    subtitle:
      "مشاريع حقيقية، نتائج قابلة للقياس، وأصوات عملاء حقيقية. اكتشف كيف يساهم TRIAX® وحلول Signature في تحويل المنظمات."
  },
  tabs: {
    successStories: "قصص نجاح",
    caseStudies: "دراسات حالة",
    blogPlanned: "مدوّنة (قريباً)"
  },
  labels: {
    challenge: "التحدي",
    solution: "الحل",
    results: "النتائج بالأرقام"
  },
  metrics: {
    timeline: "الإطار الزمني",
    roi: "العائد على الاستثمار",
    satisfaction: "رضا العملاء"
  },
  caseStudies: [
    {
      title: "تفكيك انسداد ثقافي معقّد",
      category: "CultureBridge MENA",
      duration: "٣ أشهر",
      challenge:
        "مورد ألماني لقطاع السيارات واجه صعوبات كبيرة في التوسع داخل منطقة الشرق الأوسط وشمال أفريقيا بسبب حواجز ثقافية وسوء فهم متكرر.",
      solution:
        "تحليل ثقافي قائم على نموذج TRIAX® وبرنامج CultureBridge مصمّم خصيصاً.",
      results: [
        "زيادة ١٥٠٪ في الإيرادات داخل منطقة الشرق الأوسط وشمال أفريقيا",
        "انخفاض ٨٥٪ في فشل المفاوضات",
        "إبرام شراكات مع ٣ موزعين محليين"
      ],
      quote:
        "\"لم ينقذ CultureBridge أعمالنا فحسب، بل فتح لنا باب منطقة كاملة.\"",
      author: "الرئيس التنفيذي، مورد سيارات (DAX)",
      metrics: {
        timeline: "٦ أشهر",
        roi: "٤٠٠٪",
        satisfaction: "٩.٨/١٠"
      },
      image:
        "https://images.unsplash.com/photo-1552084850-c6a1fc7cf717?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzU2MjQ4MzUzfDA&ixlib=rb-4.1.0&q=85"
    },
    {
      title: "إعادة إحياء إعادة هيكلة متعثّرة",
      category: "Change Sparring 6",
      duration: "٦ أشهر",
      challenge:
        "عملية إعادة هيكلة في شركة FinTech أدّت إلى مقاومة داخلية وانخفاض واضح في الإنتاجية.",
      solution:
        "Change Sparring منهجي مع الإدارة باستخدام منهجية TRIAX®.",
      results: [
        "زيادة ٦٠٪ في مستوى التفاعل والالتزام",
        "انخفاض ٤٠٪ في معدل دوران الموظفين",
        "إتمام عملية إعادة الهيكلة بنجاح"
      ],
      quote:
        "\"بدون Change Sparring، على الأغلب كنّا سنفشل. هذا الدعم كان نقطة التحوّل.\"",
      author: "المدير العام، شركة FinTech",
      metrics: {
        timeline: "٦ أشهر",
        roi: "٢٥٠٪",
        satisfaction: "٩.٥/١٠"
      },
      image:
        "https://images.unsplash.com/photo-1675392347224-ae88c11def9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      title: "مبيعات أكثر رشاقة – وأكثر نجاحاً",
      category: "Scrum4Sales Sprint",
      duration: "١٢ أسبوعاً",
      challenge:
        "فريق مبيعات B2B تقليدي يعاني من دورات بيع طويلة وأداء فريق منخفض.",
      solution:
        "تطبيق Scrum4Sales مع إيقاعات عمل رشيقة، وشفافية عالية، وبنية Sprints واضحة.",
      results: [
        "تقليص دورات البيع بنسبة ٤٥٪",
        "زيادة معدل الإغلاق بنسبة ٧٠٪",
        "ارتفاع إنتاجية الفريق بنسبة ٨٠٪"
      ],
      quote:
        "\"Scrum4Sales غيّر طريقة عمل فريق المبيعات بالكامل. أصبحنا نعمل كفريق واحد حقيقي.\"",
      author: "رئيس قسم المبيعات، برمجيات B2B",
      metrics: {
        timeline: "٣ أشهر",
        roi: "٣٢٠٪",
        satisfaction: "٩.٧/١٠"
      },
      image:
        "https://images.unsplash.com/photo-1743842768257-e897326cd11e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85"
    }
  ],
  summary: {
    titleBeforeHighlight: "ملخّص",
    highlight: "الإنجازات",
    stats: [
      {
        metric: "50+",
        label: "مشروعات تم تنفيذها بنجاح"
      },
      {
        metric: "95%",
        label: "نسبة رضا العملاء"
      },
      {
        metric: "300%",
        label: "متوسط العائد على الاستثمار"
      },
      {
        metric: "15",
        label: "دول وأسواق"
      }
    ]
  },
  yourStory: {
    titleBeforeHighlight: "هل حان وقت كتابة",
    highlight: "قصة نجاحكم الخاصة",
    text:
      "هذه النتائج لم تأتِ بالصدفة. إنها ثمرة عمل منهجي باستخدام TRIAX® وحلول Signature. دعونا نبني معاً قصة النجاح القادمة لمنظمتكم.",
    tiles: [
      {
        title: "مجرَّب",
        text: "أكثر من ٥٠ عملية تحول ناجحة."
      },
      {
        title: "قابل للقياس",
        text: "متوسط عائد استثمار يبلغ ٣٠٠٪."
      },
      {
        title: "مستدام",
        text: "٩٥٪ من العملاء راضون على المدى البعيد."
      }
    ],
    buttonLabel: "ابدأوا قصتكم"
  }
},

markets: {
  badgeLabel: 'تميّز عالمي',
  titleBeforeHighlight: 'الأسواق و',
  highlight: 'القطاعات',
  description:
    'نرافق عملاءنا في أسواق مختارة نعرف سياقها الثقافي والاقتصادي جيداً – بما في ذلك أنماط اتخاذ القرار وديناميكيات الأعمال العابرة للثقافات.',
  connectionText:
    'وجودنا العالمي يتيح جسوراً بين الثقافات بدون فجوات.',
  regions: [
    {
      name: 'منطقة DACH',
      countries: ['ألمانيا', 'النمسا', 'سويسرا'],
      image:
        'https://images.unsplash.com/photo-1617375402484-8a196422d93d?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      monument: 'كاتدرائية برلين – العمارة الألمانية',
      specialty: 'دقّة وكفاءة',
      gradient: 'from-slate-600 to-blue-600',
      description: 'قلب التميّز الأوروبي في عالم الأعمال.'
    },
    {
      name: 'الشرق الأوسط',
      countries: ['الإمارات العربية المتحدة', 'المملكة العربية السعودية', 'قطر'],
      image:
        'https://images.unsplash.com/photo-1653763843954-0ad7300268a6?q=80&w=435&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      monument: 'أبراج الإمارات ومتحف المستقبل',
      specialty: 'شراكة وثقة',
      gradient: 'from-orange-500 to-amber-500',
      description: 'حيث تلتقي التقاليد بالابتكار.'
    },
    {
      name: 'شمال أفريقيا',
      countries: ['المغرب', 'تونس', 'مصر'],
      image:
        'https://images.unsplash.com/photo-1699210260021-eac11ba4ff86?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      monument: 'مسجد الحسن الثاني – الدار البيضاء',
      specialty: 'تقاليد وابتكار',
      gradient: 'from-emerald-600 to-teal-600',
      description: 'جسر ثقافي بين القارات.'
    }
  ]
},
expertise: {
  badgeElite: "خدمات النخبة",
  title: "خبرتنا",
  titleHighlight: "الـSignature",
  description:
    "تجمع GLOBRIDGE بين إدارة التغيير المنهجية، والذكاء الثقافي، وExecutive Sparring في باقة Premium مصمّمة بعناية.",
  subDescription:
    "أربع خدمات Signature، منطق واحد: تحوّل عميق وقابل للقياس – بعيداً عن العروض النظرية فقط.",

  services: [
    {
      id: "change-management",
      iconName: "Zap",
      background:
        "https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-purple-600 to-blue-600",
      title: "إدارة تغيير منهجية (Systemic)",
      subtitle: "Resonance Flow Framework",
      description:
        "مرافقة شاملة لتحوّلات معقّدة – من التشخيص وحتى التثبيت الفعلي في الواقع اليومي.",
      features: [
        "تشخيص TRIAX® للثقافة والهيكل والإنسان",
        "إطار Resonance Flow من ٥ مراحل",
        "Sparring استراتيجي مع الإدارة العليا وأصحاب المصلحة",
        "مخرجات واضحة ومؤشرات KPI لكل مرحلة"
      ],
      href: "/services",
      cta: "اكتشاف منهجية التغيير"
    },
    {
      id: "leadership-coaching",
      iconName: "Users",
      background:
        "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-emerald-500 to-teal-600",
      title: "Leadership & Executive Coaching",
      subtitle: "رنين حقيقي لقادة الصف الأول",
      description:
        "مساحة Sparring عملية لقيادات تتعامل مع تحوّلات عالية الحساسية.",
      features: [
        "جلسات Coaching فردية لقادة الصف الأول",
        "تطوير القيادة في فترات التحوّل",
        "المرونة، الوضوح، وقوة اتخاذ القرار",
        "مساحة Sparring سرّية وعلى مستوى النظر"
      ],
      href: "/services",
      cta: "تعزيز القيادة"
    },
    {
      id: "scrum4sales",
      iconName: "Target",
      background:
        "https://images.unsplash.com/photo-1556740749-887f6717d7e4?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-orange-500 to-red-500",
      title: "Scrum4Sales Sprint",
      subtitle: "مبيعات رشيقة (Agile Sales)",
      description:
        "نحوّل فرق المبيعات إلى وحدات سريعة، متكيّفة، ومحكومة بالبيانات.",
      features: [
        "إيقاعات عمل رشيقة لفرق المبيعات (Sprints, Reviews, Retros)",
        "شفافية كاملة في الـPipeline وأولويات مشتركة",
        "قرارات مبنية على البيانات لا على الحدس فقط",
        "تمكين الفرق لتعمل بمسؤولية واستقلالية"
      ],
      href: "/services",
      cta: "استكشاف Scrum4Sales"
    },
    {
      id: "culturebridge-mena",
      iconName: "Star",
      background:
        "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-violet-500 to-purple-600",
      title: "CultureBridge MENA",
      subtitle: "ذكاء أعمال بين DACH والمنطقة العربية",
      description:
        "بناء جسور عملية بين DACH ومنطقة الشرق الأوسط وشمال أفريقيا للتوسّع والصفقات الحسّاسة.",
      features: [
        "تهيئة موجّهة لسياقات الأعمال بين DACH ومنطقة الشرق الأوسط وشمال أفريقيا",
        "قواعد التعامل، أساليب التفاوض، ومنطق اتخاذ القرار",
        "مرافقة في الصفقات الحسّاسة والشراكات الإستراتيجية",
        "دليل ثقافي و Playbooks عملية للفِرَق"
      ],
      href: "/sos",
      cta: "التعرّف على CultureBridge"
    }
  ],

  dna: {
    badge: "GLOBRIDGE DNA",
    titleBeforeHighlight: "ما الذي يضعنا ضمن",
    titleHighlight: "أعلى 1٪",
    titleAfterHighlight: "من بيوت الاستشارات",
    description:
      "أربعة أعمدة للتميّز تشكّل نظام TRIAX® لدينا – منهجي، ذكي ثقافياً، وقابل للقياس في أثره.",

    systemicDepth: {
      title: "عمق منهجي (Systemic)",
      line1: "نحوّل الأنظمة ككل،",
      line2: "لا نعالج الأعراض فقط.",
      chip: "منهجية TRIAX®"
    },
    culturalIntelligence: {
      title: "ذكاء ثقافي",
      line1: "نترجم بسلاسة بين",
      line2: "الثقافات والأسواق.",
      chip: "DACH × MENA"
    },
    humanResonance: {
      title: "رنين إنساني",
      line1: "نصنع صدى إنساني حقيقي،",
      line2: "لا استراتيجيات على الورق فقط.",
      chip: "قيادة بالرنين"
    },
    measurableImpact: {
      title: "أثر قابل للقياس",
      line1: "نركّز على نتائج",
      line2: "قابلة للقياس وعائد استثمار واضح.",
      chip: "إثبات للأداء"
    }
  },

  cta: {
    questionBeforeHighlight: "هل أنتم مستعدون لتحوّل على",
    highlight: "مستوى النخبة (أعلى 1٪)",
    button: "حجز جلسة استشارية تنفيذية"
  }
},

readiness: {
  title: 'فحص جاهزية التحوّل',
  subtitle: 'قيّموا مدى جاهزية مؤسستكم فعلياً للتغيير.',

  scoreLabel: 'نسبة الجاهزية',

  levelHigh: 'مرتفعة',
  levelMedium: 'متوسطة',
  levelLow: 'منخفضة',

  messageHigh:
    'فريقكم جاهز. التركيز الآن على التحسين، التوسيع، واختيار الروافع الأكثر تأثيراً.',
  messageMedium:
    'الأساس موجود. نوصي بتدخّلات موجهة في الـCoaching وإدارة التغيير.',
  messageLow:
    'ننصح بمرافقة مكثّفة. نبدأ بتشخيص للرنين (Resonance) وخارطة طريق واضحة للتحوّل.',

  questions: {
    vision: {
      question: 'ما مدى وضوح رؤية التحوّل داخل الفريق؟',
      options: {
        veryClear: 'واضحة جداً',
        partlyClear: 'واضحة إلى حد ما',
        unclear: 'غير واضحة',
        noVision: 'لا توجد رؤية'
      }
    },
    resistance: {
      question: 'ما مستوى المقاومة تجاه التغيير؟',
      options: {
        veryLow: 'منخفضة جداً',
        moderate: 'متوسطة',
        high: 'مرتفعة',
        veryHigh: 'مرتفعة جداً'
      }
    },
    culture: {
      question:
        'هل توجد تحديات ثقافية (مثل التعاون بين DACH ومنطقة الشرق الأوسط وشمال أفريقيا)؟',
      options: {
        none: 'لا',
        few: 'قليلة',
        some: 'بعض التحديات',
        many: 'تحديات كثيرة'
      }
    },
    salesAgility: {
      question: 'ما مدى رشاقة (Agility) فريق المبيعات لديكم؟',
      options: {
        veryAgile: 'رشيق جداً',
        partlyAgile: 'رشيق إلى حد ما',
        traditional: 'نموذجي/تقليدي',
        rigid: 'صلب وغير مرن'
      }
    }
  }
},
    footer: {
      claim: "استشارات مساحة الرنين – حيث يعمل التغيير. وليس مجرد مظهر للعمل.",
      rights: "© 2024 GLOBRIDGE. جميع الحقوق محفوظة.",
      privacy: "سياسة الخصوصية",
      imprint: "بيانات قانونية"
    }
  },
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      about: "À propos",
      triax: "TRIAX®",
      services: "Services",
      signature: "Programmes Signature", 
      sos: "Support SOS",
      insights: "Perspectives",
      contact: "Contact"
    },
    navDropdown: {
  services: {
    change: {
      title: "Change sans schéma tout fait",
      description: "Gestion du changement systémique, taillée sur mesure – loin des modèles génériques."
    },
    bridges: {
      title: "Business entre les mondes",
      description: "Intelligence interculturelle concrète pour des collaborations transfrontalières qui tiennent."
    },
    scrum4sales: {
      title: "Scrum4Sales",
      description: "Réinventer la vente avec l’agile : sprints, focus et dynamique de closing."
    },
    leadership: {
      title: "Atelier Leadership Résonance",
      description: "Coaching et sparring pour dirigeants et expats dans des environnements complexes."
    }
  },
  signature: {
    foundation: {
      title: "Resonance Foundation",
      description: "Les fondamentaux d’un change management durable."
    },
    accelerator: {
      title: "Resonance Accelerator",
      description: "Aligner transformation et développement du leadership dans un même dispositif."
    },
    transformation: {
      title: "Resonance Transformation",
      description: "Full RFF – accompagnement end-to-end de votre trajectoire de transformation."
    },
    sos: {
      title: "Resonance SOS",
      description: "Intervention rapide et ciblée en situation de crise."
    }
  },
  insights: {
    successStories: {
      title: "Histoires de succès",
      description: "Case studies avec chiffres, impact et enseignements actionnables."
    },
    caseStudies: {
      title: "Case studies",
      description: "Analyses détaillées de projets et d’architectures de transformation."
    },
    blog: {
      title: "Blog",
      description: "Réflexions stratégiques et pensée leadership (à venir)."
    }
  }
},
    // Welcome Section
    welcome: {
      title: "Bienvenue chez GLOBRIDGE",
      subtitle: "Votre partenaire pour la transformation systémique et l'intelligence interculturelle. Nous connectons les mondes – culturellement, technologiquement, humainement.",
      card1: {
        title: "Modèle TRIAX®",
        description: "Le modèle de transformation interculturelle : Entre Système & Humain, entre Stratégie & Impact"
      },
      card2: {
        title: "Business entre les Mondes",
        description: "Collaboration réussie au-delà des frontières culturelles. Ponts interculturels entre DACH et MENA"
      },
      card3: {
        title: "Services Premium & Support SOS",
        description: "Solutions sur mesure et aide immédiate pour des processus de changement durables et des crises de transformation aiguës"
      },
      cta: "Commencer le Dialogue Exécutif"
    },
    // Silent Epidemic New Section
    silentEpidemicNew: {
      title: "L'Épidémie Silencieuse dans les Entreprises",
      subtitle: "Pendant que tout le monde parle de digitalisation, 70% des projets de transformation échouent. Pourquoi? Parce que l'humain est oublié.",
      stat1: "des projets de changement échouent parce que les facteurs culturels et humains sont ignorés",
      stat2: "sont gaspillés chaque année par des transformations échouées",
      stat3: "des dirigeants se sentent mal préparés pour les affaires internationales",
      billion: "Mrd",
      bottomTitle: "Le problème n'est pas dans la technologie. Il est dans l'exécution.",
      bottomDescription: "Entre vision et réalité, entre leadership et équipe, entre cultures et marchés. Nous sommes les interprètes de ces langues invisibles."
    },
    // Hero Slider
    hero: {
slide1: {
  headline: "La transformation    n’est pas un projet. C’est un langage.",
  subheadline: "Nous le parlons couramment, entre systèmes et humains, entre stratégie et impact, entre régions DACH et MENA.",
  claim: "Là où la stratégie rencontre l’humain et où les projets deviennent un impact durable.",
  cta: "Planifier un échange stratégique"
},
slide2: {
  headline: "Intelligence interculturelle    Nous bâtissons des ponts là où les autres rencontrent des frontières.",
  subheadline: "L’avantage concurrentiel silencieux.",
  cta: "En savoir plus"
},
slide3: {
  headline: "TRIAX®      notre système exclusif de transformation holistique.",
  subheadline: "Une approche fondée sur la recherche qui aligne structure, culture et humain de façon systématique, pour des changements qui fonctionnent vraiment.",
  cta: "Découvrir TRIAX®"
},
slide4: {
  headline: "Scrum4Sales      une nouvelle façon de penser la vente : collaborative, adaptative, performante.",
  subheadline: "Une agilité qui fait vendre.",
  cta: "Planifier un échange stratégique"
}

    },
    silentEpidemic: {
      badge: "L'épidémie silencieuse",
      title: "Nous vivons dans un moment qui accélère tout et paralyse en même temps.",
      description1: "La numérisation, l'intelligence artificielle, les médias sociaux et les tensions mondiales ne changent pas seulement les marchés.",
      description1Highlight: "Ils changent les gens.",
      description2: "Les équipes se brisent, le leadership devient un exploit de force, les cultures s'entrechoquent et derrière chaque processus se trouve un humain qui doit décider, diriger, fonctionner.",
      description3: "Et pourtant beaucoup ressentent: Il faut quelque chose qui ne peut être mesuré. Plus profond. Plus vrai. Quelque chose manque.",
      description4: "Pas de plan, d'outil ou d'autre stratégie. Mais ce qui se trouve entre.",
      description5: "Entre ce qui pourrait être possible – et ce qui reste réalité.",
      quote: "C'est le paradoxe du business moderne: Plus la technologie devient bruyante, plus le génie humain devient silencieux.",
      imageQuote: "GLOBRIDGE déploie la transformation comme un parfum exquis:",
      imageQuoteHighlight: "profond, précis, durable.",
      imageSignature: "La résonance est notre parfum signature.",
      bottomTitle1: "Nous ne construisons pas des stratégies.",
      bottomTitle2: "Nous construisons la résonance.",
      bottomDescription: "Un système invisible à trois parties de culture, humain et structure – finement accordé, courageusement composé, perceptible dans chaque mouvement.",
      cta1: "Planifier une conversation",
      cta2: "Découvrir TRIAX"
    },
    expertise: {
      title: "Mettre l'impact en",
      titleHighlight: "mouvement",
      description: "Quatre piliers puissants qui ne promettent pas seulement la transformation – mais la livrent de manière mesurable. Pensé systémiquement, culturellement intelligent, humainement efficace.",
      subDescription: "Ce n'est pas du conseil standard. C'est l'impact dans sa forme la plus intelligente.",
      services: [
        {
          id: 'change',
          iconName: 'Zap',
          title: 'Gestion du changement systémique',
          subtitle: 'Transformation avec profondeur',
          description: 'Changement qui ne fonctionne pas seulement superficiellement, mais est ancré systémiquement.',
          features: [
            'Changement culturel',
            'Intégration structurelle',
            'Acceptation humaine',
            'Ancrage durable'
          ],
          background: 'https://images.unsplash.com/photo-1709221387675-403ac1a6003a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBhYnN0cmFjdHxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NTY0ODQwNDJ8MA&ixlib=rb-4.1.0&q=85',
          cta: 'Découvrir la gestion du changement',
          href: '/services#service-0',
          gradient: 'from-purple-600 to-blue-600'
        },
        {
          id: 'coaching',
          iconName: 'Users',
          title: 'Coaching d\'entreprise',
          subtitle: 'Excellence du leadership',
          description: 'Développement des cadres au plus haut niveau pour des résultats durables.',
          features: [
            'Coaching exécutif',
            'Développement d\'équipe',
            'Résonance du leadership',
            'Boost de performance'
          ],
          background: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
          cta: 'Découvrir le programme de coaching',
          href: '/services#service-1',
          gradient: 'from-emerald-500 to-teal-600'
        },
        {
          id: 'sales',
          iconName: 'Target',
          title: 'SCRUM pour les ventes',
          subtitle: 'Révolution des ventes agiles',
          description: 'Transformer les équipes de vente de manière agile pour des taux de clôture mesurables plus élevés.',
          features: [
            'Méthodologie de vente agile',
            'Synchronisation d\'équipe',
            'Suivi des performances',
            'Boost de conversion'
          ],
          background: 'https://images.unsplash.com/photo-1629471361722-e1306b0c0e42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw1fHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85',
          cta: 'Expérimenter Scrum4Sales',
          href: '/services#service-2',
          gradient: 'from-orange-500 to-red-500'
        },
        {
          id: 'intercultural',
          iconName: 'Star',
          title: 'Intelligence commerciale interculturelle',
          subtitle: 'Excellence d\'expansion mondiale',
          description: 'Construire des ponts culturels pour des affaires mondiales réussies.',
          features: [
            'Expertise MENA',
            'Intelligence culturelle',
            'Stratégie d\'entrée sur le marché',
            'Équipes interculturelles'
          ],
          background: 'https://images.unsplash.com/photo-1672664003230-106aa4f534c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85',
          cta: 'Découvrir l\'intelligence mondiale',
          href: '/services#service-3',
          gradient: 'from-violet-500 to-purple-600'
        }
      ]
    },
    markets: {
      title: "Marchés &",
      description: "DACH · Moyen-Orient · Afrique du Nord – où la compétence culturelle décide."
    },
    // Triax Section
    triaxSection: {
      title: "Qu'est-ce que et pourquoi TRIAX®?",
      classical: "Le conseil classique sépare les silos",
      classicalDesc: "Processus ↔ Culture ↔ Humain séparés.",
      triax: "TRIAX® intègre de manière holistique", 
      triaxDesc: "Comportement, processus, performance comme un système.",
      highlights: [
        "Augmentation des KPI grâce à l'harmonisation du système",
        "Système d'alerte précoce pour les résistances",
        "Transparence sur les interdépendances"
      ],
      cta: "Nous ne vendons pas des services. Nous livrons des transformations."
    },
    // For Whom Section
    forWhom: {
      title: "Pour les entreprises leaders et ambitieuses",
      subtitle: "Ce n'est pas un site web ordinaire. C'est une évaluation stratégique de votre préparation.",
      intro: "Si 3+ des points suivants s'appliquent, votre entreprise est prête pour un partenariat avec nous:",
      points: [
        "Vous implémentez des technologies d'IA de pointe, mais vos réunions sont plus sans vie et improductives que jamais.",
        "Les projets d'expansion livrent d'excellents résultats financiers, mais ressemblent plus à des acquisitions qu'à des partenariats.",
        "Vous êtes certifiés en méthodologies Agiles – mais votre structure organisationnelle fonctionne encore comme dans les années 80.",
        "Votre équipe parle six langues différentes – sauf le langage de la compréhension mutuelle.",
        "Vous lisez ce texte avec un pouls accéléré et une prise de conscience croissante de votre entreprise."
      ],
      notFor: "Entreprises que nous ne servons pas:",
      notForDesc: "Solutions rapides superficielles · Projets juste pour l'apparence · Pensée orientée tâches au lieu de parcours · Manque de courage pour les vérités inconfortables.",
      whyDifferent: "Ce qui nous rend différents:",
      whyDifferentDesc: "Précision allemande × sagesse orientale authentique · Profondeur × pragmatisme · Poser les bonnes questions au lieu de vendre des solutions · Formateur/partenaire stratégique/traducteur culturel."
    },
    // Markets Section
    markets: {
      title: "Marchés et Régions",
      subtitle: "Où nous construisons des ponts",
      dach: {
        title: "DACH",
        description: "Allemagne, Autriche, Suisse - précision européenne avec intelligence culturelle"
      },
      mena: {
        title: "MENA",
        description: "Moyen-Orient et Afrique du Nord - compréhension culturelle profonde et réseaux locaux"
      },
      international: {
        title: "International",
        description: "Expansion mondiale avec sensibilité culturelle"
      }
    },
    journeyTimeline: {
  milestones: [
    {
      year: 'Origines',
      title: 'Grandir entre plusieurs mondes',
      description:
        'Né entre plusieurs cultures, élevé entre plusieurs continents. DACH, MENA, Europe – non pas en touriste, mais comme partie prenante de plusieurs réalités.'
    },
    {
      year: 'Académie',
      title: 'International Business & études interculturelles',
      description:
        'Un socle académique en International Business, en études interculturelles et en change management systémique. La théorie comme fondation, jamais comme doctrine rigide.'
    },
    {
      year: 'Certification',
      title: 'Consultant Change Management ISO-EN-17024',
      description:
        'Certification internationale en gestion du changement. Non pas pour accumuler les labels, mais parce que l’excellence s’appuie sur des standards clairs.'
    },
    {
      year: 'Pratique',
      title: 'Project Delivery & accompagnement de transformation',
      description:
        'Des années de terrain : delivery de projets, programmes de change, équipes internationales. Du Mittelstand aux grands groupes. De Munich à Marrakech.'
    },
    {
      year: 'Innovation',
      title: 'TRIAX® & Resonance Flow Framework',
      description:
        'La synthèse : TRIAX® comme modèle systémique (culture–humain–structure) et le Resonance Flow Framework comme méthodologie scalable.'
    },
    {
      year: 'Aujourd’hui',
      title: 'GLOBRIDGE – Boutique de conseil',
      description:
        'Ni grand cabinet, ni produit standardisé. Une boutique pour les organisations qui cherchent une transformation profonde – avec résonance, pas seulement avec des outils.'
    }
  ]
},
about: {
  hero: {
    badge: "Identité & origine",
    titleLine1: "Né(e) entre plusieurs mondes.",
    titleHighlight: "Conçu(e) pour les relier.",
    subtitle:
      "GLOBRIDGE n’a pas été créé pour vendre du conseil classique. Mais pour combler un vide stratégique que beaucoup ne voient même pas.",
    quoteLine1:
      "Entre système et humain. Entre stratégie et impact réel.",
    quoteLine2: "Entre cultures et marchés.",
    imageAlt:
      "Contexte business professionnel dans un environnement international"
  },
  story: {
    titleBeforeHighlight: "Qui",
    titleHighlight: "nous sommes",
    p1:
      "GLOBRIDGE n’est pas une « entreprise » au sens traditionnel. C’est la synthèse d’un parcours personnel – grandi entre les cultures, formé académiquement, éprouvé sur le terrain.",
    p2:
      "Consultant en Change Management certifié ISO-EN-17024, avec un parcours en International Business et en études interculturelles, et une expérience de Project Delivery Manager, j’ai appris très tôt une chose essentielle :",
    quote:
      "La transformation n’échoue pas à cause des outils. Elle échoue lorsque l’humain disparaît de l’équation.",
    p3:
      "J’ai vu trop de stratégies brillantes se fracasser sur des angles morts culturels, des résistances internes ou un manque d’écoute. GLOBRIDGE est né comme une boutique de transformation systémique, orientée profondeur plutôt que volume.",
    closing:
      "Non pas pour réinventer le conseil, mais pour habiter l’espace entre le système et le vivant, entre la structure et l’humanité.",
    floatingQuote:
      "L’impact ne vient pas des méthodes seules, mais de la résonance qu’elles créent."
  },
  credentials: {
    title: "Fondations &",
    highlight: "crédits",
    subtitle:
      "Pas pour accumuler les labels, mais parce que l’excellence exige des standards clairs",
    items: [
      {
        id: "iso",
        title: "ISO-EN-17024",
        subtitle: "Consultant en Change Management",
        description:
          "Certification internationale en gestion du changement, alignée sur les standards européens."
      },
      {
        id: "academic",
        title: "Background académique",
        subtitle: "International Business & études interculturelles",
        description:
          "Expertise de niveau master en business international et communication interculturelle."
      },
      {
        id: "delivery",
        title: "Project Delivery Manager",
        subtitle: "Expérience terrain",
        description:
          "Années de pratique sur des projets de transformation, du Mittelstand aux grands groupes."
      },
      {
        id: "dach-mena",
        title: "Expertise DACH–MENA",
        subtitle: "Arabe · Français · Allemand",
        description:
          "Compétence trilingue pour des trajectoires de transformation entre Europe et monde arabe."
      }
    ]
  },
  journey: {
    title: "La",
    highlight: "trajectoire",
    subtitle:
      "Des racines interculturelles à la transformation systémique"
  },
  values: {
    title: "Notre",
    highlight: "philosophie",
    subtitle:
      "Des valeurs qui se vivent dans les projets – pas seulement dans les slides",
    items: [
      {
        id: "resonance",
        title: "La résonance avant la perfection",
        description:
          "Nous ne croyons pas aux stratégies parfaites. Nous croyons aux connexions humaines qui rendent le changement réellement possible."
      },
      {
        id: "systemic",
        title: "Systémique & lucide",
        description:
          "Nous pensons en systèmes (TRIAX®), tout en questionnant les dogmes. Une méthodologie exigeante, avec humilité et pragmatisme."
      },
      {
        id: "cultural",
        title: "Intelligence culturelle",
        description:
          "Les transformations échouent rarement à cause d’outils, mais souvent à cause d’angles morts culturels. Nous jouons le rôle de traducteur entre univers."
      },
      {
        id: "boutique",
        title: "Une boutique, pas une usine à slides",
        description:
          "Pas d’armées de juniors, pas de solutions standard. Un accompagnement senior, ciblé, pour des enjeux à fort impact."
      }
    ]
  },
  difference: {
    title: "Ce qui nous rend",
    highlight: "différents",
    subtitle: "De la transparence plutôt que du discours marketing",
    blocks: [
      {
        id: "not",
        title: "Ce que nous ne faisons pas",
        points: [
          "Pas de decks PowerPoint de 200 pages que personne ne lit.",
          "Pas de juniors qui récitent des modèles théoriques hors contexte.",
          "Pas de frameworks « one-size-fits-all ».",
          "Pas de promesses creuses uniquement pour décrocher le projet."
        ]
      },
      {
        id: "offer",
        title: "Ce que nous apportons",
        points: [
          "Des partenaires de sparring au même niveau que vos dirigeants.",
          "Une pensée systémique alliée à une mise en œuvre concrète.",
          "Une véritable intelligence culturelle – au-delà de la simple « sensibilisation ».",
          "Une posture honnête : nous conseillons et accompagnons, vous décidez."
        ]
      }
    ],
    promiseLead: "La promesse GLOBRIDGE :",
    promiseText:
      "Nous accompagnons vos transformations avec profondeur, expertise et intelligence culturelle. La décision reste toujours de votre côté. Aucun discours creux – seulement un sparring partner exigeant et loyal."
  },
  method: {
    title: "Notre",
    highlight: "méthodologie",
    subtitle:
      "TRIAX® & Resonance Flow Framework – relier théorie, culture et exécution",
    triax: {
      title: "TRIAX®",
      text:
        "Notre modèle systémique de transformation : considérer culture, humain et structure comme un système vivant, et non comme des silos séparés.",
      linkLabel: "En savoir plus sur TRIAX®"
    },
    rff: {
      title: "Resonance Flow Framework",
      text:
        "Notre méthodologie scalable en 5 phases, de la lecture du système à l’ancrage durable – fluide, adaptable, pilotée par les résultats.",
      linkLabel: "En savoir plus sur RFF"
    },
    reasonsTitle: "Pourquoi cette combinaison ?",
    reasons: [
      {
        id: "systemic",
        title: "Systémique",
        text:
          "TRIAX® adresse l’ensemble de l’organisation, pas uniquement un service ou un projet isolé."
      },
      {
        id: "scalable",
        title: "Scalable",
        text:
          "RFF permet de reproduire et d’industrialiser ce qui fonctionne, sans perdre la finesse du contexte local."
      },
      {
        id: "measurable",
        title: "Mesurable",
        text:
          "Des livrables et des KPI clairs à chaque phase – pour un pilotage lisible côté C-level."
      }
    ]
  },
  cta: {
    titleBeforeHighlight: "Prêt(e) pour une",
    highlight: "transformation réelle",
    text:
      "Explorons ensemble, dans un dialogue exécutif, si nous sommes le bon partenaire pour vous. Pas de pitch commercial, mais un échange direct et exigeant.",
    button: "Commencer un Executive Dialogue"
  }
},
servicesPage: {
  hero: {
    titleLine1: "Resonance Flow Framework",
    titleHighlight: "Notre façon de travailler",
    subtitle:
      "La transformation comme un flux continu de résonance – profond, durable, ajustable. Nous conseillons et accompagnons. La décision reste toujours de votre côté.",
    badge: "Interdisciplinaire · Scalable · Réplicable"
  },
  rff: {
    titleBeforeHighlight: "Les 5 phases clés du",
    highlight: "Resonance Flow",
    subtitle:
      "Un modèle en flux continu, nourri par des boucles de feedback – ajusté à votre contexte, vos enjeux et votre gouvernance."
  },
  servicesSection: {
    titleBeforeHighlight: "Nos",
    highlight: "services en détail",
    subtitle:
      "Cliquez sur un service pour explorer l’approche, les livrables et la valeur business."
  },
  serviceDetails: {
    approachTitle: "Notre approche",
    whyUsLabel: "Pourquoi nous :",
    faqTitle: "Questions fréquentes",
    phaseLabel: "Phase"
  },
  cta: {
    titleBeforeHighlight: "Prêt(e) pour une",
    highlight: "transformation réelle",
    text:
      "Nous combinons méthodologie éprouvée, intelligence interculturelle et écoute exigeante – sans surpromette. Vous gardez la main sur le rythme et le périmètre.",
    button: "Ouvrir un Executive Dialogue"
  },
  services: [
    {
      id: "change-management",
      title: "Change Management systémique",
      subtitle: "Resonance Flow Framework en action",
      intro:
        "Avec une certification ISO-EN-17024 en Change Management, un background académique solide et une expérience terrain, nous accompagnons vos transformations de manière systémique.",
      description:
        "Une transformation ne se limite pas à l’optimisation de processus. Nous adressons l’ensemble du système – culture, structure, leadership et équipes comme un organisme vivant. Le Resonance Flow Framework (RFF) connecte TRIAX®, Scrum/Agile adapté et intelligence interculturelle dans une approche pragmatique.",
      approach: [
        {
          phase: "Clarification de mandat & diagnostic de résonance",
          description:
            "Nous clarifions le besoin réel de changement et identifions les blocages systémiques. Sur la base de TRIAX® et de démarches type design thinking, nous apportons de la lisibilité côté direction.",
          deliverables: [
            "Scan de résonance (culture, humain, structure)",
            "Entretiens avec parties prenantes clés",
            "Change Readiness Assessment",
            "Analyse interculturelle basée sur Hofstede"
          ]
        },
        {
          phase: "Construction de roadmap & coalition de résonance",
          description:
            "Nous co-construisons une feuille de route adaptable et une coalition de sponsors – C-level et acteurs-clés – capable de porter le changement.",
          deliverables: [
            "Backlog Agile de changement",
            "Roadmap intégrant le modèle TRIAX®",
            "Ateliers d’alignement des parties prenantes",
            "Plan de gestion des résistances"
          ]
        },
        {
          phase: "Mise en œuvre & itérations agiles",
          description:
            "Nous déployons le changement en « flow sprints » – avec un focus fort sur l’impact concret plutôt que sur la perfection théorique.",
          deliverables: [
            "Sprints de deux semaines avec revues",
            "Sessions de coaching pour dirigeants",
            "Training résilience pour équipes",
            "Monitoring continu des risques"
          ]
        },
        {
          phase: "Boucles de feedback & ajustements",
          description:
            "Via rétrospectives agiles et pulse surveys, nous collectons le feedback et ajustons l’architecture du changement en continu.",
          deliverables: [
            "Check-ins hebdomadaires",
            "Outils de feedback anonyme",
            "Analyse de perception et de climat",
            "Plans d’ajustement ciblés"
          ]
        },
        {
          phase: "Ancrage & suivi",
          description:
            "Nous veillons à l’ancrage durable à travers un suivi régulier, des rituels et un pilotage par indicateurs.",
          deliverables: [
            "Coaching mensuel des sponsors",
            "Suivi des KPI de transformation",
            "Programmes de résilience",
            "Documentation de capitalisation"
          ]
        }
      ],
      whyUs:
        "Sans ancrage systémique, la majorité des projets de transformation échouent ou s’essoufflent. Nous structurons, challengeons et accompagnons – vous gardez le dernier mot.",
      faq: [
        {
          q: "En quoi RFF se distingue-t-il des modèles classiques de change (Kotter, etc.) ?",
          a: "RFF est un modèle fluide plutôt que linéaire. Il intègre TRIAX®, les principes agiles et la dimension interculturelle, sans rigidité méthodologique."
        },
        {
          q: "Pour quels types d’organisations RFF est-il pertinent ?",
          a: "De la PME au grand groupe. Le framework est modulaire et s’ajuste au périmètre et au degré de maturité."
        }
      ]
    },
    {
      id: "business-coaching",
      title: "Business Coaching & Leadership Development",
      subtitle: "Leadership de résonance pour dirigeants",
      intro:
        "Être dirigeant aujourd’hui, c’est bien plus que décider vite. C’est créer de la résonance, piloter des cultures multiples et guider les équipes dans la complexité.",
      description:
        "Nous accompagnons les leaders – individuellement et en équipe – dans leur posture, leurs décisions et leurs dynamiques collectives. Notre approche combine coaching systémique, intelligence culturelle et principes de leadership agile.",
      approach: [
        {
          phase: "Coaching exécutif 1:1",
          description:
            "Accompagnement individuel pour dirigeants et C-level, centré sur le leadership authentique, la clarté de rôle et l’alignement stratégique.",
          deliverables: [
            "Analyse de feedback 360°",
            "Plans de développement personnalisés",
            "Sessions de deep-dive trimestrielles",
            "Outils de gestion du stress et de la charge"
          ]
        },
        {
          phase: "Coaching d’équipe haute performance",
          description:
            "Accompagnement d’équipes de direction ou d’équipes projet dans la coopération, la résolution de tensions et la co-responsabilité.",
          deliverables: [
            "Diagnostic d’équipe",
            "Médiation et facilitation de conflits",
            "Dispositifs de confiance et de feedback",
            "Rituels agiles d’équipe"
          ]
        },
        {
          phase: "Leadership interculturel",
          description:
            "Particulièrement adapté aux contextes DACH–MENA et aux environnements internationaux : développer une posture de leader réellement globale.",
          deliverables: [
            "Analyses culturelles basées sur Hofstede",
            "Workshops sur les codes de leadership par région",
            "Guides de comportements concrets",
            "Playbooks de communication interculturelle"
          ]
        },
        {
          phase: "Leadership en phase de transformation",
          description:
            "Sparring et accompagnement dans les phases sensibles de changement, avec un focus sur l’énergie des équipes et les parties prenantes.",
          deliverables: [
            "Workshops de Change Leadership",
            "Sessions de sparring stratégique",
            "Renforcement de la résilience individuelle et collective",
            "Coaching continu sur la durée du projet"
          ]
        }
      ],
      whyUs:
        "Une large part des dirigeants se sentent sous-équipés face à la complexité globale. Nous jouons le rôle de sparring partner exigeant, sans posture de surplomb.",
      faq: [
        {
          q: "Que recouvre concrètement le concept de « leadership de résonance » ?",
          a: "Un leadership qui crée de l’écho, de la confiance et de la clarté – émotionnellement et culturellement – plutôt qu’un leadership purement technique ou contrôlant."
        },
        {
          q: "Quelle est la durée typique d’un programme de coaching ?",
          a: "De quelques mois à une année, en fonction du niveau de transformation souhaité. Le format est construit sur mesure."
        }
      ]
    },
    {
      id: "scrum-for-sales",
      title: "SCRUM for Sales",
      subtitle: "Révolution agile des forces de vente",
      intro:
        "Le cycle de vente n’est plus linéaire. Avec SCRUM for Sales, nous introduisons des principes agiles dans vos équipes commerciales pour accélérer, sécuriser et mieux prioriser.",
      description:
        "Nous adaptons les principes de Scrum (sprints, revues, rétrospectives) aux réalités commerciales. Résultat : des équipes plus réactives, plus synchronisées et plus focalisées sur la création de valeur.",
      approach: [
        {
          phase: "Sales Team Assessment",
          description:
            "Diagnostic des processus de vente actuels, des goulots d’étranglement et des points de friction.",
          deliverables: [
            "Cartographie des processus de vente",
            "Analyse des goulots d’étranglement",
            "Revue de performance d’équipe",
            "Agile Readiness Check"
          ]
        },
        {
          phase: "Implémentation des rituels agiles",
          description:
            "Mise en place de sprints commerciaux, de dailies et de revues orientées pipeline et opportunités.",
          deliverables: [
            "Setup des sprints (cycles de deux semaines)",
            "Dashboards de KPI commerciaux",
            "Rituels de synchronisation d’équipe",
            "Playbook de vente agile"
          ]
        },
        {
          phase: "Pilotage par la donnée & itération",
          description:
            "Décisions guidées par la donnée, couplées à des ajustements continus du ciblage et des approches.",
          deliverables: [
            "Tableaux de bord temps réel",
            "Suivi des taux de conversion",
            "Rétrospectives de sprint",
            "Ajustements stratégiques progressifs"
          ]
        },
        {
          phase: "Coaching & empowerment des équipes",
          description:
            "Accompagnement des commerciaux et des managers dans l’appropriation durable des pratiques agiles.",
          deliverables: [
            "Formations ventes & agilité",
            "Coaching des Sales Leaders",
            "Sessions de peer-learning",
            "Partage de best practices actionnables"
          ]
        }
      ],
      whyUs:
        "Les modèles de vente traditionnels ne suivent plus le rythme des marchés. Nous apportons structure, agilité et lisibilité – sans dogmatisme méthodologique.",
      faq: [
        {
          q: "Le Scrum est-il vraiment applicable aux ventes ?",
          a: "Oui, à condition de l’adapter. Nous utilisons les principes agiles comme leviers de pilotage, pas comme religion méthodologique."
        },
        {
          q: "Quels KPI suivez-vous en priorité ?",
          a: "Taux de conversion, durée du cycle de vente, engagement des équipes, vitesse de pipeline – adaptés à votre modèle."
        }
      ]
    },
    {
      id: "intercultural-intelligence",
      title: "Intercultural Business Intelligence",
      subtitle: "Expertise DACH–MENA & expansion globale",
      intro:
        "Les projets internationaux échouent rarement sur la stratégie, mais souvent sur le culturel. Nous traduisons les codes business, pas uniquement les langues.",
      description:
        "Avec une forte expérience entre l’espace DACH et la région MENA, nous accompagnons les entreprises dans leurs expansions, joint-ventures et partenariats. Notre approche combine lectures culturelles, intelligence politique et retour terrain.",
      approach: [
        {
          phase: "Cultural Due Diligence",
          description:
            "Avant une entrée de marché ou une alliance stratégique, nous analysons les risques et leviers culturels.",
          deliverables: [
            "Rapports pays basés sur Hofstede",
            "Briefings sur les cultures business locales",
            "Analyse de risques culturels",
            "Cartographie des parties prenantes clés"
          ]
        },
        {
          phase: "Formations à la communication interculturelle",
          description:
            "Workshops pratico-pratiques pour les équipes en contact direct avec des partenaires ou clients internationaux.",
          deliverables: [
            "Ateliers de communication interculturelle",
            "Guides de comportements par marché",
            "Do’s & Don’ts business",
            "Jeux de rôle & simulations"
          ]
        },
        {
          phase: "Stratégies d’entrée et de développement",
          description:
            "Co-construction de stratégies Go-to-Market adaptées aux codes locaux.",
          deliverables: [
            "Playbooks d’entrée de marché",
            "Support au sourcing de partenaires",
            "Stratégies de négociation",
            "Mise en relation avec des réseaux locaux"
          ]
        },
        {
          phase: "Construction d’équipes multiculturelles",
          description:
            "Accompagnement des équipes RH et managers pour construire et animer des équipes réellement hybrides.",
          deliverables: [
            "Recommandations sur la composition d’équipe",
            "Programmes d’onboarding interculturel",
            "Prévention des conflits",
            "Formations au Cultural Leadership"
          ]
        }
      ],
      whyUs:
        "Les malentendus culturels détruisent de la valeur – souvent de manière silencieuse. Nous vous aidons à les anticiper et à les transformer en avantage compétitif.",
      faq: [
        {
          q: "Sur quelles zones géographiques intervenez-vous principalement ?",
          a: "Principalement sur l’espace DACH et la région MENA (arabe, français, allemand). D’autres zones sont possibles sur demande."
        },
        {
          q: "En quoi cela diffère-t-il d’une formation « diversité & inclusion » ?",
          a: "Nous travaillons sur l’impact business direct : deals, partenariats, performance des équipes – pas uniquement sur la sensibilisation."
        }
      ]
    }
  ]
},

signaturePage: {
  hero: {
    badge: "Premium Signature Programs",
    titleLine1: "Signature Programs",
    titleHighlight: "Une transformation en mode « signature »",
    subtitle:
      "Des programmes structurés, bâtis sur le Resonance Flow Framework – pensés pour l’impact, la lisibilité et le retour sur investissement."
  },
  tierLabels: {
    small: "< 50 collaborateurs",
    medium: "50-250 collaborateurs",
    large: "250-1000 collaborateurs",
    enterprise: "1000+ collaborateurs"
  },
  signaturesSection: {
    titleBeforeHighlight: "Nos",
    highlight: "Signature Programs",
    subtitle:
      "Des dispositifs éprouvés, structurés et pourtant entièrement adaptables à votre réalité."
  },
  programDetails: {
    programFlowTitle: "Parcours du programme",
    deliverableLabel: "LIVRABLE :",
    includedTitle: "Prestations incluses",
    resultsTitle: "Résultats attendus",
    investmentTitle: "Investissement",
    investmentSubtitle:
      "Défini sur mesure en fonction de votre contexte et de votre périmètre",
    requestButton: "Devis sur demande",
    requestNote:
      "Recevez une proposition sur mesure adaptée à votre situation, vos enjeux et votre niveau d’ambition."
  },
  individualSection: {
    titleBeforeHighlight: "Services",
    highlight: "à la carte",
    subtitle:
      "Des services individuels en dehors d’un programme signature – à mobiliser selon vos besoins.",
    whyNoPublicPricesTitle: "Pourquoi pas de grille tarifaire publique ?",
    whyNoPublicPricesText:
      "En tant que cabinet boutique, nous construisons chaque mission en fonction de votre contexte, de votre taille et de votre gouvernance. Les niveaux d’investissement sont alignés sur vos besoins réels et le ROI attendu. Parlons d’abord de votre réalité, puis construisons une proposition cohérente."
  },
  whySection: {
    titleBeforeHighlight: "Pourquoi des",
    highlight: "Signature Programs",
    cards: [
      {
        title: "Structurés & éprouvés",
        text: "Des phases claires, des livrables concrets, une gouvernance lisible pour toutes les parties prenantes."
      },
      {
        title: "Orientés ROI",
        text: "Des dispositifs conçus pour générer un impact business mesurable – souvent 3 à 5x l’investissement sur 18 mois."
      },
      {
        title: "100% adaptables",
        text: "Un cadre solide mais jamais rigide, que nous adaptons à votre culture, vos marchés et vos équipes."
      }
    ]
  },
  cta: {
    titleBeforeHighlight: "Prêt(e) pour votre",
    highlight: "Signature Transformation",
    text:
      "Explorons ensemble quel type de programme correspond le mieux à votre organisation, à votre équipe de direction et à votre timing.",
    button: "Ouvrir un dialogue exécutif",
    dialogProgramLabel: "Dialogue exécutif (premier échange)"
  },
  signatures: [
    {
      id: "resonance-foundation",
      tier: "Entrée",
      title: "Resonance Foundation",
      subtitle: "Change Management Essentials",
      duration: "3 mois",
      description:
        "Le point d’entrée idéal pour une transformation systémique. Nous posons les fondations d’un changement durable.",
      forWhom: {
        title: "Pour qui ?",
        targets: [
          "Entreprises préparant leur première grande transformation",
          "Équipes avec un besoin de changement ciblé mais stratégique",
          "Organisations souhaitant construire leur « change readiness »",
          "PME à la recherche d’un accompagnement professionnel"
        ]
      },
      setup: {
        phase1: {
          title: "Mois 1 : Diagnostic & roadmap",
          activities: [
            "Scan de résonance TRIAX®",
            "Entretiens avec parties prenantes clés",
            "Change Readiness Assessment",
            "Co-construction de la feuille de route"
          ],
          deliverable: "Roadmap de transformation & plan de quick wins"
        },
        phase2: {
          title: "Mois 2 : Mise en œuvre",
          activities: [
            "Deux flow sprints de 2 semaines",
            "Ateliers d’alignement des parties prenantes",
            "Gestion des résistances",
            "Coaching d’équipe (2 sessions)"
          ],
          deliverable: "Premiers résultats tangibles"
        },
        phase3: {
          title: "Mois 3 : Ancrage",
          activities: [
            "Boucles de feedback",
            "Plan d’ajustement",
            "Coaching de suivi",
            "Documentation & playbook"
          ],
          deliverable: "Legacy box & rapport de clôture"
        }
      },
      included: [
        "Diagnostic de résonance TRIAX®",
        "6 séances de coaching (90 minutes)",
        "4 flow sprints avec revues",
        "Ateliers d’alignement des parties prenantes",
        "Roadmap & playbook de changement",
        "Suivi mensuel sur 3 mois",
        "Support email / téléphone"
      ],
      results: [
        "Roadmap de transformation clarifiée",
        "Adhésion des parties prenantes clés",
        "Quick wins livrés rapidement",
        "Capacité interne au changement renforcée"
      ],
      pricing: {
        small: { base: 18500, region: { dach: 18500, mena: 16500, intl: 21000 } },
        medium: { base: 32000, region: { dach: 32000, mena: 28500, intl: 36500 } },
        large: { base: 52000, region: { dach: 52000, mena: 46500, intl: 59000 } },
        enterprise: { base: 85000, region: { dach: 85000, mena: 76000, intl: 96500 } }
      }
    },
    {
      id: "resonance-accelerator",
      tier: "Professionnel",
      title: "Resonance Accelerator",
      subtitle: "Change + Leadership Development",
      duration: "6 mois",
      description:
        "Une transformation à part entière, couplée à un développement intensif du leadership – pour les organisations qui cherchent à concilier profondeur et vitesse.",
      forWhom: {
        title: "Pour qui ?",
        targets: [
          "Organisations déjà engagées dans une phase de transformation",
          "Structures présentant un gap en matière de leadership",
          "Équipes internationales (par ex. axe DACH–MENA)",
          "ETI et grands groupes en phase de scaling"
        ]
      },
      setup: {
        phase1: {
          title: "Mois 1–2 : Fondations & coalition",
          activities: [
            "Diagnostic TRIAX® complet",
            "Leadership Assessment (360°)",
            "Workshops de coalition de sponsors",
            "Design de l’architecture de transformation",
            "Coaching exécutif (2x par mois)"
          ],
          deliverable: "Architecture de transformation & plan leadership"
        },
        phase2: {
          title: "Mois 3–4 : Activation & itération",
          activities: [
            "6 flow sprints",
            "Programme de Leadership Development",
            "Coaching d’équipe hebdomadaire",
            "Gestion structurée des résistances",
            "Workshops cross-culture (si contexte MENA)"
          ],
          deliverable: "Améliorations mesurables des KPI"
        },
        phase3: {
          title: "Mois 5–6 : Harmonisation & ancrage",
          activities: [
            "Boucles de feedback & ajustements",
            "Leadership Resonanz Atelier",
            "Développement de capacités internes",
            "Accompagnement à la pérennisation"
          ],
          deliverable: "Ancrage durable & leadership renforcé"
        }
      },
      included: [
        "Tout le contenu de Foundation PLUS :",
        "Leadership Assessment (360°)",
        "12 séances de coaching exécutif",
        "6 séances de coaching d’équipe",
        "8 flow sprints avec rétrospectives",
        "Programme de développement du leadership",
        "Workshops interculturels (optionnels)",
        "Check-ins bi-hebdomadaires",
        "Support prioritaire email / téléphone",
        "Suivi post-programme sur 3 mois"
      ],
      results: [
        "Efficacité du leadership +60 %",
        "Engagement des équipes +50 %",
        "Résistance au changement −70 %",
        "Transformation ancrée de manière durable"
      ],
      pricing: {
        small: { base: 42000, region: { dach: 42000, mena: 37500, intl: 47500 } },
        medium: { base: 68000, region: { dach: 68000, mena: 61000, intl: 77000 } },
        large: { base: 115000, region: { dach: 115000, mena: 103000, intl: 130000 } },
        enterprise: { base: 185000, region: { dach: 185000, mena: 166000, intl: 210000 } }
      }
    },
    {
      id: "resonance-transformation",
      tier: "Élite",
      title: "Resonance Transformation",
      subtitle: "Full RFF – accompagnement complet",
      duration: "12 mois",
      description:
        "Le programme de transformation « élite ». Le Resonance Flow Framework dans sa version complète, pensé pour les transformations complexes et internationales.",
      forWhom: {
        title: "Pour qui ?",
        targets: [
          "Grands groupes avec plusieurs chantiers de transformation",
          "Stratégies d’expansion internationale (axe DACH–MENA)",
          "Organisations pilotant plusieurs projets de change en parallèle",
          "C-level recherchant un sparring partner stratégique à long terme"
        ]
      },
      setup: {
        phase1: {
          title: "T1 : Diagnostic, coalition & stratégie",
          activities: [
            "Analyse systémique TRIAX® approfondie",
            "Assessment & plan de développement du leadership",
            "Coalition C-level & acteurs clés",
            "Architecture complète de change incluant SCRUM4Sales",
            "Cultural Due Diligence (notamment MENA)",
            "Coaching exécutif hebdomadaire"
          ],
          deliverable: "Blueprint de transformation & roadmap leadership"
        },
        phase2: {
          title: "T2–T3 : Activation & itérations agiles",
          activities: [
            "12 flow sprints",
            "Leadership Resonanz Atelier (mensuel)",
            "Coaching d’équipe & gestion des conflits",
            "Implémentation SCRUM4Sales",
            "Formations interculturelles",
            "Boucles de feedback & ajustement continu"
          ],
          deliverable: "Impact business mesurable & KPI consolidés"
        },
        phase3: {
          title: "T4 : Harmonisation, scaling & legacy",
          activities: [
            "Extension à d’autres équipes / régions",
            "Train-the-trainer & montée en compétence interne",
            "Optimisation de la performance",
            "Documentation des playbooks & capitalisation",
            "Transition vers un ownership interne"
          ],
          deliverable: "Transformation autoportée & capitalisation formalisée"
        }
      },
      included: [
        "Tout le contenu de Accelerator PLUS :",
        "Partenaire stratégique dédié (sur 12 mois)",
        "24 séances de coaching exécutif",
        "12 séances de coaching d’équipe",
        "12 flow sprints avec rétrospectives complètes",
        "Implémentation complète de SCRUM4Sales",
        "Intercultural Business Intelligence (DACH–MENA)",
        "Leadership Resonanz Atelier (12 sessions)",
        "Programme Train-the-Trainer",
        "Support on-demand (réponse 24/48h)",
        "Suivi post-programme sur 6 mois",
        "Revue stratégique annuelle"
      ],
      results: [
        "Transformation pleinement ancrée et internalisée",
        "Capacité de leadership +80 %",
        "Expansion internationale sécurisée",
        "ROI de l’ordre de 3 à 5x l’investissement sur ~18 mois"
      ],
      pricing: {
        small: { base: 95000, region: { dach: 95000, mena: 85000, intl: 108000 } },
        medium: { base: 145000, region: { dach: 145000, mena: 130000, intl: 165000 } },
        large: { base: 240000, region: { dach: 240000, mena: 215000, intl: 272000 } },
        enterprise: { base: 380000, region: { dach: 380000, mena: 342000, intl: 432000 } }
      }
    },
    {
      id: "resonance-sos",
      tier: "Intervention de crise",
      title: "Resonance SOS",
      subtitle: "Intervention rapide en cas de crise",
      duration: "4 à 8 semaines",
      description:
        "Quand le système est en surchauffe. Une intervention ciblée pour les crises de transformation, les conflits d’équipe ou les projets en échec.",
      forWhom: {
        title: "Pour qui ?",
        targets: [
          "Organisations en crise de change ou de culture",
          "Équipes avec des conflits en escalade",
          "Projets de transformation en échec ou à l’arrêt",
          "Équipes de direction ayant besoin d’un soutien intensif et rapide"
        ]
      },
      setup: {
        phase1: {
          title: "Semaines 1–2 : Diagnostic & plan de crise",
          activities: [
            "Diagnostic rapide sous 48h",
            "Analyse de crise (acteurs, tensions, dynamiques)",
            "Plan d’actions immédiates",
            "Coaching intensif (disponibilité quasi quotidienne)"
          ],
          deliverable: "Plan de crise & quick wins"
        },
        phase2: {
          title: "Semaines 3–6 : Intervention & stabilisation",
          activities: [
            "Flow sprints intensifs (hebdomadaires)",
            "Médiation et facilitation de conflits",
            "Sparring leadership (jusqu’à 3x / semaine)",
            "Coaching d’équipe & reconstruction de la confiance",
            "Support à la stratégie de communication de crise"
          ],
          deliverable: "Stabilisation & regain de dynamique"
        },
        phase3: {
          title: "Semaines 7–8 : Transition & handover",
          activities: [
            "Plan de stabilisation à moyen terme",
            "Passation aux équipes internes",
            "Coaching de suivi",
            "Documentation & lessons learned"
          ],
          deliverable: "Handover et plan de suivi"
        }
      },
      included: [
        "Temps de réponse sous 48h",
        "Diagnostic intensif (2 jours sur site)",
        "Disponibilité quasi quotidienne (téléphone / visio)",
        "10 séances de coaching",
        "4 médiations de conflit",
        "Support communication de crise",
        "Accès prioritaire (délai de 24h)",
        "Suivi post-SOS sur 4 semaines"
      ],
      results: [
        "Crise stabilisée en 2 à 4 semaines dans la majorité des cas",
        "Conflits désamorcés",
        "Transformation remise sur les rails",
        "Capacité de décision de la direction restaurée"
      ],
      pricing: {
        small: { base: 28000, region: { dach: 28000, mena: 25000, intl: 32000 } },
        medium: { base: 45000, region: { dach: 45000, mena: 40500, intl: 51000 } },
        large: { base: 68000, region: { dach: 68000, mena: 61000, intl: 77000 } },
        enterprise: { base: 95000, region: { dach: 95000, mena: 85500, intl: 108000 } }
      }
    }
  ],
  individualServices: [
    {
      service: "Change Management systémique",
      description: "Parcours RFF complet – du diagnostic à l’ancrage",
      duration: "3 à 6 mois",
      pricing: {
        small: { base: 22000 },
        medium: { base: 38000 },
        large: { base: 62000 },
        enterprise: { base: 98000 }
      }
    },
    {
      service: "Executive Coaching",
      description: "Coaching 1:1 pour dirigeants et top managers",
      duration: "Par pack de 6 séances",
      pricing: {
        small: { base: 6500 },
        medium: { base: 6500 },
        large: { base: 8500 },
        enterprise: { base: 11500 }
      }
    },
    {
      service: "Implémentation SCRUM for Sales",
      description: "Mise en place de routines commerciales agiles",
      duration: "2 à 4 mois",
      pricing: {
        small: { base: 18000 },
        medium: { base: 28000 },
        large: { base: 45000 },
        enterprise: { base: 72000 }
      }
    },
    {
      service: "Intercultural Business Intelligence",
      description: "Expansion DACH–MENA & formations interculturelles",
      duration: "1 à 3 mois",
      pricing: {
        small: { base: 15000 },
        medium: { base: 24000 },
        large: { base: 38000 },
        enterprise: { base: 58000 }
      }
    },
    {
      service: "Team Coaching",
      description: "Développer des équipes à haute performance",
      duration: "Par pack de 4 sessions",
      pricing: {
        small: { base: 5500 },
        medium: { base: 7500 },
        large: { base: 9500 },
        enterprise: { base: 12500 }
      }
    },
    {
      service: "Workshop / formation (tarif jour)",
      description: "Workshops sur mesure, en présentiel ou à distance",
      duration: "Par jour",
      pricing: {
        small: { base: 2500 },
        medium: { base: 2500 },
        large: { base: 3500 },
        enterprise: { base: 4500 }
      }
    }
  ]
},
triaxPage: {
  hero: {
    titleBeforeHighlight: "Qu’est-ce que",
    highlight: "TRIAX®",
    suffix: " ?",
    subtitle:
      "Notre approche systémique de la transformation durable relie trois dimensions clés – structure, culture et humain – dans un modèle cohérent et actionnable."
  },
  classical: {
    title: "Approches classiques",
    text:
      "La plupart des approches de transformation se focalisent sur une seule dimension : structure, technologie ou individus. TRIAX® est né précisément pour combler ce fossé.",
    bullets: [
      { bold: "Les change managers", text: " se concentrent sur les processus" },
      { bold: "Les coaches", text: " travaillent sur les personnes" },
      {
        bold: "Les consultants en culture",
        text: " se concentrent sur les valeurs et les comportements"
      }
    ],
    footer: "→ Chacun dans son couloir, rarement dans une vue système"
  },
  triaxApproach: {
    title: "L’approche TRIAX®",
    text:
      "TRIAX® rend visible la façon dont une décision sur la structure, la culture ou le leadership résonne sur les deux autres. La transformation devient alors un design conscient du système, et non une suite de projets isolés.",
    highlight:
      "💡 Dès que vous touchez à une des trois axes, les deux autres bougent – que vous l’ayez anticipé ou non."
  },
  advantage: {
    title: "Votre avantage en tant que comité de direction",
    items: [
      {
        title: "Un modèle de référence commun",
        description:
          "Un langage précis pour parler de complexité entre DG, RH, opérations et fonctions support."
      },
      {
        title: "Une adressage systémique",
        description:
          "Les conflits, risques et opportunités sont travaillés au niveau du système, pas seulement au niveau des symptômes."
      },
      {
        title: "Un impact durable",
        description:
          "Des résultats mesurables et soutenables dans le temps, au-delà du « programme du moment »."
      }
    ]
  },
  how: {
    titleBeforeHighlight: "Comment",
    highlight: "fonctionne TRIAX®",
    subtitle:
      "Structure, culture et humain forment un seul système vivant. Lorsque vous modifiez une dimension, l’équilibre général se reconfigure. TRIAX® permet de voir et de piloter ces effets en conscience.",
    inactiveTitle: "Cliquez sur un axe",
    inactiveSubtitle:
      "Explorez ce que recouvre chaque dimension – et ce qui se passe lorsque vous changez la structure, la culture ou le leadership.",
    footnote:
      "La force du modèle TRIAX® réside dans sa lecture systémique : les trois dimensions interagissent en permanence. Toucher à l’une, c’est toujours influencer les deux autres."
  },
  axesSection: {
    examplesTitle: "Exemples :"
  },
  axes: [
    {
      id: "struktur",
      label: "Quoi ?",
      vennTitle: "Structure",
      title: "Axe Structure",
      subtitle: "Processus, méthodes & systèmes",
      description:
        "La structure définit comment le travail circule dans l’organisation. L’enjeu n’est pas d’ajouter des procédures, mais de concevoir des processus agiles, lisibles et soutenants.",
      examples: [
        "Structures organisationnelles agiles",
        "Design de processus orientés usagers",
        "Pilotage de projet et de portefeuille",
        "Feuille de route de transformation digitale"
      ]
    },
    {
      id: "kultur",
      label: "Comment ?",
      vennTitle: "Culture",
      title: "Axe Culture",
      subtitle: "Valeurs, rituels & règles informelles",
      description:
        "La culture est le système d’exploitation invisible de votre entreprise. Elle détermine la façon dont les décisions se prennent, dont les tensions se gèrent et dont l’organisation apprend.",
      examples: [
        "Principes et rituels de décision",
        "Sécurité psychologique & boucles de feedback",
        "Diagnostics de culture & heatmaps",
        "Traduction entre sous-cultures métiers ou pays"
      ]
    },
    {
      id: "mensch",
      label: "Qui ?",
      vennTitle: "Humain",
      title: "Axe Humain",
      subtitle: "Équipes, émotions & leadership",
      description:
        "Les personnes sont le cœur de tout système. Une transformation porteuse nécessite de l’intelligence émotionnelle, des équipes solides et un leadership qui crée du sens, pas seulement du contrôle.",
      examples: [
        "Renforcement des compétences émotionnelles",
        "Travail sur les dynamiques d’équipe",
        "Programmes de leadership & coaching",
        "Développement de la readiness au changement"
      ]
    }
  ],
  interactionsSection: {
    title: "Effets systémiques",
    subtitle:
      "Les trois dimensions se co-influencent en continu. Modifier l’une d’elles, c’est toujours provoquer un rééquilibrage global – qu’il soit accompagné ou subi.",
    focusLabel: "Zone de focus typique :"
  },
  interactions: [
    {
      from: "Culture",
      to: "Humain",
      title: "La culture façonne les relations",
      description:
        "L’intelligence culturelle conditionne la qualité de lien, la circulation d’information et le niveau de confiance que les équipes accordent à la direction.",
      examples: [
        "Une culture explicite renforce la confiance dans les équipes hybrides",
        "La sécurité psychologique permet un débat réel sur les sujets sensibles",
        "Les équipes interculturelles performent mieux lorsque les codes sont clarifiés"
      ],
      professionals:
        "RH, développement organisationnel, responsables de la transformation"
    },
    {
      from: "Humain",
      to: "Structure",
      title: "Les personnes stabilisent les structures",
      description:
        "Des équipes engagées et un leadership clair transforment les organigrammes et procédures en pratiques vivantes au quotidien.",
      examples: [
        "Des équipes fortes co-construisent des processus adaptés au terrain",
        "Le leadership clarifie rôles et droits à décider",
        "Les circuits de décision sont respectés plutôt que contournés"
      ],
      professionals: "Managers, chefs de projet, coaches"
    },
    {
      from: "Structure",
      to: "Culture",
      title: "Les structures influencent les comportements",
      description:
        "Les incitations, la gouvernance et les reporting lines envoient des signaux culturels puissants – parfois en contradiction avec le discours officiel.",
      examples: [
        "Des structures claires augmentent la transparence",
        "Une gouvernance perçue comme équitable renforce la confiance",
        "Des structures incohérentes nourrissent résistance et jeux politiques"
      ],
      professionals:
        "Change managers, process owners, experts en gouvernance & compliance"
    }
  ],
  professionalsSection: {
    titleBeforeHighlight: "Ce que différentes",
    highlight: "professions adressent",
    differenceText:
      "La différence avec TRIAX® : au lieu d’additionner des interventions isolées, nous intégrons structure, culture et humain dans une même feuille de route systémique."
  },
  professionals: [
    {
      id: "change-manager",
      role: "Change managers",
      focus: "Structure & processus",
      description:
        "Travaillent sur la conception et l’optimisation des processus, des structures organisationnelles et des programmes de transformation."
    },
    {
      id: "coaches",
      role: "Coaches",
      focus: "Humain & leadership",
      description:
        "Accompagnent dirigeants et équipes sur l’intelligence émotionnelle, les dynamiques relationnelles et le développement individuel."
    },
    {
      id: "triax-consultants",
      role: "Consultants TRIAX®",
      focus: "Intégration systémique",
      description:
        "Relient structure, culture et humain pour construire des transformations cohérentes et durables plutôt que des projets isolés."
    }
  ],
  benefitsSection: {
    titleBeforeHighlight: "Pourquoi",
    highlight: "TRIAX® ?"
  },
  benefits: [
    {
      id: "systemic",
      title: "Une lecture systémique",
      description:
        "Une approche globale des trois dimensions – structure, culture, humain – plutôt qu’un traitement en silos."
    },
    {
      id: "scientific",
      title: "Ancré dans la recherche",
      description:
        "Inspiré par la pensée systémique, la recherche interculturelle et des années de pratique internationale."
    },
    {
      id: "practical",
      title: "Éprouvé sur le terrain",
      description:
        "Utilisé dans des programmes de transformation complexes, au niveau COMEX et conseil d’administration."
    },
    {
      id: "sustainable",
      title: "Impact durable",
      description:
        "Pensé pour des changements de comportements et de culture qui tiennent dans le temps – pas seulement pour un kick-off."
    }
  ],
  cta: {
    titleBeforeHighlight: "Prêt(e) pour une",
    highlight: "transformation systémique",
    text:
      "Explorons ensemble ce que TRIAX® pourrait apporter à votre organisation – dans un dialogue exigeant, lucide et sans marketing creux.",
    button: "Initier une conversation TRIAX®"
  }
},
sosPage: {
  hero: {
    badge: "Réponse d’urgence stratégique",
    highlight: "SOS",
    titleLine: "Quand 48 heures pèsent sur les prochains mois",
    subtitle:
      "Pour les situations qui ne supportent aucun délai : gestion de crise, support de négociation et transformation sous forte pression temporelle.",
    bullets: [
      "Réponse immédiate",
      "Gestion de crise",
      "Intervention ciblée"
    ]
  },
  packagesSection: {
    title: "Offres",
    highlight: "SOS",
    subtitle:
      "Trois dispositifs d’urgence éprouvés pour différents scénarios critiques.",
    footnote:
      "*La durée peut varier en fonction de la taille des équipes"
  },
  labels: {
    urgent: "URGENT"
  },
  packages: [
    {
      id: "culturebridge",
      title: "CultureBridge MENA",
      badge: "Réponse en 24h",
      duration:
        "1 jour de formation + 3 semaines de coaching + 1 guide culturel",
      description:
        "Pour les entreprises DACH qui se préparent à travailler avec des partenaires arabes.",
      features: [
        "Do’s & Don’ts interculturels + décryptage des modes de pensée",
        "Étiquette business, styles de communication, culture de négociation",
        "Préparation très concrète aux réunions et négociations",
        "Guide culturel pour sécuriser la performance dans la durée"
      ]
    },
    {
      id: "scrum4sales",
      title: "Scrum4Sales Sprint",
      badge: "Réponse en 48h",
      duration:
        "12 semaines de coaching agile & accompagnement terrain",
      description: "Pour des équipes commerciales en pleine mutation.",
      features: [
        "Mise en place de rythmes sales agiles (planning, review, rétro)",
        "Travail sur la culture & l’architecture des responsabilités",
        "Alignement d’équipe et outils de transparence",
        "Optimisation continue des processus commerciaux"
      ]
    },
    {
      id: "change-sparring-6",
      title: "Change Sparring 6",
      badge: "Créneau garanti sous 24h",
      duration: "6 mois d’accompagnement 1:1",
      description:
        "Pour des dirigeant·e·s en phase de transformation critique.",
      features: [
        "Analyse systémique, roadmap et clarification des rôles",
        "Navigation des conflits & espaces de résonance",
        "Sessions de sparring hebdomadaires",
        "Support d’urgence en cas de situation critique"
      ]
    }
  ],
  actions: {
    requestSOS: "Demander un SOS maintenant"
  },
  resultsSection: {
    titleBeforeHighlight: "Des résultats",
    highlight: "prouvés",
    subtitle:
      "Nos offres SOS génèrent des résultats mesurables en un temps record."
  },
  results: [
    { id: "productivity", metric: "+40%", label: "productivité" },
    { id: "revenue", metric: "+35%", label: "chiffre d’affaires" },
    { id: "delays", metric: "-50%", label: "retards" },
    {
      id: "decisions",
      metric: "+60%",
      label: "meilleure qualité de décision"
    }
  ],
  process: {
    titleBeforeHighlight: "Comment fonctionne",
    highlight: "SOS",
    steps: [
      {
        title: "Contact immédiat",
        text:
          "Un appel ou un e-mail suffit. Nous revenons vers vous sous 24–48h."
      },
      {
        title: "Analyse rapide",
        text:
          "Un assessment court de la situation et des recommandations prioritaires."
      },
      {
        title: "Mise en œuvre immédiate",
        text:
          "Démarrage direct de l’intervention avec des méthodes SOS éprouvées."
      }
    ]
  },
  contact: {
    titleBeforeHighlight: "Votre situation est",
    highlight: "critique",
    text:
      "Ne tardez pas. Chaque heure compte. Nos expert·e·s SOS sont prêts à vous accompagner immédiatement.",
    bullets: [
      "Disponibilité 24/7",
      "Experts rôdés à la crise",
      "Impact immédiat"
    ],
    hotlineButton: "Hotline d’urgence : +49 xxx xxx xxx",
    emailButton: "E-mail : sos@globalegroupe.de"
  }
},
contactPage: {
  hero: {
    highlight: "La transformation",
    titleRest: "ne commence pas par un kick-off",
    subtitle: "Elle commence par une conversation honnête.",
    bullets: ["Réponse sous 24h", "Confidentiel", "Personnalisé"]
  },
  form: {
    titleBeforeHighlight: "Parlons-en",
    highlight: "ensemble",
    nameLabel: "Nom",
    namePlaceholder: "Votre nom",
    companyLabel: "Entreprise",
    companyPlaceholder: "Votre entreprise",
    emailLabel: "E-mail",
    emailPlaceholder: "votre@email.com",
    phoneLabel: "Téléphone",
    phonePlaceholder: "+33 x xx xx xx xx",
    topicLabel: "Choisissez un sujet",
    topicPlaceholder: "Veuillez sélectionner",
    messageLabel: "Votre message",
    messagePlaceholder:
      "Parlez-nous du contexte, de vos enjeux, de vos questions...",
    submitLabel: "Envoyer le message",
    footerText:
      "Nous revenons vers vous sous 24 heures. Vos informations sont traitées de manière confidentielle.",
    topics: [
      "Transformation TRIAX®",
      "Demande de package SOS",
      "Solution Signature",
      "Conseil interculturel",
      "Coaching de leadership",
      "Premier échange",
      "Autre sujet"
    ]
  },
  contactInfo: {
    titleBeforeHighlight: "Contacts",
    highlight: "directs",
    emailLabel: "E-mail",
    email: "hello@globalegroupe.com",
    linkedinLabel: "LinkedIn",
    linkedin: "linkedin.com/company/globalegroupe",
    hotlineLabel: "Hotline SOS",
    hotlineNumber: "+49 xxx xxx xxx",
    hotlineNote: "Pour les situations urgentes"
  },
  why: {
    title: "Pourquoi GloBridge ?",
    bullets: [
      "Première lecture de la situation sous 24 heures",
      "Premier entretien gratuit (30 minutes)",
      "Traitement strictement confidentiel de vos informations",
      "Recommandations concrètes plutôt que théorie abstraite"
    ]
  },
  locations: {
    titleBeforeHighlight: "Nos",
    highlight: "implantations",
    subtitle: "DACH · Afrique · Pays du Golfe – là où vous avez besoin de nous"
  },
  offices: [
    {
      region: "DACH",
      city: "Francfort-sur-le-Main",
      address: "Bockenheimer Landstraße 123, 60325 Francfort",
      phone: "+49 69 123 456 789",
      email: "dach@globalegroupe.com",
      gradient: "from-purple-600 to-blue-600"
    },
    {
      region: "MENA",
      city: "Dubaï",
      address: "DIFC, Gate Village 10, Level 5, Dubai",
      phone: "+971 4 123 456 789",
      email: "mena@globalegroupe.com",
      gradient: "from-orange-500 to-red-500"
    },
    {
      region: "Afrique du Nord",
      city: "Casablanca",
      address: "Twin Center, Tour A, Angle Boulevards",
      phone: "+212 522 123 456",
      email: "africa@globalegroupe.com",
      gradient: "from-emerald-500 to-teal-600"
    }
  ],
  finalCTA: {
    titleBeforeHighlight: "Prêt·e à faire",
    highlight: "le premier pas",
    text:
      "La transformation commence par une conversation. Explorons ensemble comment mettre votre organisation en résonance.",
    primaryButton: "Planifier un rendez-vous",
    secondaryButton: "Premier échange gratuit"
  }
},
insightsPage: {
  hero: {
    chipLabel: "Histoires de réussite & insights",
    titleHighlight: "Insights",
    titleRest: "Apprendre à partir du terrain",
    subtitle:
      "Des projets réels, des résultats mesurables, des témoignages authentiques. Découvrez comment TRIAX® et nos solutions Signature transforment les organisations."
  },
  tabs: {
    successStories: "Histoires de réussite",
    caseStudies: "Études de cas",
    blogPlanned: "Blog (à venir)"
  },
  labels: {
    challenge: "Défi",
    solution: "Solution",
    results: "Résultats chiffrés"
  },
  metrics: {
    timeline: "Timeline",
    roi: "ROI",
    satisfaction: "Satisfaction"
  },
  caseStudies: [
    {
      title: "Résoudre un blocage interculturel",
      category: "CultureBridge MENA",
      duration: "3 mois",
      challenge:
        "Un équipementier automobile allemand échouait à se développer dans la région MENA à cause de barrières culturelles et de malentendus répétés.",
      solution:
        "Analyse culturelle basée sur TRIAX® et programme CultureBridge sur mesure.",
      results: [
        "150% d’augmentation du chiffre d’affaires dans la région MENA",
        "85% de ruptures de négociation en moins",
        "Partenariats conclus avec 3 distributeurs locaux"
      ],
      quote:
        "\"CultureBridge n’a pas seulement sauvé notre business, cela nous a ouvert toute une région.\"",
      author: "CEO, équipementier automobile (DAX)",
      metrics: {
        timeline: "6 mois",
        roi: "400%",
        satisfaction: "9,8/10"
      },
      image:
        "https://images.unsplash.com/photo-1552084850-c6a1fc7cf717?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzU2MjQ4MzUzfDA&ixlib=rb-4.1.0&q=85"
    },
    {
      title: "Relancer une réorganisation bloquée",
      category: "Change Sparring 6",
      duration: "6 mois",
      challenge:
        "Une réorganisation dans une fintech a entraîné résistances, tensions et baisse visible de productivité.",
      solution:
        "Change Sparring structuré avec la méthode TRIAX® pour l’équipe de direction.",
      results: [
        "60% d’augmentation de l’engagement des collaborateurs",
        "40% de réduction du turnover",
        "Réorganisation menée à son terme avec succès"
      ],
      quote:
        "\"Sans le Change Sparring, nous n’y serions pas arrivés. Cet accompagnement a été la clé du succès.\"",
      author: "Managing Director, FinTech",
      metrics: {
        timeline: "6 mois",
        roi: "250%",
        satisfaction: "9,5/10"
      },
      image:
        "https://images.unsplash.com/photo-1675392347224-ae88c11def9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85"
    },
    {
      title: "Un collectif commercial agile – et performant",
      category: "Scrum4Sales Sprint",
      duration: "12 semaines",
      challenge:
        "Une force de vente B2B très classique, avec des cycles de vente longs et une performance d’équipe limitée.",
      solution:
        "Mise en place de Scrum4Sales avec rythmes agiles, transparence et sprints structurés.",
      results: [
        "45% de réduction de la durée des cycles de vente",
        "70% d’augmentation du taux de closing",
        "80% de gain de productivité au niveau de l’équipe"
      ],
      quote:
        "\"Scrum4Sales a transformé notre approche commerciale. Nous travaillons enfin comme une vraie équipe.\"",
      author: "Head of Sales, logiciel B2B",
      metrics: {
        timeline: "3 mois",
        roi: "320%",
        satisfaction: "9,7/10"
      },
      image:
        "https://images.unsplash.com/photo-1743842768257-e897326cd11e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGx1eHVyeXxlbnwwfHx8fDE3NTYyNDgyOTN8MA&ixlib=rb-4.1.0&q=85"
    }
  ],
  summary: {
    titleBeforeHighlight: "Résultats",
    highlight: "consolidés",
    stats: [
      {
        metric: "50+",
        label: "Projets menés avec succès"
      },
      {
        metric: "95%",
        label: "Taux de satisfaction clients"
      },
      {
        metric: "300%",
        label: "ROI moyen"
      },
      {
        metric: "15",
        label: "Pays & marchés"
      }
    ]
  },
  yourStory: {
    titleBeforeHighlight: "Envie d’écrire",
    highlight: "votre propre success story",
    text:
      "Ces résultats ne doivent rien au hasard. Ils sont le fruit d’un travail systémique avec TRIAX® et nos solutions Signature. Co-construisons ensemble votre prochaine histoire de réussite.",
    tiles: [
      {
        title: "Éprouvé",
        text: "Plus de 50 transformations réussies."
      },
      {
        title: "Mesurable",
        text: "En moyenne 300% de retour sur investissement."
      },
      {
        title: "Durable",
        text: "95% de satisfaction client à long terme."
      }
    ],
    buttonLabel: "Commencer votre histoire"
  }
},
markets: {
  badgeLabel: 'Global excellence',
  titleBeforeHighlight: 'Marchés &',
  highlight: 'secteurs',
  description:
    'Nous accompagnons des organisations sur des marchés où nous connaissons intimement les codes culturels, les dynamiques décisionnelles et les logiques business.',
  connectionText:
    'Notre présence globale crée des ponts interculturels sans rupture.',
  regions: [
    {
      name: 'DACH',
      countries: ['Allemagne', 'Autriche', 'Suisse'],
      image:
        'https://images.unsplash.com/photo-1617375402484-8a196422d93d?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      monument: 'Berlin Cathedral - architecture allemande',
      specialty: 'Précision & efficacité',
      gradient: 'from-slate-600 to-blue-600',
      description: "Le cœur de l’excellence business européenne."
    },
    {
      name: 'Moyen-Orient',
      countries: ['Émirats arabes unis', 'Arabie saoudite', 'Qatar'],
      image:
        'https://images.unsplash.com/photo-1653763843954-0ad7300268a6?q=80&w=435&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      monument: 'Emirates Towers & Museum of the Future',
      specialty: 'Partenariat & confiance',
      gradient: 'from-orange-500 to-amber-500',
      description: "Là où la tradition rencontre l’innovation."
    },
    {
      name: 'Afrique du Nord',
      countries: ['Maroc', 'Tunisie', 'Égypte'],
      image:
        'https://images.unsplash.com/photo-1699210260021-eac11ba4ff86?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      monument: 'Mosquée Hassan II - Casablanca',
      specialty: 'Tradition & innovation',
      gradient: 'from-emerald-600 to-teal-600',
      description: 'Un pont culturel entre les continents.'
    }
  ]
},
expertise: {
  badgeElite: "Services d’élite",
  title: "Notre",
  titleHighlight: "Signature-Expertise",
  description:
    "GLOBRIDGE réunit conduite du changement systémique, intelligence culturelle et sparring exécutif dans des formats premium soigneusement conçus.",
  subDescription:
    "Quatre services Signature, un objectif : une transformation profonde et mesurable, loin du feu d’artifice PowerPoint.",

  services: [
    {
      id: "change-management",
      iconName: "Zap",
      background:
        "https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-purple-600 to-blue-600",
      title: "Change Management systémique",
      subtitle: "Resonance Flow Framework",
      description:
        "Accompagnement end-to-end de transformations complexes – du diagnostic à l’ancrage durable.",
      features: [
        "Diagnostic TRIAX® des dimensions culture, structure et humain",
        "Resonance Flow Framework en 5 phases",
        "Sparring C-Level et alignement des parties prenantes",
        "Livrables et KPIs clairement définis à chaque phase"
      ],
      href: "/services",
      cta: "Découvrir notre approche du change"
    },
    {
      id: "leadership-coaching",
      iconName: "Users",
      background:
        "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-emerald-500 to-teal-600",
      title: "Leadership & Executive Coaching",
      subtitle: "Résonance pour C-Level",
      description:
        "Sparring pour décideurs en phases de transformation complexes.",
      features: [
        "Coaching exécutif 1:1 pour C-Level et hauts potentiels",
        "Développement du leadership en phases de transformation",
        "Résilience, puissance de décision, clarté",
        "Sparrings confidentiels, d’égal à égal"
      ],
      href: "/services",
      cta: "Renforcer le leadership"
    },
    {
      id: "scrum4sales",
      iconName: "Target",
      background:
        "https://images.unsplash.com/photo-1556740749-887f6717d7e4?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-orange-500 to-red-500",
      title: "Scrum4Sales Sprint",
      subtitle: "Ventes agiles",
      description:
        "Nous rendons les équipes commerciales rapides, adaptatives et pilotées par la donnée.",
      features: [
        "Rythmes agiles pour les équipes commerciales (sprints, reviews, retros)",
        "Pipeline transparente et priorisation partagée",
        "Décisions pilotées par les données plutôt que par l’instinct",
        "Enablement pour des équipes responsables et autonomes"
      ],
      href: "/services",
      cta: "Découvrir Scrum4Sales"
    },
    {
      id: "culturebridge-mena",
      iconName: "Star",
      background:
        "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1200&q=80",
      gradient: "from-violet-500 to-purple-600",
      title: "CultureBridge MENA",
      subtitle: "Intelligence business interculturelle",
      description:
        "Pont DACH–MENA pour expansion, deals critiques et joint-ventures.",
      features: [
        "Préparation ciblée aux contextes business DACH–MENA",
        "Do’s & Don’ts, codes de négociation et logiques de décision",
        "Accompagnement sur les deals critiques et les partenariats stratégiques",
        "Culture handbook et playbooks opérationnels pour votre équipe"
      ],
      href: "/sos",
      cta: "Découvrir CultureBridge"
    }
  ],

  dna: {
    badge: "ADN GLOBRIDGE",
    titleBeforeHighlight: "Ce qui fait de nous",
    titleHighlight: "l’élite 1 %",
    titleAfterHighlight: "du marché",
    description:
      "Quatre piliers d’excellence composent notre système TRIAX® – systémique, culturellement intelligent et orienté impact mesurable.",

    systemicDepth: {
      title: "Profondeur systémique",
      line1: "Nous transformons les systèmes,",
      line2: "pas seulement les symptômes.",
      chip: "Méthodologie TRIAX®"
    },
    culturalIntelligence: {
      title: "Intelligence culturelle",
      line1: "Nous traduisons entre",
      line2: "les cultures et les marchés.",
      chip: "DACH × MENA"
    },
    humanResonance: {
      title: "Résonance humaine",
      line1: "Nous créons des connexions",
      line2: "émotionnelles, pas seulement des stratégies.",
      chip: "Resonance Leadership"
    },
    measurableImpact: {
      title: "Impact mesurable",
      line1: "Nous garantissons des résultats",
      line2: "vérifiables et un ROI tangible.",
      chip: "Preuve de performance"
    }
  },

  cta: {
    questionBeforeHighlight: "Prêt·e pour une transformation au",
    highlight: "niveau d’élite 1 %",
    button: "Planifier un conseil exécutif"
  }
},

readiness: {
  title: 'Transformation Readiness Check',
  subtitle:
    "Évaluez à quel point votre organisation est réellement prête au changement.",

  scoreLabel: 'Niveau de préparation',

  levelHigh: 'Élevé',
  levelMedium: 'Moyen',
  levelLow: 'Faible',

  messageHigh:
    'Votre organisation est prête. Focus sur l’optimisation, la mise à l’échelle et les bons leviers.',
  messageMedium:
    'Les bases sont là. Nous recommandons des interventions ciblées en coaching et change management.',
  messageLow:
    'Un accompagnement intensif est recommandé. Nous commençons par un diagnostic de résonance et une feuille de route claire.',

  questions: {
    vision: {
      question: 'À quel point la vision de transformation est-elle claire dans vos équipes ?',
      options: {
        veryClear: 'Très claire',
        partlyClear: 'Plutôt claire',
        unclear: 'Peu claire',
        noVision: 'Pas de vision'
      }
    },
    resistance: {
      question: 'Quel est le niveau de résistance au changement ?',
      options: {
        veryLow: 'Très faible',
        moderate: 'Modéré',
        high: 'Élevé',
        veryHigh: 'Très élevé'
      }
    },
    culture: {
      question:
        'Rencontrez-vous des défis culturels (par ex. DACH–MENA, équipes internationales) ?',
      options: {
        none: 'Non',
        few: 'Peu',
        some: 'Quelques-uns',
        many: 'Beaucoup'
      }
    },
    salesAgility: {
      question: 'À quel point votre équipe commerciale travaille-t-elle en mode agile ?',
      options: {
        veryAgile: 'Très agile',
        partlyAgile: 'Partiellement agile',
        traditional: 'Plutôt traditionnelle',
        rigid: 'Rigide'
      }
    }
  }
},

    footer: {
      claim: "Conseil d'espace de résonance – Où le changement fonctionne. Et ne ressemble pas seulement au travail.",
      rights: "© 2024 GLOBRIDGE. Tous droits réservés.",
      privacy: "Politique de confidentialité",
      imprint: "Mentions légales"
    }
  }
};